import React, { useState, useRef, useCallback, useEffect } from "react";
import styles from "./add-edit-product-omni.scss";
import flagStyles from "../add-edit-product/countrySlider/country-flags.scss";
import SliderHeader from "jd-library/SliderHeader";
import ButtonGroup from "jd-library/ButtonGroup";
import historyHandler from "jd-library/historyHandler";
import AnimateOnHover from "jd-library/AnimateOnHover";
import ToggleBtnGroup from "jd-library/ToggleBtnGroup";
import Loader from "jd-library/Loader";
import { useHistory, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import InputWithMovingLabel from "jd-library/InputWithMovingLabel";
import {
  updateEditProductDetail,
  saveAddEditProduct,
  auditorRejection,
  discardAddProductMedia,
  resetProductData,
  hideProductEditSlider,
  getBizList,
  updateBizList,
  updateProductMedia,
  deleteProductImage,
  deleteProductVideo,
  toggleBiz,
  updateProductStatus,
  getListingData,
  setAuditObject,
  restoreProductData,
  updateDeletionPending,
  updateApprovalPending,
  setTabStatus,
  updateBrandedProduct,
  fetchCountryCode,
  showItemSearchSlider,
  setBrandSuggestion,
  setHybridData,
  updateProductsWithSmartFill,
  getAuditProductUpdateLog,
  addRemoveSpecVariant,
  getProductSmartFillSpec,
  setFromSeller,
  setShouldRetainScroll,
  addUpdateFixedSpecs,
  filterQuery,
  toggleAddProductSlider,
  updateDescType,
  getPsvDetails,
} from "../../actions/products";
import ProductFileAttachment from "../add-edit-product/ProductFileAttachment";
// import { showToastMessage } from '../../actions/toastmessage';
import toastMessageActions from "jd-library/toastMessageActions";
import ViewImage from "../../common/ViewImage/ViewImage";
import Button from "../../common/Button/Button";
import Switch from "../../common/switch/Switch";
import UOMSliderWrapper from "../add-edit-product/UOMSliderWrapper";
import CategorySearchSlider from "../add-edit-product/CategorySearchSlider";
import {
  getMatchedUOM,
  fetchAuditUrl,
  skipProduct,
  checkForCameraPermissions,
  isProductNameValid,
  identifyAuditFlow,
  formatProdDesc,
  setRouteChangeMessage,
  deleteObjectionableProduct,
  getAuditTagValues,
  scrollIntoView,
  Regex,
  getBusinessTypes,
  universalClose,
  discountCalculator,
  generateBarcode,
  enforceStrictASCII
} from "../../utills";
import { getDescriptionData } from "../../common/description-Ai-modals/utils.js";
import { getAllSpecificationData } from "../../pages/add-edit-product/c-specification-slider/customActions";
import BusinessType from "../business-type/BusinessType";
import ProductSpecification from "../add-edit-product/ProductSpecification";
import VideoListing from "../listing/VideoListing";
import UploadOptions from "../../common/upload-options/UploadOptions";
import LinkUploadSlider from "../../common/link-upload-slider/LinkUploadSlider";
import { toggleLibrarySlider } from "../../actions/videoLibrary";
import FormElement from "../add-edit-product/FormElement";
import Modal from "jd-library/Modal";
import SwipeableDrawer from "jd-library/SwipeableDrawer";
import JdRepresentativeHeader from "../add-edit-product/JdRepresentativeHeader";
import ViewImageSlider from "../../common/ViewImage/ViewImageSlider";
import JustdialCatModal from "../add-edit-product/JustdialCatModal";
import SliderWrapper from "jd-library/SliderWrapper";
import SkuField from "../add-edit-product/sku/SkuField";
import UnitCount from "../add-edit-product/unit-Count/UnitCount"
import axios from "axios";
import ProductSynonyms from '../product-synonyms/ProductSynonyms';
const priceRegex = /^\d{0,10}(\.\d{0,2})?$/;
const actualProductWeightRegex = /^\d{0,10}(\.\d{0,3})?$/;
const numberRegex = /^\d{0,8}$/;
const commissionRegex = {
  inputField: /^\d{0,3}(\.\d{0,2})?$/,
  validation: /^\d{0,2}(\.\d{0,2})?$/,
};
const productDimensions = {
  inputField: /^\d{0,10}(\.\d{0,2})?$/,
};
// const actualProductWeightRegex = /^\d{0,10}(\.\d{0,2})?$/;
const minQtyRegex = /^\d{0,8}$/;
export const otherThanEnglish = /[^\x00-\x7F]/g;
import useOnScroll from "jd-library/useOnScroll";
import { getContent } from "jd-library/Clipboard";
import ObjectionalNotify from "../add-edit-product/ObjectionalNotify";
import BuyOnlineUrlModal from "../add-edit-product/BuyOnlineUrlModal";
import Popover from "jd-library/Popover";
import CommissionModal from "../listing/CommissionModal";
import CountrySliderList from "../add-edit-product/countrySlider/CountrySlider";
import PriceRangeQty from "../add-edit-product/price-range-qty/PriceRangeQty";
import InventoryBatches from "../InventoryBatches/InventoryBatches";
import ItemSearchSlider from "../add-edit-product/ItemSearchSlider";
import {
  fetchSpecificationAttributes,
  resetSpecificationFormData,
  resetSpecErrors
} from "../../actions/productSpecification";
import ManageTaxesHOC from "../add-edit-product/manage-taxes/ManageTaxes";
import TaxSlider from "../../common/TaxModule/TaxSlider";
import InputWithAutosuggestSlider from "../add-edit-product/c-specification-slider/components/textboxAutosuggestContainer/index";
import FixBoxContainer from "../add-edit-product/c-specification-slider/components/fixedboxContainer/index";
import ManufacturerDetails from "../add-edit-product/c-specification-slider/components/manufacturerDetails/index";
import ImporterDetails from "../add-edit-product/c-specification-slider/components/importerDetails/index";
import { DocReqModel } from "../add-edit-product/DocReqModel";
import {
  updateBrandManufactureDetails,
  updateSpecificationData,
  resetBrandManufactureData,
  checkAndReset,
  convertRetainSpecs
} from "../../actions/productSpecification";
import AddVariantWelcome from "../add-edit-product/variant/AddVariantWelcome";
import AddVariantOptions from "../add-edit-product/variant/AddVariantOptions";
import VariantOptions from "../add-edit-product/variant/VariantOptions";
import VariantDetails from "../add-edit-product/variant/VariantDetails";
import VariantMoreDetails from "../add-edit-product/variant/VariantMoreDetails";
import VariantSection from "../add-edit-product/variant/VariantSection";
import {
  resetVariantData,
  validateVariants,
  validateVariantsService,
  setVariantProductData,
  setVariantData
} from "../../actions/variants";
import TransactionModal from "../add-edit-product/VariantModals/TransactionModal";
import ComplianceFieldModal from "../add-edit-product/c-specification-slider/components/complianceFieldsModal/ComplianceFieldModal";
import ProductChangeModal from "../add-edit-product/VariantModals/ProductChangeModal";
import CopyImagesSlider from "../../common/UploadOptions/CopyImages/CopyImagesSlider";
import { pageLoad, pageLoadForIos } from "../../common/Utills";
import { scanBarcode, checkAtleastOneThirdLvlCheckBox } from '../add-edit-product/appUtils/AppUtils'
import StatusMessages from "../add-edit-product/status-messages/StatusMessages";
import ProductExpiry from "../add-edit-product/ProductExpiry/ProductExpiry";
import SellingPriceModal from "../add-edit-product/SellingPriceModal";
import { getImagePath } from "../../common/productImageUtils";
import useMRPInputField from "../../common/UpdateMRP/MRPInputFileld/singleMRP";
import ActionModal from "../../common/action-modal/ActionModal";
import DisputeImages from "../order/order-return/raise-return-claim/disputeImagesFlow/DisputeImages";
import ImageZoom from "../add-edit-product/image-zoom/ImageZoom";
import AddInventoryBatch from "../InventoryBatches/AddInventoryBatch";
import { getAllJdCatCoverData } from "../../actions/jdCategoryCover";
import PackagingLabel from "../add-edit-product/c-specification-slider/components/packagingLabel/PackagingLabel";
import ProductBankFields from '../../common/ProductBankFields';
import Dropdown from "jd-library/Dropdown";
import ProgressSvgComponent from "../add-edit-product/progressSvgComponent/ProgressSvgComponent";
import { NudgePrice } from "../add-edit-product/progressSvgComponent/ProgressSvg.components.utils";
import { SpecificDurationDropDown } from "../add-edit-product/StaticData";
import ServiceSwitch from "../add-edit-product/ServiceSwitch";
import ItemInfoContainer from "../add-edit-item/component-groups/ItemInfoContainer";
import FormSwitch from "jd-library/FormSwitch";
import EnquiryDeliveryStockContainer from "./GroupingContainers/EnquiryDeliveryStockContainer";
import SizeChartSlider from "./SizeChartSlider";
import ShowUploadLibraryImage from '../../common/UploadOptions/UploadLibraryImages/UploadLibraryImage';
import ValidationModal from "../../common/description-Ai-modals/ValidationModal";
import MagicWind from "../../common/Listing/Icons/MagicWind";
import { withPortal } from "jd-library";
import AISuggestedSpex from "../add-edit-product/AISuggestedSpex";
import { fetchAiSpecSuggestions } from "../add-edit-product/product-specification/productSpecifications.utils";
import CorrectnessModel from "../add-edit-product/CorrectnessModel";


const redirectApiFail = (options = {}) => {
  let { props, history } = options;
  let isAuditUrl = false;
  const flowCheck = identifyAuditFlow({ checkType: true });
  if (flowCheck.fetchNextAudit) {
    isAuditUrl = true;
  }
  const isAuditor =
    props.session.user.loggedUser &&
    props.session.user.loggedUser.userType == "AUDITOR" &&
    isAuditUrl
      ? true
      : false;
  if (isAuditor) {
    history.push("/login");
  }
};

const saveAuditMrpComplianceBatch = ({
	token = '',
	productId = '',
	mrp = '',
	sellingPrice = '',
	consignmentNo = '',
	disposition = '',
	rejectedReason = '',
	parentId = ''
},cb) => {
	let url = `/marketplace/static/php/web/b2bWebsite.php?action=updateAuditMrpDetails`;
  let formData = new FormData();
  formData.append("token",token);
  formData.append("productId",productId);
  formData.append("mrp",mrp);
  formData.append("consignmentNo",consignmentNo);
  formData.append("sellingPrice",sellingPrice);
  formData.append("disposition",disposition);
  formData.append("rejectReason",rejectedReason);
  formData.append("parentId",parentId);

	axios.post(url, formData)
  .then((res)=>{
    console.log(res);
    cb && cb(res);
  }).catch((err)=>console.log(err,"auditor mrp batch error"));
};

const contractorTypes = ["CONTRACTORV2", "CONTRACTORV3"];

const packagedContractorAllow = ["CONTRACTOR", "CONTRACTORV2"];

const AddEditProductOmni = (props) => {
  const dispatch = useDispatch();
const PortalUploadOptions = withPortal((props) => {
  return <UploadOptions
          onUploadOptionClick={(value) => {
            if (value === "jdGallery") {
              dontResetEditProduct.current = true;
            }
          }}
          categoryType={!isAddProduct ? productData.categoryType : null}
        />
})
  const productData = props.productData;
  const priceObj = productData.priceObj || {};
  let history = useHistory();
  const [productInitialMrp,setProductInitialMrp]=useState(undefined)
  const [listingDataLength, setListingDataLength] = useState(0)
  const [descCount,updateCount] = useState(productData?.description?.length ? (productData.description.length > 8000 ? 8000 : productData.description.length) : 0);
  const [aiSpecBypass,updateAISpecByPass] = useState(false);
  const [showInputPlaceHolder, setShowInputPlaceHolder] = useState(false);
  const [maxSupplyCapacity, setMaxSupplyCapacity] = useState(productData?.maxSupplyCapacity || priceObj?.maxSupplyCapacity || '');
  const [supplyTimePeriod, setSupplyTimePeriod] = useState(productData?.supplyTimePeriod || priceObj?.supplyTimePeriod || '');
  const [aiSpecsShown,updateAiSpecsShown] = useState(false);
  const [showValidationModal,toggleValidationModal] = useState({
    show: false
  });
  const [reTryAI, setReTryAI] = useState(false)
  let dateOptions = [{
      label: 'Day',
      key: 'day'
  }, {
      label: 'Week',
      key: 'week'
  }, {
      label: 'Month',
      key: 'month'
  }, {
      label: 'Quarter',
      key: 'quarter'
  }, {
      label: 'Year',
      key: 'year'
  }];
  useEffect(() => {
    if(productData?.productId && productInitialMrp==undefined){
      setProductInitialMrp(productData?.mrp)
    }
  }, [productData?.mrp])


  if (productData.error) {
    useEffect(() => {
      redirectApiFail({
        props,
        history,
      });
      checkForCameraPermissions();
    }, []);
    return null;
  }

  const isTemplate = productData.isTemplate;
  const isIPhone = props.deviceData.isIphone || props.isJdSourceIOS;
  let selectTypeQuery = identifyAuditFlow({ query: true });
  const isAddProduct = productData.productId == "ADD_PRODUCT" || selectTypeQuery.isTemp;
  const isEditProduct = productData.productId != "ADD_PRODUCT";
  const fromSellerRejected = selectTypeQuery.fromSellerRejected === "true";
  const fromPhotos = selectTypeQuery.fromPhotos;
  const isProductOnlyProfile = props.session?.newProfile;
  const showUOMFields = productData.contentPerPiece && productData.unitPerPiece; //(productData.minOrderQuantity && productData.unitOfMeasurement) ||
  const [errors, updateError] = useState({
    name: "",
  });
  const savedUOM = useRef(props.unitOfMeasurement);
  const prevKeywordId = useRef(props.productData?.keywordId);
  const commissionRef = useRef(null);
  const [savedUOMTYPE, _] = useState(props.unitOfMeasurement.uomType);
  const [catSliderShown, updateCatSliderVisibility] = useState(false);
  const [showBarcodeField, toggleBarcodeField] = useState(false);
  const [showSOFields, toggleShowSOFields] = useState(false);
  const labelImages =productData.labelImageUrl ? productData.labelImageUrl?.split(",") : [];
  const labelFrontImages = productData.labelFrontImageUrl ? productData.labelFrontImageUrl?.split(","): [];
  const [subText,setSubText] = useState("Enter Product Dimensions to Determine Applicable Delivery Charge");
  const [volumetricWeightType, setVolumetricWeightType] = useState(null);
  const [proofImages, setProofImagesList] = useState(labelImages?.length ? labelImages.map(cur => ({
    loading: false,
    key: '',
    url: cur,
    finalUrl: cur
  })) : []);
  const [labelFront,setFrontImage] = useState(labelFrontImages?.length ? labelFrontImages.map(cur => ({
    loading: false,
    key: '',
    url: cur,
    finalUrl: cur
  })) : []);
  const [showSearch, toggleSearch] = useState(
    props.productData.productId == "ADD_PRODUCT"
  );
  const [fieldsSet, updateStatus] = useState(false);
  const [scrollEl, setScrollEl] = useState(null);
  const [moreFieldsShown, updateMoreFields] = useState(() => {
    if (showUOMFields) {
      return true;
    }
    const attributes = productData.attributes || [];
    for (let i = 0; i < attributes.length; i++) {
      if (attributes[i].values && attributes[i].values.length) {
        return true;
      }
    }
    const customAttrs = productData.customAttrs;
    if (!customAttrs || !customAttrs.length) {
      return false;
    }

    return !!(customAttrs[0].name && customAttrs[0].value);
  });
  const [saveBtnShown, showHideShowBtn] = useState(true);
  const isOwner =
    props.session.user.loggedUser &&
    props.session.user.loggedUser.userType == "OWNER"
      ? true
      : false;
  let isAuditUrl = false;
  let auditFromPage = false;
  const flowCheck = identifyAuditFlow({ checkType: true });
  if (flowCheck.fetchNextAudit) {
    isAuditUrl = true;
  }
  if (flowCheck.searchAudit) {
    auditFromPage = true;
  }
  const isBrandedProduct =
    productData && productData.isBrandedProd ? true : false;
  const isTempProd = productData && productData.isTempProd ? true : false;
  let auditHomePath = "/audit-home";
  if (typeof window !== "undefined" && window.top != window.self) {
    auditHomePath += "?loadedInIframe=true";
  }
  let type = productData.queueType;
  let isObjectionableQueue = false;
  if (productData.isObjectionable) {
    isObjectionableQueue = true;
  }
  let isJdRepresentative =
    props.session.user.loggedUser &&
    props.session.user.loggedUser.userType == "JDEMPLOYEE";
  const isAuditor =
    props.session.user.loggedUser &&
    props.session.user.loggedUser.userType == "AUDITOR" &&
    isAuditUrl
      ? true
      : false;
  const mrpCompliance = selectTypeQuery.queueType === 'brandedMrp' && isAuditor ? true : false;
  const [justdialCatModal, showJDCatModal] = useState(false);
  const [timeoutModal, updateTimeoutModal] = useState(false);
  const [audiProdLoader, updateProdLoader] = useState(false);
  const [showBtnLoader, toggleBtnLoader] = useState(false);
  const [confirmBtnLoader, toggleConfirmBtnLoader] = useState(false);
  const [skipDrawer, updateSkipDrawer] = useState("");
  const [TAPLoader, updateTAPLoader] = useState(false);
  const [showCopyModal, toggleCopyModal] = useState(false);
  const [saveAuditMsg, updateAuditMsg] = useState("");
  const [saveProdConflict, updateSaveProdConflict] = useState("");
  const [imageSliderVisible, updateViewImageSlider] = useState(null);
  const [showaddinv , setShowAddInv] =useState(false);
  const scrollRef = useRef(null);
  const [isScrolled, setScroll] = useState(false);
  const [showPriceRange, toggleRange] = useState(
    !priceObj.isSinglePrice && (priceObj.minPrice || priceObj.maxPrice)
  );
  const [showDeleteModal, toggleDelModal] = useState(false);
  const [showPaste, togglePaste] = useState((productData.description || props.deviceData?.isIphone || props.deviceData?.isIphoneApp) ? false : true);
  const [objectionalModal, toggleShowObjectionalModal] = useState({
    show: false,
  });
  const [correctnessModel, setCorrectnessModel] = useState({ show: false, data: {} });
  const [aiSpecModal, setAIspecModal] = useState({ show: false})
  const [aiSpecsSaved, setAiSpecsSaved] = useState(false);
  const [docReqModal, toggledocReqModal] = useState({ show: false });
  const [sellingPriceModal, toggleSellingPriceModal] = useState({ show: false });
  const [auditPendingModal,setAuditPendingModal] = useState(false);
  const [auditPendingData,setAuditPendingData] = useState(false);
  const [showChangeModal, toggleChangeModal] = useState({ key: "" });
  const [showPriceLabelModal, toggleShowPriceLabelModal] = useState({
    show: false,
    isVisited: false
  });
  const [showObjectionalDelModal, toggleShowObjectionalDelModal] = useState(
    null
  );
  const [onlineUrlModal, setOnlineUrlModal] = useState(false);
  const [commissionModal, setCommissionModal] = useState(false);
  const [selectedCountry, updateSelectedCountry] = useState({
    ...productData.countryOrigin,
  });
  const [showSellOnline, toggleSellOnline] = useState(productData.isSellOnline);
  const [showBulkSell, toggleBulkSell] = useState((props.permissions?.sellOnlineInBulk && productData?.isBulkPricingActive==1) || false);
  const [isSellOnlineProduct, updateIsSellOnlineProduct] = useState(false);
  const [openFlagSlider, toggleFlagSlider] = useState(false);
  const [isVariant, updateType] = useState( 
   (props.session.supplierId != 231 && props.permissions?.packagePermissionData?.isAllowVariantProducts)? 1 : 0
  );
  const [variantInfo, toggleVariantWelcome] = useState(false);
  const [removedSpec, updateRemovedSpec] = useState([]);
  let productOrService = props.selectedCategoryType;
  if (productData.categoryType) {
    productOrService = productData.categoryType.toLowerCase();
  } else if (selectTypeQuery.selectedProductType) {
    productOrService = selectTypeQuery.selectedProductType;
  } else if (selectTypeQuery.isTemp) {
    productOrService = "product";
  }
  const [showTabs,updateTabs] = useState(Number(props.session?.newProfile) == 2  && productOrService != 'service' );
  const [selectedType, setSelectedType] = useState(productOrService);
  const [categoryChanged, setCategoryChanged] = useState(false);
  const [brandChange,setBrandChange] = useState(false);
  const [savingObjectionable,setSavingObjectionable] = useState(false);
  let previousIndex = 1;
  if (!isAddProduct || productData.isDuplicate) {
    if (showPriceRange) {
      previousIndex = 2;
    } else if (
      !showPriceRange &&
      priceObj.priceOnQty?.length &&
      !priceObj.isSinglePrice
    ) {
      previousIndex = 3;
    }
  }
  let selectedIndex = isAddProduct && !productData.isDuplicate ? 1 : previousIndex;
  const [toggleIndex, setToggleIndex] = useState(selectedIndex);
  const dontResetEditProduct = useRef(false);
  const [priceRangeQtyRef, setPriceRangeQtyRef] = useState();
  const [toggleInventory, setInventory] = useState(false);
  const [toggleAddInventoy , setAddInventory] = useState(false);
  const [showComplianceModal,updateShowComplianceModal] = useState(false);
  const [complianceModalShown,setComplianceModalShown] = useState(false);
  const [preHistory, setPerHistory] = useState(0);
  const [showBusinessType, setShowBusinessType] = useState(false); 
  const scrollEle = useRef([]);
  let sliderRef = useRef(null);
  let catSliderRef = useRef(null);
  let moreFieldsRef = useRef(null);
  let saveButtonStatus = useRef(null);
  let copytext = useRef(null);
  let copyProductBankIdText = useRef(null);
  let copyProductNameText = useRef(null);
  let isContractor =
    props.session.user.loggedUser &&
    contractorTypes.indexOf(props.session.user.loggedUser.subType) != -1;
  let isContractorV1V2 =
    props.session.user.loggedUser &&
    packagedContractorAllow.indexOf(props.session.user.loggedUser.subType) !=
      -1;
  let imageArray = props.productData.imageUrlArr
    ? props.productData.imageUrlArr
    : [];
  let videoArray = props.productData.videoUrlArr
    ? props.productData.videoUrlArr
    : [];
  const [countrySuggestions] = useState([
    {
      countryCode: "IN",
      countryID: 100,
      countryName: "India",
      isdCode: 91,
    },
    {
      countryCode: "CN",
      countryID: 45,
      countryName: "China",
      isdCode: 86,
    },
    {
      countryCode: "KR",
      countryID: 203,
      countryName: "South Korea",
      isdCode: 82,
    },
  ]); 
  const mediaUrlArr = [...imageArray, ...videoArray];
  const toggleViewImageSlider = (selImageIndex) => {
    updateViewImageSlider({
      selImageIndex: selImageIndex,
    });
  };
  const [sellingPriceModalData, setSellingPriceModalData] = useState({
    productName: productData.productName,
    actualImageUrl:getImagePath(imageArray[0]?.imgURL|| productData.imageUrl),
    batches:[{
    mrp: productData.mrp,
    sellingPrice: productData.sellingOnlinePrice,
    batchCreationDate: productData.batchCreationDate
    }]

    }
  );


  const [discountWaringPercent, setDiscountWaringPercent] = useState(productData.discount_percentage);
  const [showComplianceUpdateLoader,setShowComplianceUpdateLoader] = useState(false);
  const [countryUpdatedFromSmartFill,setCountryUpdatedFromSmartFill] = useState(false);

  const [backClick,setBackClick] = useState(false);
  const [taxSlider, toggleTaxSlider] = useState(false);
  const [taxObj, setTaxObj] = useState([]);
  const [batches, setBatches] = useState([])
  const [productNameTextAreaScrollHeight, setProductNameTextAreaScrollHeight] = useState(20);
  const [isSizeChartEnabled, setIsSizeChartEnabled] = useState(false)

  const isReviewStatusNotRejected = (!productData.reviewStatus?.toString().split(',').includes('REJECTED') && !productData.reviewStatus?.toString().split(',').includes('DOCUMENT_PENDING'));

  let taxSequence = [];
  if (props.permissions.taxZones && props.permissions.taxZones.length) {
    props.permissions.taxZones.map((ele) => {
      taxSequence.push(ele.zoneName);
    });
  }

  const mrpImages = productData?.mrp_images ? productData.mrp_images.split(",") : [];
  const mrpFrontImages = productData?.mrp_front_img ? productData.mrp_front_img.split(",") : [];

  const disableSellOnlineCustom = isAuditor && !isTemplate && productData.isSellOnline;

  useEffect(() => {
    axios.get(`/marketplace/dc-common/getStoreSettingsNew.ns?supplierId=${props.session.supplierId}&docid=${props.docId}`).then(rsp=>{
      setIsSizeChartEnabled(rsp?.data?.results?.isSizeChartEnabled || false)
    }).catch(err=>{
      setIsSizeChartEnabled(false)
      console.log("Error is storedetail api ",err);
    })
  }, [props.session.supplierId])

  useEffect(() => {
    if (props.productData.isAlreadyAudited && !props.showAuditData) {
      updateTimeoutModal(true);
    }
  }, [props.productData.isAlreadyAudited]);

  useEffect(() => {
    let iframeEle = parent.document.getElementById('omniIframe')
    if(selectTypeQuery?.closeIframe == '1' && iframeEle){
      iframeEle.style.visibility = 'unset';
      parent.document.body.style.overflow = 'hidden';
      parent?.Utills?.Loader?.hide({loaderType: 'spinner'});
    }
    if (!volumetricWeightType){
        axios.get('/marketplace/gis/getDeliveryTimeBand.service').
        then((res)=> {
            if (res.data && res.data.result){
                setVolumetricWeightType(res.data.result.volumetricWeightType);
            }
        })
    }
    if (props.session.viaOmni && productData.productId == "ADD_PRODUCT" && productData.categoryType.toLowerCase() == "product") {
      props?.updateEditProductDetail([{ key: "isSellOnline", value: 1 }]);
      toggleSellOnline(!showSellOnline);
    }
}, []);


  useEffect(() => {
    if(!productData.keywordId && !(isTempProd || isTemplate) && productData.productId != 'ADD_PRODUCT' && productData?.specification?.length) {
      // only in case of bulk upload i.e. custom product
      let sidList = [];
      let dataList = {};
      productData?.specification && productData.specification.map(cur => {
        if(cur.sid){
          sidList.push(cur.sid);
          dataList[cur.sid] = cur.value[0];
        }
      });
      axios.get('/vendorapis/products/product/getSpecInfoById?spec_ids='+sidList.toString()).then(res => {
        let sids = {};
        let data = {};
        let optionName = {};
        Object.keys(res.data.data).map(cur => {
          data[res.data.data[cur].sn] = dataList[cur];
          sids[res.data.data[cur].sn] = cur.toString();
          optionName[res.data.data[cur].sn] = res.data.data[cur].sdn;

        })
        setTimeout(() => {
          props.setHybridData({data: data,sidData: sids,optionName: optionName})
        }, 200);
      })

    }
    // if(isAuditor && (isTempProd || isTemplate) && copyProductNameText.current) {
    //   setProductNameTextAreaScrollHeight(copyProductNameText.current.scrollHeight);
    // }
    if(isAddProduct && !(isTempProd || isTemplate || props?.productData?.isDuplicate)){
      handleResetSpecification(true);
    }
    // if (isAuditor && isTemplate) {
    //   setFieldValue('isUnknownMrpValue', false);
    // }
    setPerHistory(history.length)
    setListingDataLength(Object.keys(props.listingProdData.results).length)
  },[]);
  useEffect(()=>{
    if((productData.isTemplate || productData.isTempProd) && isAddProduct){
      dispatch(getProductSmartFillSpec({
        brand: props.productData?.brandName,
        psv_node_id: props.productData?.leafId,
        custom: false
      }));
    }
  },[props.productData?.brandName,props.productData?.leafId])

  useEffect(() => {
    updateType(props.variantProps.variantProductData?.length ? 1 : 0);
  },[props.variantProps.variantProductData.length])

  useEffect(() => {
    productOrService = props.selectedCategoryType;
    if (productData.categoryType) {
      productOrService = productData.categoryType.toLowerCase();
    } else if (selectTypeQuery.selectedProductType) {
      productOrService = selectTypeQuery.selectedProductType;
    } else if (selectTypeQuery.isTemp) {
      productOrService = "product";
    }
    if(selectTypeQuery.searchKey && !productData.productName) {
      props.updateEditProductDetail({key: 'productName',value: selectTypeQuery.searchKey})
    }
    setSelectedType(productOrService);
  }, [props.selectedCategoryType]);

  useEffect(() => {
    if (props.productData && props.productData.hasOwnProperty("keywordId")) {
      const isBulkCatSelect = (!prevKeywordId.current && !(isTempProd || isTemplate) && productData.productId != 'ADD_PRODUCT');
      if(!isBulkCatSelect && Number(prevKeywordId.current) !== Number(productData.keywordId)){
        props.resetSpecificationFormData({prevData: categoryChanged});
        props.checkAndReset();
        // props.resetBrandManufactureData();
      }
      let preDefinedData =
        props.productData.hasOwnProperty("specification") &&
        props.productData.specification?.length
          ? props.productData.specification
          : null;

      if(props.productData.hasOwnProperty("contentPerPiece") && parseInt(props.productData.contentPerPiece) && props.productData.hasOwnProperty("unitPerPiece")){
        const getDetail = (value = "", key ="") => {
			const val = key === "unitPerPiece" ? getMatchedUOM(props.uom.netweightUOM, value).displayVal : value;
			return {
				value: val ? val.split() : [],
				error: ""
			  }
		};
        //Updating Netweight in specification slider
        const contentPerPiece = props.productData.contentPerPiece;
        const unitPerPiece = props.productData.unitPerPiece;
        const details = {
          contentPerPiece: getDetail(contentPerPiece),
          unitPerPiece: getDetail(unitPerPiece, "unitPerPiece")
        }
        props.updateBrandManufactureDetails({contentWeightUnit:details, contentWeightUnitSaved: details});
      }

      //Fetching specifications list
      if(props.savedPuvSpecAttributes?.length && !isBulkCatSelect && Number(prevKeywordId.current) != Number(props.productData.keywordId)){
        props.updateEditProductDetail([{
            key: "specification",
            value: categoryChanged? productData.specification :[]
        },{
            key: 'productLength',
            value: categoryChanged? productData.productLength :''
        },{
            key: 'productHeight',
            value: categoryChanged? productData.productHeight :''
        },{
            key: 'actualProductWeight',
            value: categoryChanged? productData.actualProductWeight :''
        },{
            key: 'productWidth',
            value : categoryChanged? productData.productWidth :''
        }]);
        setTimeout(() => {
          props.resetSpecificationFormData({prevData: categoryChanged});
        });
        // props.resetBrandManufactureData();
        props.checkAndReset();
        updateSelectedCountry(categoryChanged?selectedCountry:'');
        setBrandChange(true);
        preDefinedData = [];
    }
    let specIds = productData.keywordId? '' : productData.specification?.length?productData.specification.map(cur => (cur.sid)):null;
    prevKeywordId.current = props.productData.keywordId;
      props.fetchSpecificationAttributes(
        props.productData.keywordId,
        preDefinedData,
        {specIds, isTemplate: isTemplate || isTempProd,jdmartids: props.productData.jdmartids,uom: props.unitOfMeasurement},
        null
      );
      let catId = props.productData.psv_node_id
        ? props.productData.psv_node_id
        : props.productData.leafId;
      axios
        .get(
          `/vendorapis/products/product/getSpecList?supplierId=${props.session.supplierId}&catid=${catId}&sid=122`
        )
        .then((res) => {
          let result  = [];
          if (res.data.results?.slist?.length) {
            result = res.data.results.slist[0][122].split("|~|");
          }
          props.setBrandSuggestion([...result]);
        });
    }
  }, [props.productData.keywordId, props.session.supplierId]);

  useEffect(() => {
    let { specification = [] } = props;
    let isCompliance =
      (productData.isTempProd || productData.isTemplate) &&
      productData.compliance;
    if (
      specification.length &&
      (productData.productId != "ADD_PRODUCT" || productData.isDuplicate)
      && props.savedPuvSpecAttributes?.length
    ) {
      let brandDetails = specification.find((el) => el?.sid?.toString() == '122');
      let val = props.savedPuvSpecAttributes.find(el => el.s_id.toString() == '122');
      if(categoryChanged && props.savedPuvSpecAttributes?.length && brandDetails && val){
        brandDetails.value =  val?.s_type == 'Fixed'?val?.s_type_options:[val?.userInput?.value];
      }
      let manufactureData = {};
      let importerData = {};
      let isCustom = 0;
      props.savedPuvSpecAttributes.map((cur) => {
        if (["manufacturer", "manufactured_details"].includes(cur.s_nm)) {
          manufactureData[cur.s_nm] = cur;
        }
        if (["importer", "importers_detail"].includes(cur.s_nm)) {
          importerData[cur.s_nm] = cur;
        }
      });
      let mNameDetails = specification.find(
        (el) => el.sid == manufactureData["manufacturer"]?.s_id
      );
      let mAddressDetails = specification.find(
        (el) => el.sid == manufactureData["manufactured_details"]?.s_id
      );
      let impNameDetails = specification.find(
        (el) => el.sid == importerData["importer"]?.s_id
      );
      let impAddressDetails = specification.find(
        (el) => el.sid == importerData["importers_detail"]?.s_id
      );
      let installData = {
        ins_days: specification.find((el) => el.name == "ins_days")?.value[0],
        ins_amount: specification.find((el) => el.name == "ins_amount")
          ?.value[0],
        ins_cover: specification.find((el) => el.name == "ins_cover")?.value[0],
        ins_not_cover: specification.find((el) => el.name == "ins_not_cover")
          ?.value[0],
      };
      //Dimension in Specs change
      let productHeight = specification.find(el => el?.sid?.toString() === '5724');
      let productWidth = specification.find(el => el?.sid?.toString() === '5723');
      let productLength = specification.find(el => el?.sid?.toString() === '11426');
      let actualProductWeight = specification.find(el => el?.sid?.toString() === '7926');
      props.updateEditProductDetail([
        {
          key: 'productHeight',
          value: productData.productHeight?productData.productHeight: productHeight?.value[0]
        },
        {
          key: 'productWidth',
          value: productData.productWidth?productData.productWidth: productWidth?.value[0]
        },
        {
          key: 'productLength',
          value: productData.productLength?productData.productLength: productLength?.value[0]
        },
        {
          key: 'actualProductWeight',
          value: (() => {
            const v =
              productData.actualProductWeight ??
              actualProductWeight?.value?.[0];

            return Number(v) < 0.01 ? "" : v || "";
          })()
        },
        {
          key: 'oldProductWeight',
          value: productData.actualProductWeight?productData.actualProductWeight: actualProductWeight?.value[0]
        }
    ])

      let installArr = [
        {
          name: "ins_days",
          values: installData.ins_days
            ? [installData.ins_days]
            : props.installData[0].values[0]
            ? props.installData[0].values
            : [],
          s_nm: "Installation Days",
          s_type: "",
          isCustom: 1,
        },
        {
          name: "ins_amount",
          values: installData.ins_amount
            ? [installData.ins_amount]
            : props.installData[1].values[0]
            ? props.installData[1].values
            : [],
          s_nm: "Installation Amount",
          s_type: "",
          isCustom: 1,
        },
        {
          name: "ins_cover",
          values: installData.ins_cover
            ? [installData.ins_cover]
            : props.installData[2].values[0]
            ? props.installData[2].values
            : [],
          s_nm: "Covered under Standard Installation",
          s_type: "",
          isCustom: 1,
        },
        {
          name: "ins_not_cover",
          values: installData.ins_not_cover
            ? [installData.ins_not_cover]
            : props.installData[3].values[0]
            ? props.installData[3].values
            : [],
          s_type: "",
          s_nm: "Not Covered under Standard Installation",
          isCustom: 1,
        },
      ];
      if (isCompliance) {
        mNameDetails = mNameDetails
          ? mNameDetails
          : props.savedPuvSpecAttributes.find(
              (el) => (el.s_nm == "manufacturer")
            );
        mAddressDetails = mAddressDetails
          ? mAddressDetails
          : props.savedPuvSpecAttributes.find(
              (el) => (el.s_nm == "manufactured_details")
            );
        impNameDetails = impNameDetails
          ? impNameDetails
          : props.savedPuvSpecAttributes.find((el) => el.s_nm == "importer");
        impAddressDetails = impAddressDetails
          ? impAddressDetails
          : props.savedPuvSpecAttributes.find(
              (el) => el.s_nm == "importers_detail"
            );
        if (mNameDetails)
          mNameDetails.value = mNameDetails?.value
            ? mNameDetails.value
            : [mNameDetails?.userInput?.value];
        if (mAddressDetails)
          mAddressDetails.value = mAddressDetails?.value
            ? mAddressDetails.value
            : [mAddressDetails?.userInput?.value];
        if (impNameDetails)
          impNameDetails.value = impNameDetails?.value
            ? impNameDetails.value
            : [impNameDetails?.userInput?.value];
        if (impAddressDetails)
          impAddressDetails.value = impAddressDetails?.value
            ? impAddressDetails.value
            : [impAddressDetails?.userInput?.value];
      }
      let sendData = [...props.sendBMDetails];
      let eleIndex = "";
      if (brandDetails?.value?.length) {
        eleIndex = sendData.findIndex((el) => el.name == "brand");
        sendData[eleIndex] = {
          sid: brandDetails?.sid || brandDetails?.s_id,
          productId: null,
          name: "brand",
          filterFlag: "1",
          values: brandDetails?.value,
          unit: "",
        };
      }

      if (mNameDetails?.value?.length) {
        eleIndex = sendData.findIndex((el) => el.name == "manufacturer");
        sendData[eleIndex] = {
          sid: mNameDetails?.sid || mNameDetails?.s_id,
          values: mNameDetails?.value,
          name: "manufacturer",
          productId: null,
          unit: "",
          filterFlag: "",
          isCustom: isCustom,
        };
      }

      if (mAddressDetails?.value?.length) {
        eleIndex = sendData.findIndex(
          (el) => el.name == "manufactured_details"
        );
        sendData[eleIndex] = {
          sid: mAddressDetails?.sid || mAddressDetails?.s_id,
          values: mAddressDetails?.value,
          name: "manufactured_details",
          productId: null,
          unit: "",
          filterFlag: "",
          isCustom: isCustom,
        };
      }

      if (impNameDetails?.value?.length) {
        eleIndex = sendData.findIndex((el) => el.name == "importer");
        sendData[eleIndex] = {
          sid: impNameDetails?.sid || impNameDetails?.s_id,
          values: impNameDetails?.value,
          name: "importer",
          productId: null,
          unit: "",
          filterFlag: "",
          isCustom: 0,
        };
      }

      if (impAddressDetails?.value?.length) {
        eleIndex = sendData.findIndex((el) => el.name == "importers_detail");
        sendData[eleIndex] = {
          sid: impAddressDetails?.sid || impAddressDetails?.s_id,
          values: impAddressDetails?.value,
          name: "importers_detail",
          productId: null,
          unit: "",
          filterFlag: "",
          isCustom: 0,
        };
      }
      props.updateBrandManufactureDetails({
        ...props.brandManufacturer,
        brandName: brandDetails?.value.toString(),
        manufacturer: mNameDetails?.value.toString(),
        manufactured_details: mAddressDetails?.value.toString(),
        importer: impNameDetails?.value.toString(),
        importers_detail: impAddressDetails?.value.toString(),
        sendDetails: sendData,
        installData: installArr,
      });
    }
  }, [props.specification, props.savedPuvSpecAttributes]);

  const handleResetSpecification = (dontSet) => {
    console.log('handle Reset')
    if(!dontSet){
      setBackClick(true);
    }
    props.updateEditProductDetail([{key: 'specification',value: []}])
    props.resetBrandManufactureData();
    props.setHybridData("");
    props.resetSpecificationFormData(true);
  };

  const updateSellOnlineFormData = (sellOnlineFormData, from) => {
    let newPriceObj = { ...productData.priceObj };
    let priceQtyArr = [];
    let rangeQtyData = sellOnlineFormData;
    if (from == "maxQty") {
      newPriceObj.isMaxQtyNotApplicableForRange = sellOnlineFormData;
      setFieldValue("priceObj", newPriceObj, productData.uomType);
      return;
    }
    if (rangeQtyData?.length) {
      rangeQtyData?.forEach((cur) => {
        let dummyObj = {};
        dummyObj.minVisit = cur.minimumQuantity;
        dummyObj.maxVisit = cur.maximumQuantity;
        dummyObj.price = cur.sellingPrice;
        dummyObj.discountType = cur.fixedDiscount ? "fixedDiscount" : "percentageDiscount";
        dummyObj.discountValue = cur.fixedDiscount || cur.percentageDiscount;
        dummyObj.disabled = cur.disabled;
        priceQtyArr.push(dummyObj);
      });
    }
    if (priceQtyArr.length) {
      newPriceObj.priceOnQty = priceQtyArr;
      setFieldValue("priceObj", newPriceObj, productData.uomType);
    }
  };
4

  const updateBulkSellFormData = (sellOnlineFormData, from) => {
    // let newBulkPricingDetail = productData?.bulkPricingDetail || [];
    if (from == "maxQty") {
      setFieldValue("isBulkMaxQtyApplicableForRange", sellOnlineFormData, productData.uomType);
      return 
    }
    setFieldValue("bulkPricingDetail", sellOnlineFormData, productData.uomType);
  };

  useEffect(() => {
    setFieldValue("isBulkPricingActive", showBulkSell, productData.uomType);
  }, [showBulkSell])
  

  useOnScroll({
    callback : (e,scrollObj) => {
      if(scrollObj.currScroll.scrollTop){
        setScroll(true);
      }else{
        setScroll(false)
      }
    },
    element : !scrollEl ? null : scrollEl,
    deps: [scrollEl]
  })

  useEffect(() => {
    if (errors["image"] && props.variantImagesLength) {
      handleFocus(null, "image");
    }
  }, [props.variantImagesLength]);

  useEffect(() => {
    if (
      props.session.showCompanyDetails &&
      props.session.user.loginData &&
      !props.session.isReadOnly
    ) {
      if (
        isAuditUrl &&
        (!props.session.user.loggedUser ||
          props.session.user.loggedUser.userType != "AUDITOR")
      ) {
        props.setAuditObject({
          redirectUrl: window.location.href,
        });
        history.push("/login");
        return;
      }
      if (!props.session.user.loggedUser) {
        history.push("/products/auth");
      }
    }
  }, [props.session.user.loginData]);

  useEffect(() => {
    savedUOM.current = props.unitOfMeasurement;
  }, [props.session.isAppInitialized, props.unitOfMeasurement]);
  const mounted = useRef();
  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
    } else {
      if (moreFieldsShown) {
        window.scrollBy({
          top: moreFieldsRef.current.offsetHeight + 20,
          behavior: "smooth",
        });
      }
    }
  }, [moreFieldsShown]);

  useEffect(() => {
    if (
      props.productData?.categoryType === "service" && 
      (!("actualPrice" in priceObj) ||
        priceObj.actualPrice === undefined ||
        priceObj.actualPrice === null ||
        Number(priceObj.actualPrice) === 0) &&
      "singlePrice" in priceObj &&
        priceObj.singlePrice !== undefined &&
        priceObj.singlePrice !== null &&
        Number(priceObj.singlePrice) !== 0
    ) {
      priceObj.actualPrice = priceObj.singlePrice;
    }
  }, [toggleIndex]);


  const updateValue = (e, value, key) => {
    if (key == "transactionType") {
      if (!showSellOnline) {
        let priceObject = productData.oldPriceObj || { ...priceObj };
        if(maxSupplyCapacity && supplyTimePeriod) {
          priceObject['maxSupplyCapacity'] = maxSupplyCapacity;
          priceObject['supplyTimePeriod'] = supplyTimePeriod;
        }
        let editProductData = [
          {
            key: "priceObj",
            value: priceObject,
            uomType: props.productData.uomType,
          },
        ];
        if (isAddProduct && priceObj.singlePrice && !showPriceRange) {
          editProductData.push({
            key: "mrp",
            value: priceObj.singlePrice,
          });
          editProductData.push({
            key: "sellingOnlinePrice",
            value: priceObj.singlePrice,
          });
        }
        props.updateEditProductDetail(editProductData);
      } else {
        toggleShowSOFields(false);
        let editProductData = [
          {
            key: "quantity",
            value: productData.quantity || productData.oldSellOnlineObj?.quantity || '',
          },
          {
            key: "mrp",
            value: productData.mrp ||  productData.oldSellOnlineObj?.mrp || '',
          },
          {
            key: "sellingOnlinePrice",
            value: productData.sellingPrice || productData.oldSellOnlineObj?.sellingPrice || '',
          },
          {
            key: "barcode",
            value: productData.oldSellOnlineObj
              ? productData.oldSellOnlineObj.barcode
              : "",
          },
        ];
        if (isAddProduct) {
          let addSellOnlineOff = productData.priceObj
            ? { ...productData.priceObj }
            : {};
          addSellOnlineOff.singlePrice = productData?.sellingOnlinePrice || productData?.priceObj?.singlePrice;
          editProductData.push({
            key: "priceObj",
            value: addSellOnlineOff,
            uomType: props.productData.uomType,
          });
        }
        props.updateEditProductDetail(editProductData);
      }
      toggleSellOnline(!showSellOnline);
    } else {
      setToggleIndex(value);
      // if(props.unitOfMeasurement?.val && !(isTempProd || isTemplate)){
      //   setTimeout(() => setFieldValue('unitOfMeasurement','', productData.uomType), 100);
      // }
      if (value == 2 || value == 3) {
        toggleRange(true);
      } else {
        toggleRange(false);
      }

      if (value == 1) {
        if (priceObj.singlePrice) {
          let newPriceObj = { ...priceObj };
          newPriceObj.isSinglePrice = true;
          if(!showSellOnline && maxSupplyCapacity && supplyTimePeriod) {
            newPriceObj['maxSupplyCapacity'] = maxSupplyCapacity;
            newPriceObj['supplyTimePeriod'] = supplyTimePeriod;
          }
          setFieldValue("priceObj", newPriceObj, productData.uomType);
        }
      }
    }
  };

  const onBusinessChange = (natCatId) => {
    props.updateBizList({
      natCatId,
    });
    if (errors.businessError) {
      let newErr = { ...errors };
      newErr.businessError = "";
      updateError(newErr);
    }
  };

  const closeCatSliderOnBack = () => {
    openCloseCatSlider(false);
  };

  //prefilled Data for branded Product Specs
  useEffect(() => {
    // let noSid = props.sendBMDetails.find((el) => !el.sid);
    let manufactureDetails = {};
    let importerDetails = {};
    if (props.hybrid.length) {
      console.log("prefill useeffect");
      let productHeight = '',
          productWidth = '',
          productLength = '',
          actualProductWeight = ''
      if(productData.compliance) {
        productHeight = productData?.compliance.packaging_height;
        productWidth = productData?.compliance.packaging_width;
        productLength = productData?.compliance.packaging_length;
        actualProductWeight = productData?.compliance.packaging_weight;
      }
      props.updateEditProductDetail([
        {
          key: 'productHeight',
          value: productHeight?productHeight:productData.productHeight
        },
        {
          key: 'productWidth',
          value: productWidth?productWidth:productData.productWidth
        },
        {
          key: 'productLength',
          value: productLength?productLength:productData.productLength
        },
        {
          key: 'actualProductWeight',
          value: actualProductWeight?actualProductWeight:productData.actualProductWeight
        },
        {
          key: 'oldProductWeight',
          value: actualProductWeight?actualProductWeight:productData.actualProductWeight
        }
    ])
      let sendBmData = [...props.sendBMDetails];
      sendBmData.map((cur) => {
        let element = props.hybrid.find((el) => (el.name == cur.name));
        let elInSpec = props.savedPuvSpecAttributes.find(
          (el) => el.s_nm == cur.name
        );
        if (element) {
          cur.values = (cur.values?.length && cur.values[0])  ? cur.values : element.values;
          cur.sid = element.sid;
          if(element.values[0])
            manufactureDetails[cur.name] = element.values[0];
        } else if (elInSpec) {
          cur.values = cur.values?.length
            ? cur.values
            : [elInSpec.userInput.value];
          cur.sid = element?.sid || elInSpec?.s_id;
          if(elInSpec.userInput.value)
            manufactureDetails[cur.name] = elInSpec.userInput.value;
        }
      });
      props.updateBrandManufactureDetails({
        ...props.brandManufacturer,
        ...manufactureDetails,
        sendDetails: [...sendBmData],
      });
    }
  }, [props.hybrid]);

  useEffect(() => {
  if(productData.compliance){
    const preDefinedData =
        props.productData.hasOwnProperty("specification") &&
        props.productData.specification?.length
          ? props.productData.specification
          : null;
    let specIds = productData.specification?.length?productData.specification.map(cur => (cur.sid)):null
    props.fetchSpecificationAttributes('',preDefinedData,{
      leafId: productData.leafId,
      bid: productData.bid,
      isTemp: true,
      isTemplate: isTemplate || isTempProd,
      specIds
    },props.brandManufacturer)

  }
  },[productData.compliance])

  const setComplianceSpecs = (data, sidData) => {
    console.log("setcompliance Specs");
    props.setHybridData({ data, sidData });
  };

  const setFieldDetails = () => {
    let data = {};
    axios
      .get(
        "/vendorapis/products/product/getSpecInfo?spec_names=manufacturer,country_of_origin,importers_detail,importer,manufactured_details&action=getSpecInfo"
      )
      .then((res) => {
        data = res.data.data;
        console.log("setFieldDetails");
        if (productData.specification?.length && !selectedCountry.countryCode) {
          let countrySpec = productData.specification.find(
            (el) => el.sid == data["country_of_origin"]
          );
          let countryObj = countrySpec
            ? props.countryList.find(
                (el) => el.countryName == countrySpec.value[0]
              )
            : {};
          countryObj?.countryCode && updateSelectedCountry({ ...countryObj });
        }
        if (!productData.keywordId && productData.leafId < 0) {
          //case of Bulk Upload
          let savedSpecification = [...props.savedPuvSpecAttributes];
          productData.specification.map((cur) => {
            let elmnt = savedSpecification.find((el) => el.sid == cur.sid);
            if (elmnt) {
              elmnt.userInput.value = cur.value[0];
            }
          });
          props.updateSpecificationData({
            editablePuvSpecAttributes: [...savedSpecification],
            savedPuvSpecAttributes: [...savedSpecification],
          });
        }
        updateStatus(true);
      });
  };

  useEffect(() => {
    if(categoryChanged && (showSellOnline || productData.isSellOnline) && (productData.productId != 'ADD_PRODUCT' && !categoryChanged ? Number(productData.lbl_img_mandatory): Number(props.productSpecification.lbl_img_mandatory)) == 1 && !showPriceLabelModal.isVisited && !(isTempProd || isTemplate)) {
      setTimeout(() => {
        toggleShowPriceLabelModal({show: true,isVisited: true});
      }, 500);
    }else {
      toggleShowPriceLabelModal({show: false,isVisited: showPriceLabelModal.isVisited})
    }
  },[props.productSpecification.expiryFlag,props.productSpecification.lbl_img_mandatory])

  useEffect(() => {
    if (productData.compliance) {
      let {
        country_of_origin,
      } = productData.compliance;
      if (country_of_origin) {
        if (country_of_origin.split(",").length > 1) {
          country_of_origin = country_of_origin.split(",")[0];
        }
        let countryObj = props.countryList.find(
          (el) => el.countryName == country_of_origin
        );
        if(!countryObj){
          countryObj = {
            countryCode: country_of_origin?.substring(0,2)?.toLocaleUpperCase(),
            countryID: 1,
            countryName: country_of_origin,
            isdCode: 93
          }
        }
        updateSelectedCountry({ ...countryObj });
      }
      console.log(productData.compliance);

        if (!props.hybrid.length && !backClick) {
          axios
            .get(
              "/vendorapis/products/product/getSpecInfo?spec_names="+Object.keys(productData.compliance).toString()+"&action=getSpecInfo"
            )
            .then((res) => {
              console.log(res.data);
              let spec = [], complianceFields = {};
              Object.keys(productData.compliance).map(cur => {
                complianceFields[cur] = productData.compliance[cur];
                if(!['brand','manufacturer','manufactured_details','country_of_origin','importer','importers_detail','price','packaging_length','packaging_width','packaging_height','packaging_weight','Expiry_date'].includes(cur) && productData.compliance[cur]){
                  delete complianceFields[cur];
                }
                if(productData.compliance[cur] && res.data?.data[cur]){
                  spec.push(res.data?.data[cur]);
                }
              });

              props.addUpdateFixedSpecs({dataToAdd: spec});
              props.setHybridData({data: complianceFields, sidData: res.data.data});
            });
        }
    }
    if(props.productSmartFillSpec?.length && !countryUpdatedFromSmartFill){
      let prodSpecObj = {};
      props.productSmartFillSpec?.map((cur)=>{
        prodSpecObj[cur.s_nm] = cur?.userInput?.value;
      });
      let {
        country_of_origin,
      } = prodSpecObj;
      if(country_of_origin) {
        if(country_of_origin.split(',').length > 1){
          country_of_origin = country_of_origin.split(',')[0];
        }
        let countryObj = props.countryList.find(el => el.countryName == country_of_origin);
        if(!countryObj){
          countryObj = {
            countryCode: country_of_origin?.substring(0,2)?.toLocaleUpperCase(),
            countryID: 1,
            countryName: country_of_origin,
            isdCode: 93
          }
        }
        updateSelectedCountry({...countryObj})
        setCountryUpdatedFromSmartFill(true);
      }
    }
    let localCountryList = props.countryList.length ? props.countryList : countrySuggestions;
    if(!selectedCountry.countryCode && localCountryList.length && (productData.productId != 'ADD_PRODUCT' || productData.isDuplicate)){
      let countrySpec = props.editablePuvSpecAttributes.find(el => el.s_nm == 'country_of_origin');
      if(countrySpec && productData.specification?.length) {
        countrySpec = productData.specification.find(el => el.sid == countrySpec.s_id);
        let countryObj = countrySpec?localCountryList.find(el => el.countryName == countrySpec.value[0]):{};
        if(!countryObj && countrySpec?.value[0]){
          countryObj = {
            countryCode: countrySpec.value[0]?.substring(0,2)?.toLocaleUpperCase(),
            countryID: 1,
            countryName: countrySpec.value[0],
            isdCode: 93
          }
        }
        updateSelectedCountry({...countryObj})
      }
    }
    if (
      !selectedCountry.countryCode &&
      productData.productId != "ADD_PRODUCT" &&
      !productData.keywordId
    ) {
      !fieldsSet && setFieldDetails();
    }
  },[props.countryList,props.editablePuvSpecAttributes,props.productSmartFillSpec])

  useEffect(() => {
    let initialTaxData = {};
    if (productData.hsnSacNo) {
      initialTaxData["HSN/SAC"] = productData.hsnSacNo;
    }
    if(typeof productData.gstRate === 'number' || productData.gstRate){
      initialTaxData['salestax'] = String(productData.gstRate) + '%';
    }
    if ((productData.purchaseTax && Array.isArray(productData.purchaseTax) && productData.purchaseTax.length) || [{taxId: ''}]) {
      let taxData = props.permissions.purchaseTaxData;
      if(taxData){
          Array.isArray(productData?.purchaseTax) && productData?.purchaseTax?.length && productData.purchaseTax.map((ele) => {
              if (ele.taxId) {
                  let taxArr = taxData.filter((tax) => {
                      if (tax.taxId == ele.taxId) {
                          return tax;
                      }
                  });
                  initialTaxData['purchaseTax'] = taxArr[0]?.taxName + ' @ ' + taxArr[0]?.taxRate + '%';
              } else {
                initialTaxData['purchaseTax'] = 'Select Tax';
              }
          })
      }
  }
    setTaxObj(initialTaxData);
  },[props.permissions.taxData])

  useEffect(() => {
    //addBackHandler(closeCatSliderOnBack);
    if (Number(isProductOnlyProfile) == 1 && isAddProduct) {
      toggleSellOnline(true);
    }
    if (Number(props.session?.newProfile) == 0 && productData.isSellOnline && productData.productId != "ADD_PRODUCT") {
      updateIsSellOnlineProduct(true);
      updateTabs(true);
    }else if(Number(props.session?.newProfile) == 1 && !productData.isSellOnline && productData.productId != 'ADD_PRODUCT') {
      updateTabs(true);
    }
    if(window){
      window.appHandler = (jsonStr) => {
          try {
          console.log('callback',jsonStr);
          const transformedJson = JSON.parse(jsonStr);
          const {eventType, redirectionurl} = transformedJson;
          if(redirectionurl){
              window.location.replace(redirectionurl);
          }else if(eventType == "deviceback"){
              if (JdLiteInterface && JdLiteInterface.verticalHandler) {
                const urlPath= window.location.pathname
                if (urlPath.includes('/products/add') ||urlPath.includes('/products/edit')) {
                  history.goBack();
                } else {
                  const exitJson ={"action":"exit"};
                  JdLiteInterface.verticalHandler(JSON.stringify(exitJson));
                }
              }
          }
          } catch (e) {
          console.log(e)
          }
      };
      if(props.isJdSourceAndroid){
        pageLoad();
      }else if (props.isJdBusinessIOS) {
				pageLoadForIos();
			}
    }
    return () => {
      //removeBackHandler(closeCatSliderOnBack);
      if (saveButtonStatus.current != "saved") {
        if (productData.productId) {
          props.resetProductData({
            dontResetEditProduct: dontResetEditProduct.current, // in case of jd gallery,
            AddImagestoListing: false
          });
        }
      } else {
        if(isContractorV1V2 || props.session.isOnboardingEmp){
          dispatch(getAllJdCatCoverData({docid: props.docId}))
        }
        if (props.isJdPhotoSlider && !props.directAddToProduct && !fromPhotos) {
          if (props.deviceData.isMobile) {
            setTimeout(() => {
              history.goBack();
            }, 300); // slider close timeout
          } else {
            historyHandler.closeAll();
          }
        }
      }
      scrollRef.current &&
        scrollRef.current.removeEventListener("scroll", scrollHandler);
    };
    return () => {
      handleResetSpecification()
    }
  }, []);



  const toggleMoreFields = (e) => {
    updateMoreFields(!moreFieldsShown);
  };

  let leftIconArr = [
    {
      className: "icon-hdrBackNew",
      onClick: () => {
        // props.resetProductData();
        if (productData.productId) {
          props.discardAddProductMedia();
        }
        handleResetSpecification();
        props.hideProductEditSlider();
        props.resetVariantData();
        props.deviceData.isMobile && props.listingProdData.prodCount > 0 && props.setShouldRetainScroll(true);
        if((props.isJdSourceAndroid || props.isJdBusinessIOS) && fromSellerRejected){
          window.location.href = 'https://jdext.php';
        }else{
          history.goBack();
        }
      },
    },
  ];
  let AuditBtnArray = [];
  let AuditWebsiteBtn = [];
  let jdCatList = [];
  let contractorSourceList = [];
  let isContractorSourcev1 = false;
  let rightIconArray = props.deviceData.isMobile || mrpCompliance
    ? []
    : [
        {
          className: "icon-HDRcross",
          onClick: () => {
            // historyHandler.closeAll();
            props.discardAddProductMedia();
            handleResetSpecification();
            props.resetVariantData();
            // history.goBack();
            // if(props.fromSellerDashboard){
            //   setTimeout(()=>{
            //     history.go(-1);
            //   },0)
            // }
            universalClose(props.fromSellerDashboard,historyHandler);
            if(props.session.closeIframe) {
              setTimeout(() => {
                let ele = parent?.document.getElementById('omniIframe');
                parent.document.body.style.overflow = 'unset';
                if(ele?.parentNode && ele?.parentNode?.children && ele?.parentNode?.children?.length){
                  ele.parentNode.removeChild(ele);
                }
              }, 1000);
              return
            }
          },
        },
      ];
  let leftIconWeb =
    (productData.productId === "ADD_PRODUCT" &&
      !props.viaSuggested) ||
    props.isSearchSliderOpen
      ? [
          {
            className: "icon-HDRback",
            onClick: () => {
              historyHandler.closeCurrent();
              handleResetSpecification();
              props.resetVariantData();
              !props.isSearchSliderOpen && 
              !props.session.hideSuggestedAutoServiceSlider &&
              props.showItemSearchSlider(props?.productData?.type?.toLowerCase() || props?.productData?.categoryType?.toLowerCase());
            },
          },
        ]
      : [];

  let drawerOptions, drawerOnClick, drawerTitle;
  if (
    isJdRepresentative &&
    !isAddProduct &&
    props.deviceData.isMobile &&
    !productData.isObjectionable &&
    !mrpCompliance
  ) {
    rightIconArray = [
      {
        isMoreMenu: true,
        menuClass: "representative-header-options",
        options: [
          {
            label: "View Product ID",
            onClick: () => {
              toggleCopyModal(true);
            },
          },
        ],
      },
    ];
  }
  // if (isAuditor) {
  //   const { queueType = "" } = identifyAuditFlow({ query: true });
  //   type = type ? type : queueType;
  //   leftIconArr = [];
  //   if (auditFromPage) {
  //     leftIconArr = [
  //       {
  //         className: "icon-hdrBackNew",
  //         onClick: () => {
  //           if (productData.productId) {
  //             props.discardAddProductMedia();
  //           }
  //           handleResetSpecification();
  //           props.hideProductEditSlider();
  //           props.resetVariantData();
  //           window.history.back();
  //         },
  //       },
  //     ];
  //   }
  //   if (!isAddProduct && !mrpCompliance) {
  //     rightIconArray.push({
  //       isMoreMenu: true,
  //       menuClass: `representative-header-options ${isAuditor && !productData.isObjectionable ? (productData.JdMartPdpLink ? '' :  'option-disabled') : (productData.JdMartPdpLink ? 'option-blank' :  '')} `,
  //       options: [
  //         {
  //           label: "Delete",
  //           onClick: () => {
  //             toggleCopyModal("delete");
  //           },
  //         },
  //         {
  //           label: productData?.buyOnlineUrl
  //             ? "Edit Buy Online URL"
  //             : "Add Buy Online URL",
  //           onClick: () => {
  //             setOnlineUrlModal(true);
  //           },
  //           },
  //            isAuditor && !productData.isObjectionable && {
  //             label: "JdMart PDP link",
  //             class: "pdp-link",
  //             holderClass: "pdp-link1",
  //             customClass:"pdp-link1",
  //             onClick: () => {
  //               window.open(productData.JdMartPdpLink || '', '_blank');
  //             },
  //         }
  //       ],
  //     });
  //   }
  //   let firstWebsiteBtn = {};
  //   firstWebsiteBtn = {
  //     key: "1",
  //     label: "Company Website",
  //     jdWebsiteUrl: productData.jdWebsiteUrl,
  //     className:
  //       (productData.jdWebsiteUrl ? "" : "disabled") +
  //       " " +
  //       styles["hover-tooltip"],
  //     onClick: () => {
  //       productData.jdWebsiteUrl &&
  //         window.open(productData.jdWebsiteUrl, "_blank");
  //     },
  //   };
  //   let secondWebsiteBtn = {
  //     key: "2",
  //     label: "Best Practices Website",
  //     jdBestPracticeWebsiteUrl: productData.jdBestPracticeWebsiteUrl,
  //     className:
  //       (productData.jdBestPracticeWebsiteUrl ? "" : "disabled") +
  //       " " +
  //       styles["hover-tooltip"],
  //     onClick: () => {
  //       productData.jdBestPracticeWebsiteUrl &&
  //         window.open(productData.jdBestPracticeWebsiteUrl, "_blank");
  //     },
  //   };
  //   AuditWebsiteBtn.push([firstWebsiteBtn, secondWebsiteBtn]);

  //   if (productData.jdCatList && productData.jdCatList.length) {
  //     AuditBtnArray.push({
  //       name: "Categories",
  //       onClick: () => {
  //         showJDCatModal(true);
  //       },
  //     });
  //     jdCatList = productData.jdCatList;
  //   }
  //   if (productData.jdLink) {
  //     AuditBtnArray.push({
  //       name: "Justdial",
  //       onClick: () => {
  //         window.open(productData.jdLink, "_blank");
  //       },
  //     });
  //   }
  //   if (skipDrawer == "stopAuditing") {
  //     drawerTitle = "STOP AUDITING";
  //     drawerOptions = {
  //       skipFetch: {
  //         text: "Approve & Stop Auditing",
  //         value: "approveStop",
  //       },
  //       skipStop: {
  //         text: "Reject / Delete & Stop Auditing",
  //         value: "deleteStop",
  //       },
  //     };
  //   } else {
  //     drawerTitle = `SKIP ${(productOrService == 'service') ? 'SERVICE' : 'PRODUCT'}`;
  //     drawerOptions = {
  //       skipFetch: {
  //         text: `Skip & Fetch Another ${(productOrService == 'service') ? 'Service' : 'Product'}`,
  //         value: "skipFetch",
  //       },
  //       skipStop: {
  //         text: "Skip & Stop Auditing",
  //         value: "skipStop",
  //       },
  //     };
  //   }
  //   if (productData.source && productData.source.length) {
  //     contractorSourceList = productData.source;
  //   }
  //   let contractorSourceCount = 1;
  //   if (productData.dataSource && productData.dataSource.length) {
  //     contractorSourceList = [];
  //     isContractorSourcev1 = true;
  //     productData.dataSource.map((cur) => {
  //       let value = { ...cur };
  //       value.displaySourceName = "S" + contractorSourceCount;
  //       value.displayName = cur.type;
  //       value.websiteUrl = cur.value;
  //       contractorSourceCount++;
  //       contractorSourceList.push(value);
  //     });
  //   }
  //   if (productData.sourceFiles) {
  //     if (!productData.dataSource || !productData.dataSource.length) {
  //       contractorSourceList = [];
  //     }
  //     if (
  //       productData.sourceFiles &&
  //       productData.sourceFiles.sourceDocs &&
  //       productData.sourceFiles.sourceDocs.length
  //     ) {
  //       isContractorSourcev1 = true;
  //       productData.sourceFiles.sourceDocs.map((cur, index) => {
  //         let value = { ...cur };
  //         value.displaySourceName = "S" + contractorSourceCount;
  //         value.displayName = "Source File " + (index + 1);
  //         value.download = `/marketplace/static/php/web/b2bWebsite.php?action=downloadAttachment&docid=${productData.docid}&fileId=${cur.fileId}`;
  //         contractorSourceList.push(value);
  //       });
  //       contractorSourceCount++;
  //     }
  //     if (
  //       productData.sourceFiles &&
  //       productData.sourceFiles.callRecordings &&
  //       productData.sourceFiles.callRecordings.length
  //     ) {
  //       isContractorSourcev1 = true;
  //       productData.sourceFiles.callRecordings.map((cur, index) => {
  //         let value = { ...cur };
  //         value.displaySourceName = "S" + contractorSourceCount;
  //         value.displayName = "call Recording " + (index + 1);
  //         value.download = `/downloads/b2bAuditReport/contractorSourceFiles/callRecordings/${cur.serverFileName}`;
  //         value.isCallRecording = true;
  //         contractorSourceList.push(value);
  //       });
  //     }
  //   }
  // }

  const fetchResolve = (options = {}) => {
    let { data, redirectToHome, fromDelete } = options;
    const { queueType = "" } = identifyAuditFlow({ query: true });
    if (data.data.status == 1 && !redirectToHome) {
      if (window.top != window.self) {
        data.data.url += "&loadedInIframe=true";
      }
      const redirect = () => {
        if (fromDelete) {
          window.location.replace(data.data.url);
        } else {
          window.location.href = data.data.url;
        }
      };
      if (data.data.previousDocId || data.data.previousEmpMobile) {
        // updateAuditDocModal({
        //   cb: redirect,
        //   queueType
        // });
      } else {
        redirect();
      }
    } else {
      const redirect = () => {
        if (fromDelete) {
          history.replace(auditHomePath);
        } else {
          history.push(auditHomePath);
        }
      };      
      // updateAuditDocModal({
      //   cb: redirect,
      //   queueType,
      //   noMoreRecords: true
      // });
    }
  };

  const delObjectionableProd = (options = {}) => {
    const { queueType = "", token, id, isStop } = options;
    deleteObjectionableProduct({
      queueType,
      token,
      id,
      cb: (data) => {
        toggleShowObjectionalDelModal(null);
        if (auditFromPage) {
          if (listingDataLength > 0){
          window.history.back()
          }else {
              history.push("/login")
          }
        } else {
          if (isStop) {
            fetchResolve({
              data,
              redirectToHome: true,
              fromDelete: true,
            });
          } else {
            fetchAuditUrl({
              cb: (data) => {
                fetchResolve({ data, fromDelete: true });
              },
            });
          }
        }
      },
    });
  };

  drawerOnClick = (e, key) => {
    // if (isAuditor) {
    //   const { queueType = "" } = identifyAuditFlow({ query: true });
    //   if (key.value == "approveStop" || key.value == "deleteStop") {
    //     if (key.value == "approveStop") {
    //       saveData();
    //     } else if (key.value == "deleteStop") {
    //       toggleShowObjectionalDelModal({
    //         id: "deleteStopAudit",
    //         headerText: "Reject / Delete & Stop Auditing",
    //         buttonText: "Reject / Delete & Stop Auditing",
    //         cb: () => {
    //           delObjectionableProd({
    //             queueType,
    //             token: props.session.token,
    //             id: productData.id,
    //             isStop: true,
    //           });
    //         },
    //       });
    //     }
    //   } else {
    //     skipProduct({
    //       token: props.session.token,
    //       productId: productData.isObjectionable
    //         ? undefined
    //         : productData.productId,
    //       id: productData.isObjectionable ? productData.id : undefined,
    //       queueType,
    //       cb: (data) => {
    //         if (data.data.status == 1) {
    //           if (key.value == "skipFetch") {
    //             fetchAuditUrl({
    //               cb: (data) => {
    //                 fetchResolve({ data });
    //               },
    //             });
    //           } else if (key.value == "skipStop") {
    //             history.push(auditHomePath);
    //           }
    //         }
    //       },
    //     });
    //   }
    //   updateSkipDrawer("");
    // }
  };

  const updateSkipBatch = () => {
		// if (isAuditor) {
		// 	const { queueType = '' } = identifyAuditFlow({ query: true });
		// 	skipProduct({
		// 		token: props.session.token,
		// 		productId: productData.isObjectionable
		// 			? undefined
		// 			: productData.productId,
		// 		consignmentNo: productData.consignment_no,
		// 		queueType,
		// 		cb: data => {
		// 			if (data.data.status == 1) {
		// 					fetchAuditUrl({
		// 						cb: data => {
		// 							fetchResolve({ data });
		// 						}
		// 					});
		// 			}
		// 		}
		// 	});
		// }
  };

  const openCloseCatSlider = (flag) => {
    updateCatSliderVisibility(flag);
  };

  const handleFocus = (e, key) => {
    // e &&
    //   e.currentTarget &&
    //   scrollIntoView(e.currentTarget, "edit-product-form");
    const newErrors = { ...errors };
    newErrors[key] = "";
    if(key == 'actualProductWeight'){
      newErrors['packageWeightGram'] = '';
    }
    if(key == 'maxSupplyCapacity') {
      newErrors['supplyTimePeriod'] = '';
    }
    updateError(newErrors);
  };
  const getVolumetricWeightFactor = (volumetricWeightType) => {
    let volumetricWeightFactors = [0,139,166,194,4000,5000,6000];
    return volumetricWeightFactors[volumetricWeightType];
  }
  const updateMessage = (tempObj = productData) => {
    let volWeight;
    const actualProdWeight = tempObj.actualProductWeight ? Number(tempObj.actualProductWeight).toFixed(2) : 0;
    if (tempObj.productLength || tempObj.productWidth || tempObj.productHeight || actualProdWeight){
        volWeight = (Number(tempObj.productLength||0) * Number(tempObj.productWidth||0) * Number(tempObj.productHeight||0)) / getVolumetricWeightFactor(volumetricWeightType || 5);
        props.updateEditProductDetail({key : 'volumetricWeight',value: volWeight});
        if (actualProdWeight > volWeight){
            setSubText('Delivery Charge is applicable on Actual Weight ('+ (actualProdWeight || 0) + ' Kg) as it is greater than Volumetric Weight ('+ (volWeight.toFixed(2) || 0) +' Kg)');
        }
        else{
            setSubText('Delivery Charge is applicable on Volumetric Weight ('+ (volWeight.toFixed(2) || 0) + ' Kg) as it is greater than Actual Weight ('+ (actualProdWeight || 0) +' Kg)');
        }
        if (volWeight == 0 && !actualProdWeight){
            setSubText('Enter Product Dimensions to Determine Applicable Delivery Charge');
        }
    }
    else{
        setSubText('Enter Product Dimensions to Determine Applicable Delivery Charge');
    }
}
  const handleChange = (e, key, options = {}) => {
    let newPriceObj = { ...productData.priceObj };
    const curData = typeof event !== "undefined" ? event.data : null;
    let value =
      options.value ||
      (key == "description" ? formatProdDesc(e.target.innerHTML)?.slice(0,8000) : e?.currentTarget?.value);
    if (key != 'productName' && otherThanEnglish.test(value)) {
      return;
    }
    if (value === "." && e?.nativeEvent?.data === ".") return;
    switch (key) {
      case "actualPrice": {
        if (!priceRegex.test(value)) {
          return;
        } else if (
          !priceRegex.test(
            (newPriceObj.actualPrice || "") + (curData || "")
            //(productData.sellingPrice || '') + (curData || '')
          )
        ) {
          return;
        }
        newPriceObj.actualPrice = value;
        if(toggleIndex == 1) {
          newPriceObj.isSinglePrice = true;
        }else {
          newPriceObj.isSinglePrice = false;
        }
        key = "priceObj";
        value = newPriceObj;
      }
        break;

      case "newconsignmentNo":
        {
          value = value.trim();
        }
        break;
      case "sellingPrice":
        {
          if (!priceRegex.test(value)) {
            return;
          } else if (
            !priceRegex.test(
              (newPriceObj.singlePrice || "") + (curData || "")
              //(productData.sellingPrice || '') + (curData || '')
            )
          ) {
            return;
          }
          newPriceObj.singlePrice = value;
          if (toggleIndex == 1) {
            newPriceObj.isSinglePrice = true;
          } else {
            newPriceObj.isSinglePrice = false;
          }
          key = "priceObj";
          value = newPriceObj;
          priceRangeQtyRef &&
            priceRangeQtyRef.updateAllSp(newPriceObj.singlePrice);
        }
        break;
      case "minOrderQuantity":
        {
          if (
            productData.uomType == "PACKED"
              ? !minQtyRegex.test(value)
              : !/^\d{0,8}(\.\d*)?$/.test(value)
          ) {
            return;
          }
        }
        break;
      case "minPrice":
        {

          if (!priceRegex.test(value)) {
            return;
          }
          newPriceObj.isSinglePrice = false;
          newPriceObj.minPrice = value;
          key = "priceObj";
          value = newPriceObj;
        }
        break;
      case "maxPrice":
        {
          if (!priceRegex.test(value)) {
            return;
          }
          newPriceObj.isSinglePrice = false;
          newPriceObj.maxPrice = value;
          key = "priceObj";
          value = newPriceObj;
        }
        break;
      case "quantity":
        {
          if (!numberRegex.test(value)) {
            return;
          }
        }
        break;
      case 'specificDuration': {
        if(!numberRegex.test(value)) return;
      }
      case "mrp":
        {
          // const err={...errors}
          const err={}
          if(value && Number((productData.sellingOnlinePrice+"").replace(/,/g,""))>Number(value)){
            err["sellingOnlinePrice"]="Higher than MRP";
          } else{
            delete err["sellingOnlinePrice"];            
            delete err["mrp"];
          }
          updateError(err)
          setInitialMrp(value)
          // if (!priceRegex.test(value)) {
          //   return;
          // }
        }
        break;
      case "sellingOnlinePrice":
        {
          // const err={...errors}
          const err={}
          let mrp1 = productData.mrp || '0';
          if(Number(value)>Number((mrp1 + '').replace(/,/g,""))){
            err["sellingOnlinePrice"]="Higher than MRP";
          } else{
            delete err["sellingOnlinePrice"]
          }
          updateError(err)
          if (!priceRegex.test(value)) {
            return;
          }
        }
        break;
      case "cost_price": {
        const err={}
          if(Number(value) < 0){
            err["cost_price"]="Invalid Cost Price";
            // updateError(err)
          } else {
            err["cost_price"]="";
          }
          updateError(err)
          if (!priceRegex.test(value)) {
            return;
          }
        break;
      }
      case "consignment_selling_price":
          {
            if (!priceRegex.test(value)) {
              return;
            }
          }
          break;
      case "consignment_mrp":
            {
              if (!priceRegex.test(value)) {
                return;
              }
            }
            break;
      case "commissionRate":
        {
          if (!commissionRegex.inputField.test(value)) {
            return;
          }
        }
        break;
      case "actualProductWeight":
        {
          if (!actualProductWeightRegex.test(value)) {
            return;
          }
        }
        break;
      case "productLength":
        {
          if (!productDimensions.inputField.test(value)) {
            return;
          }
        }
        break;
      case "productWidth":
        {
          if (!productDimensions.inputField.test(value)) {
            return;
          }
        }
        break;
      case "productHeight":
        {
          if (!productDimensions.inputField.test(value)) {
            return;
          }
        }
        break;
      case "description":
        {
          if (value=='<br>' || value=='<br/>') {
            value='';
          }
          if(value && productData.description?.length && productData.description != value) {
            props.updateDescType({descType: 3});
          }else{
            props.updateDescType({descType: value?.length ? 1 : null})
          }
          updateCount(value.length);
        }
        break;
      case "productName":
        {
          const sanitized = enforceStrictASCII(value);
          value = sanitized;
        }
      break;
    }
    setFieldValue(key, value, productData.uomType);
    if(["productHeight","productWidth","productLength","actualProductWeight"].includes(key)){
      updateMessage({...productData,[key]: value});
    }
  };

  const setFieldValue = (key, value, uomType) => {
    props.updateEditProductDetail({
      key,
      value: value,
      uomType,
    });
  };


  const showMrp = !Boolean(productData?.mrp_list?.length === 1 && parseInt(productData.mrp_list[0],10) === 0);
  const showMrpEdit = isTempProd ? false : showMrp;
  const {getMRPInput,getUpdateMRPModal,getBothCommentAndUpload,setInitialMrp}=useMRPInputField(
    showMrpEdit, // this parameter to enable new MRP inventory flow
    props,
    productData,
    isIPhone,
    styles,
    handleChange,
    handleFocus,
    errors,
    setFieldValue
  )

  const getHideMrp = () => {
    if (disableSellOnlineCustom) {
      return false;
    }

    if (isAuditor && isTemplate) {
      // return true;
    } else {
      if(!isTempProd && !isTemplate){
        return false;
      }else if(productInitialMrp!=undefined && productInitialMrp!=null && (productData?.mrp_list?.length || productData?.mrp_status === 'EMPTY_MRP_LIST')){
        return true;
      }else{
        return false;
      }
    }
  }

  const matchLowestPrice = (price) => {
    setFieldValue("sellingOnlinePrice", price.toString()?.replaceAll(',',''));
  };

  const onSelectUOM = (e, uom) => {
    const key = "unitOfMeasurement";
    let updateArr = [
      {
        key,
        value: uom.val,
        uomType: uom.uomType,
      },
    ];
    if (uom.uomType == "LOOSE") {
      updateArr.push(
        {
          key: "contentPerPiece",
          value: "",
        },
        {
          key: "unitPerPiece",
          value: "",
        }
      );
    }
    if(uom.val === 'stds'){
      updateArr.push(
        {
          key: 'specificDurationUnit',
          value: 'months',
          uomType: uom.uomType,
        },
        {
          key: 'specificDuration',
          value: ''
        }
      );
    }
    props.updateEditProductDetail(updateArr);
    const newErrors = { ...errors };
    newErrors[key] = "";
    newErrors['specificDuration'] = '';
    // if(savedUOM.current.uomType == 'LOOSE' && uom.uomType == 'PACKED' && !isAddProduct) {
    // 	newErrors[key]=showPriceRange?'Invalid Unit':'Invalid Unit Selected';
    // 	props.showToastMessage({
    // 		showToastMessage: true,
    // 		message: `Cannot Change	Unit of Measurement from Loose (`+savedUOM.current.plural+`) to Packed (`+uom.plural+`)`,
    // 		duration: 5000
    // 	});
    // }
    updateError(newErrors);
    sliderRef.current.openCloseUOMSlider(false);
  };

  const onSelectCategory = (e, catData, options = {}) => {
    let psvData = {
      type : productData.categoryType,
      psv_node_id : catData.psv_node_id
    }
    const PsvDetailsUomType = props.getPsvDetails(psvData)	
    const key = "categoryName";
    // setSelectedType(catData.otype?.toLowerCase() || "product");
    const updateProdArr = [
      {
        key,
        value: catData.psv_node_name,
      },
      {
        key: 'keywordName',
        value: catData.name
      },
      {
        key: "leafId",
        value: catData.id,
      },
      {
        key: "logistic_flag",
        value: catData.logistic_flag,
      },
      {
        key: 'jdmartids',
        value: catData?.jdmartids.toString()
      },
      ...(options.comments
        ? [
            {
              key: "categoryComment",
              value: options.comments,
            },
          ]
        : []),
    ];
    if (catData.keywordId) {
      let obj = {
        key: "keywordId",
        value: catData.keywordId,
      };
      updateProdArr.push(obj);
    }
    if (catData.psv_node_id) {
      let obj = {
        key: "psv_node_id",
        value: catData.psv_node_id,
      };
      updateProdArr.push(obj);
    }
    // if (catData.otype) {
    //   let obj = {
    //     key: "categoryType",
    //     value: catData.otype,
    //   };
    //   updateProdArr.push(obj);
    // } else {
    //   let obj = {
    //     key: "categoryType",
    //     value: "PRODUCT",
    //   };
    //   updateProdArr.push(obj);
    // }
    if (
      productData.categoryType?.toLowerCase() != catData.otype?.toLowerCase()
    ) {
      let data = { ...props.unitOfMeasurement };
      data.value = "";
      if (!data.key) {
        data.key = "unitOfMeasurement";
      }
      setCategoryChanged(true);
    } else {
      setCategoryChanged(false);
    }
    if (catData.otype?.toLowerCase() == "service") {
      toggleRange(false);
      if (priceObj && Object.keys(priceObj).length != 0) {
        priceObj.isSinglePrice = true;
        updateProdArr.push({
          key: "priceObj",
          value: priceObj,
          uomType: productData.uomType,
        });
      }
    }
    toggleShowPriceLabelModal({show: false,isVisited: false})
    props.updateEditProductDetail(updateProdArr);
    const newErrors = { ...errors };
    newErrors[key] = "";
    updateError(newErrors);
    // props.getBizList(catData.id);
    const payload = {
      data: getBusinessTypes(),
      status: 1,
    };
    props.getBizList(payload);
    closeCatSliderOnBack();
    props.resetVariantData();
    updateRemovedSpec(
      props.addRemoveSpecVariant({
        remove: false,
        data: removedSpec,
      })
    );
    props.setVariantProductData([]);
    if (PsvDetailsUomType){
      onSelectUOM('',PsvDetailsUomType.UNIT[0])
    }
  };

  const checkError = (value, key, newErrors, isError) => {
    isError =   (newErrors?.productName || newErrors?.categoryName || newErrors?.cv2ProductSource || newErrors?.businessError) ? true : isError;
    switch (key) {
      case "cv2ProductSource":
        {
          value = value.trim();
          if (!value) {
            return `${selectedType == 'service' ? 'Service' : 'Product'} Source URL cannot be blank`;
          }
          if (!Regex.urlRegex.test(value)) {
            return "Please Enter a Valid URL";
          }
        }
        break;
      case "productName":
        {
          value = value.trim();
          if (!value) {
            return `${"Please Enter"} ${productOrServiceLabel}`;
          }
          if (value.length < 3) {
            return `${productOrServiceLabel} ${"Should Have 3 or More Characters"}`;
          }
          // if (!isProductNameValid(value)){
          // 	return 'Please Enter Valid Product Name';
          // }
        }
        break;
      case "categoryName":
        {
          if (!isTemplate && !value && !isTempProd) {
            return `Please Select ${isAuditor ? "Product " : ""}Category`;
          }
        }
        break;
      case "actualPrice": {
          return checkErrorForsellingProductPrice(
            newErrors,
            isError,
            value,
            key
          )
        }
        break;
      case "sellingProductPrice":
        {
          return checkErrorForsellingProductPrice(
            newErrors,
            isError,
            value,
            key
          );
        }
        break;
      case "unitPerPiece":
        {
          if (!value) {
            if (productData.contentPerPiece) {
              updateMoreFields(true);
              return "Please Select Unit";
            }
          }
        }
        break;
      case "priceRange":
        {
          return checkErrorForPriceRange(newErrors, isError);
        }
        break;
      case 'specificDuration':{
        return checkErrorForspecificDuration(newErrors, isError, value, key);
      }
      case "countryOfOrigin":
        {
          if (
            !(isAuditor && isObjectionableQueue) &&
            !selectedCountry.countryCode &&
            selectedType == "product" &&
            showSellOnline && !(isAuditor && isObjectionableQueue)
          ) {
            return "";
          }
        }
        break;
      case "singleBatchSellOnline":
        {
          if (!isVariant && ((isAuditor && !isTemplate) || !isAuditor)) {
            return checkErrorForSingleBatch(newErrors, isError);
          }
        }
        break;
      case "auditorMrpBatchSellOnline":
          {
            if (!isVariant) {
              return checkErrorForAuditorMrpSingleBatch(newErrors,isError);
            }
          }
      break;
      case "commissionRate":
        {
          if (showSellOnline) {
            if (!productData.commissionRate) {
              return "Please Enter the Commission Rate";
            } else if (
              productData.commissionRate &&
              !commissionRegex.validation.test(productData.commissionRate)
            ) {
              return "Commission Rate Must be Less than 100";
            }
          }
        }
        break;
      case "actualProductWeight":
        {
          if (showSellOnline && !productData.actualProductWeight && !(isAuditor && isObjectionableQueue)) {
            return "Please Enter the Packaged Weight";
          }
        }
        break;
      case "maxSupplyCapacity": {
        if(!maxSupplyCapacity && (supplyTimePeriod && supplyTimePeriod != 'selectPeriod') && productOrService != 'service') {
          return "Please Select Max Sup. Capacity";
        }
      }
        break;
      case "supplyTimePeriod": {
        if(maxSupplyCapacity && (!supplyTimePeriod || supplyTimePeriod == 'selectPeriod') && productOrService != 'service'){
          return 'Please Select Period';
        }
      }
        break;
      case "packageDimensions":
        {
          if(!(isAuditor && isObjectionableQueue)){
            return checkErrorForProductDimensions(newErrors, isError);
          }else {
            return ""
          }
        }
        break;
      case "packageWeight":
        {
          if (showSellOnline && !(isAuditor && isObjectionableQueue)) {
            if(productData.actualProductWeight && Number(productData.actualProductWeight) === 0){
              return "Packaged Product Weight Must be Greater than Zero "+(productData?.packUnit?productData?.packUnit:'Kg');
            }else if((productData?.packUnit == 'Gm'? Number(productData.actualProductWeight) > 10000:Number(productData.actualProductWeight) > 10) && productData?.logistic_flag =="1"){
              let txt = (productData?.packUnit?productData?.packUnit:'Kg');
              txt = txt == 'Gm'? '10000 Gms':'10 Kgs';
              return "Packaged Weight of the Selected Product Category Cannot Exceed "+txt;
            }
          }
        }
        break;
        case "cost_price": {
            if(Number(value) < 0){
              return "Invalid Cost Price";
            } else {
              return false;
            }
          break;
        }
    }
    return false;
  };

  const checkErrorForsellingProductPrice = (newErrors, isError, value, key) => {
    let isErrorTmp = false,
      errorMsg = "";
      if(key == 'actualPrice' && toggleIndex == 1 && selectedType == 'service') {
        if(priceObj.actualPrice && Number(priceObj.actualPrice) == 0){
          errorMsg = 'Actual Price Cannot be 0';
          isErrorTmp = true;
          newErrors['actualPrice'] = errorMsg;
        }
        else if(priceObj.actualPrice && Number(priceObj.actualPrice) < 0.01){
          isErrorTmp = true;
          errorMsg = "Actual Price must be at least 0.01"
          newErrors['actualPrice'] = errorMsg;
          if(Number(priceObj.singlePrice) < 1){
            newErrors['sellingPrice'] = errorMsg
          }
        }
      } else {
        if (!priceObj.singlePrice && toggleIndex == 3) {
          errorMsg = "Please Enter Price";
          isErrorTmp = true;
          newErrors["sellingPrice"] = errorMsg;
        } else if (
          priceObj.singlePrice &&
          (priceObj.singlePrice == 0  || Number(priceObj.singlePrice) < 0.01) &&
          toggleIndex != 2 && !showSellOnline
        ) {
          if(Number(priceObj.singlePrice) == 0){
            errorMsg = `${toggleIndex == 1 && selectedType == 'service' ? 'Discounted' : ''} Price Cannot be 0`;
          }else {
            errorMsg = "Price must be at least 0.01"
          }
          isErrorTmp = true;
          newErrors["sellingPrice"] = errorMsg;
        } else if (priceObj.singlePrice && Number(priceObj.singlePrice) < 0.01 && toggleIndex != 2) {
          errorMsg = toggleIndex == 1 && selectedType == 'service' ? "Discounted Price must be at least 0.01" : "Price must be at least 0.01";
          isErrorTmp = true;
          newErrors["sellingPrice"] = errorMsg;
        }else if(priceObj.actualPrice && Number(priceObj.singlePrice) > Number(priceObj.actualPrice) && toggleIndex == 1 && selectedType == 'service') {
          errorMsg = 'Discounted Price Cannot be More than Actual Price';
          isErrorTmp = true;
          newErrors['sellingPrice'] = errorMsg;
          newErrors['actualPrice'] = true;
        } 
      }
    if(!isError && isErrorTmp) {
      isError = true;
      dispatch(
        toastMessageActions.showMessage({
          message: errorMsg,
          type: "error",
          showReduxToast: true,
          duration: 5000,
        })
      );
    }
    return isError;
  };
  const checkErrorForspecificDuration = (newErrors, isError, value, key) => {
    let errorField = "",
      errorMsg = "";
   if(props.unitOfMeasurement?.val === 'stds' && productData?.specificDuration === '0'){
      if (!isError) {
        dispatch(
          toastMessageActions.showMessage({
            message: 'Specific Time Duration must be Greater than 0',
            type: "error",
            showReduxToast: true,
            duration: 5000,
          })
        );
      }
      isError = true;
      newErrors["specificDuration"] = " ";
    }
    return isError;
  };

  const checkErrorForSingleBatch = (newErrors, isError) => {
    let errorField = "";
    newErrors.sellingOnlinePrice = '';
    newErrors.quantity = '';
    newErrors.mrp = '';
    if (!isAuditor) {
      if (productData.quantity && Number(productData.quantity) > 100) {
        let msg = 'In-stock Quantity Cannot be More than 100';
        newErrors['quantity'] = 'Cannot be More than 100';
        errorField = msg;
      }
    }

    if (productData.mrp && Number(productData.mrp) == 0) {
      let msg = "Cannot be 0";
      newErrors["mrp"] = msg;
      if (!errorField) {
        errorField = "MRP Value " + msg;
      }
    } else if (!productData.mrp) {
      let msg = "Enter MRP";
      newErrors["mrp"] = msg;
      if (!errorField) {
        errorField = msg;
      }
    } else if (productData.mrp && Number(productData.mrp) < 0.01) {
      let msg = "Invalid value";
      newErrors["mrp"] = msg;
      if (!errorField) {
        errorField = "MRP Value must be at least 0.01";
      }
    }
    
    if ( productData.sellingOnlinePrice && Number(productData.sellingOnlinePrice) == 0) {
      let msg = "Cannot be 0";
      newErrors["sellingOnlinePrice"] = msg;
      if (!errorField) {
        errorField = "Selling Price Value " + msg;
      }
    } else if (!productData.sellingOnlinePrice) {
      let msg = "Enter Price";
      newErrors["sellingOnlinePrice"] = msg;
      if (!errorField) {
        errorField = msg;
      }
    } else if (productData.sellingOnlinePrice && Number(productData.sellingOnlinePrice) < 0.01) {
      let msg = "Invalid value";
      newErrors["sellingOnlinePrice"] = msg;
      if (!errorField) {
        errorField = "Selling Price Value must be at least 0.01";
      }
    } else if (
      productData.mrp &&
      Number(productData.sellingOnlinePrice?.toString()?.replaceAll(',','')) > Number(productData.mrp?.toString()?.replaceAll(',',''))
    ) {
      let msg = "Higher than MRP";
      newErrors["sellingOnlinePrice"] = msg;
      if (!errorField) {
        errorField = "Selling Price Cannot be Higher than MRP";
      }
    }

    if (
      !isAuditor &&
      ((!productData.quantity && isAddProduct) ||
        (!productData.quantity &&
          productData.quantity != "0" &&
          !isAddProduct)) &&
      !productData.mrp &&
      !productData.sellingOnlinePrice
    ) {
      let msg = "Please Enter Quantity and Price";
      newErrors["quantity"] = "allSellFieldEmpty";
      newErrors["mrp"] = "allSellFieldEmpty";
      newErrors["sellingOnlinePrice"] = "allSellFieldEmpty";
      errorField = msg;
    }
    if (!isError && errorField) {
      dispatch(
        toastMessageActions.showMessage({
          message: errorField,
          type: "error",
          showReduxToast: true,
          duration: 5000,
        })
      );
    }
    if (errorField) {
      return true;
    } else {
      return isError;
    }
  };

  const getDateObj = (dateString) => {
    if(dateString)
    {
        var dateParts = dateString.split('/');
        // month is 0-based, that's why we need dataParts[1] - 1
        var dateObj = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        return(dateObj);
    }
}
  const checkErrorForAuditorMrpSingleBatch = (newErrors, isError) => {
    let errorField = "";
    newErrors.consignment_selling_price = '';
    newErrors.consignment_mrp = '';

    if (productData.consignment_mrp && Number(productData.consignment_mrp) == 0) {
      let msg = "Cannot be 0";
      newErrors["consignment_mrp"] = msg;
      if (!errorField) {
        errorField = "MRP Value " + msg;
      }
    } else if (!productData.consignment_mrp) {
      let msg = "MRP Cannot be empty";
      newErrors["consignment_mrp"] = msg;
      if (!errorField) {
        errorField = msg;
      }
    } else if (productData.consignment_mrp < 2) {
      let msg = "Invalid value";
      newErrors["consignment_mrp"] = msg;
      if (!errorField) {
        errorField = "MRP Value is Invalid";
      }
    }
    if (productData.consignment_selling_price && Number(productData.consignment_selling_price) == 0) {
      let msg = "Cannot be 0";
      newErrors["consignment_selling_price"] = msg;
      if (!errorField) {
        errorField = "Selling Price Value " + msg;
      }
    } else if (!productData.consignment_selling_price) {
      let msg = "Selling Price Cannot be empty";
      newErrors["consignment_selling_price"] = msg;
      if (!errorField) {
        errorField = msg;
      }
    } else if (productData.consignment_selling_price < 2) {
      let msg = "Invalid value";
      newErrors["consignment_selling_price"] = msg;
      if (!errorField) {
        errorField = "Selling Price Value is Invalid";
      }
    } else if (
      productData.mrp &&
      Number(productData.consignment_selling_price?.toString()?.replaceAll(',','')) > Number(productData.consignment_mrp?.toString()?.replaceAll(',',''))
    ) {
      let msg = "Higher than MRP";
      newErrors["consignment_selling_price"] = msg;
      if (!errorField) {
        errorField = "Selling Price Cannot be Higher than MRP";
      }
    }

    if (
      !isAddProduct &&
      !productData.consignment_mrp &&
      !productData.consignment_selling_price
    ) {
      let msg = "Please Enter Price";
      newErrors["consignment_mrp"] = "allSellFieldEmpty";
      newErrors["consignment_selling_price"] = "allSellFieldEmpty";
      errorField = msg;
    }
    if (!isError && errorField) {
      dispatch(
        toastMessageActions.showMessage({
          message: errorField,
          type: "error",
          showReduxToast: true,
          duration: 5000,
        })
      );
    }
    if (errorField) {
      return true;
    } else {
      return isError;
    }
  };

  const getHistoryObj = (obj) => {
      const historyNum = history.length - preHistory
      if (historyNum == 0) {
        window.history.back()
      }else if (historyNum == 1) {
        props?.isAddProductSlider ? history.go(-2) : window.history.back()
      }else {
        if (obj == 'reject'){
          history.go(-historyNum)
        } else if (obj == 'save') {
            window.history.back()
        }else {
          history.go(-(historyNum+1))
        }
        // history.go(-2)
      }
      dispatch(toggleAddProductSlider({isAddProductSlider:false}));
  }

  const checkErrorForExpiryBatch = (newErrors, isError) => {
    let toastMessage = '';
    const currentDate = new Date();
    if(!productData.newconsignmentNo && !props.session.viaOmni) {
      toastMessage = 'Please Enter Batch / Lot Number';
      newErrors.newconsignmentNo = 'Please Enter Batch / Lot Number'
    }else if(productData?.newconsignmentNo?.length < 4) {
      toastMessage = "Batch Lot Number must be at least 4 characters long";
      newErrors.newconsignmentNo = "Batch Lot Number must be at least 4 characters long";
    }
    if (!productData.manufacturing_date && productData.expiryBy != 'expiry_date' && !props.session.viaOmni) {
        toastMessage = toastMessage ? toastMessage : 'Please Enter Manufacturing Date';
        newErrors.manufacturing_date = 'Please Enter Manufacturing Date';
    }else if (productData.expiryBy == 'manufacturing_date'){
        if (!productData.best_before && !props.session.viaOmni) {
            toastMessage = toastMessage ? toastMessage : 'Please Enter Best Before';
            newErrors.best_before = 'Please Enter Best Before';
        }else if(productData.manufacturing_date && (productData.best_before == '0' || productData.best_before == '' || productData.best_before == null)) {
            toastMessage = toastMessage ? toastMessage : 'Please Enter Best Before';
            newErrors.best_before = 'Please Enter Best Before';
        } else {
            let value = getDateObj(productData.manufacturing_date);
            if(value){
              currentDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds())
              //Ignore time param while comparing two dates.

              var expDateByBestBefore = new Date(currentDate);
              var bestBeforeInDays = Number(productData.best_before);
              var bestBeforeUnit = productData.bestBeforeUnit || 'months';
              if(bestBeforeUnit == 'months'){
                bestBeforeInDays = bestBeforeInDays * 30;
              }else if(bestBeforeUnit == 'years'){
                  bestBeforeInDays = bestBeforeInDays * 365;
              }
              expDateByBestBefore.setTime( value.getTime() + bestBeforeInDays * 86400000 );
              if(currentDate < value) {
                toastMessage = toastMessage ? toastMessage : 'You have Entered Future Date as Manufacturing Date';
                newErrors.manufacturing_date = 'You have Entered Future Date as Manufacturing Date';
              }else if(currentDate > expDateByBestBefore) {
                toastMessage = toastMessage ? toastMessage : 'Product has Already Expired.';
                newErrors.manufacturing_date = 'Product has Already Expired.';
              }
            }
        }
    }else {
      let value = getDateObj(productData.expiry_date);
      if(value){
        currentDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds())
        //Ignore time param while comparing two dates.
      }
      if (currentDate > value) {
        toastMessage = toastMessage ? toastMessage :"You have Entered Expired Date";
        newErrors.expiry_date = 'You have Entered Expired Date';
      }
    }
    if (!isError && toastMessage) {
      dispatch(
        toastMessageActions.showMessage({
          message: toastMessage,
          type: "error",
          showReduxToast: true,
          duration: 5000,
        })
      );
    }
    if (toastMessage) {
      return true;
    } else {
      return isError;
    }
  }

  const checkErrorForImporter = (newErrors, isError) => {
    let errorField = "";
    props.sendBMDetails.forEach((cur) => {
      if (props.auditData.checkedValue != 'productRejected' &&
        props.auditData.checkedValue != 'PRODUCT_REJECTED_FOR_LABEL'){
        if (
          !(isAuditor && isObjectionableQueue) &&
          selectedCountry.countryCode &&
          selectedCountry.countryCode != "IN"
        ) {
            let importerArrayString = cur.values.join("");
            if (
              ["importer", "importers_detail"].includes(cur.name) &&
              !importerArrayString
            )
             {
              newErrors["ImporterDetails"] = "Please Enter Importer Details";
              errorField = errorField
                ? errorField
                : "Please Enter Importer Details";
             }
          }
        }
      });
        if (!isError && errorField) {
          dispatch(
            toastMessageActions.showMessage({
              message: errorField,
              type: "error",
              showReduxToast: true,
              duration: 5000,
            })
          );
        }
        if (errorField) {
          return true;
        } else {
          return isError;
        }
    }

  const checkErrorForManufactImport = (newErrors, isError) => {
    let errorField = "";
    props.sendBMDetails.forEach((cur) => {
      if (
        !(isAuditor && isObjectionableQueue) && (
        (productData.categoryName && props.isBrandSpecIndex) ||
        productData.compliance?.manufacturer ||
          productData.compliance?.manufactured_details ||
        isTemplate ||
        isTempProd ||
        isBrandedProduct
      )) {
        if (
          (productData.categoryName && props.isBrandSpecIndex) ||
          productData.compliance?.manufacturer ||
            productData.compliance?.manufactured_details ||
          isTemplate ||
          isTempProd ||
          isBrandedProduct
        ) {
          if (
            showSellOnline &&
            cur.name === "brand" &&
            !cur.values[0] &&
            !(isTempProd || isTemplate || isBrandedProduct)
            && !props.session.viaOmni
          ) {
            newErrors["brandName"] = "Please Enter Brand";
            errorField = "Please Enter Brand";
          }
          if (showSellOnline &&
            ["manufacturer", "manufactured_details"].includes(cur.name) &&
            !cur.values[0] && (props.brandManufacturer.manuFacturerMand || productData.isManufacturerMand)
            && !props.session.viaOmni
          ) {
            newErrors["manufacturerDetails"] =
              "Please Enter Manufacturer Details";
            errorField = errorField
              ? errorField
              : "Please Enter Manufacturer Details";
          }
        }
      }});

    if (!isError && errorField) {
      dispatch(
        toastMessageActions.showMessage({
          message: errorField,
          type: "error",
          showReduxToast: true,
          duration: 5000,
        })
      );
    }
    if (errorField) {
      return true;
    } else {
      return isError;
    }
  };

const checkErrorForProductDimensions = (newErrors, isError) => {
    if ((!showSellOnline && !isContractorV1V2) || (props.hideLBH && (isTempProd || isTemplate))) {
      return;
    }
    let errorMsg = [
      "Please Enter the Dimensions",
      "Dimension value should be greater than 0.5 cm",
    ];
    let errorField = "";
    if (
      !productData.productHeight &&
      !productData.productWidth &&
      !productData.productLength &&
      isContractorV1V2 &&
      !showSellOnline
    ) {
      newErrors["productHeight"] = "";
      newErrors["productWidth"] = "";
      newErrors["productLength"] = "";
      return isError;
    }
    if (productData.productHeight && productData.productHeight <= 0.5) {
      newErrors["productHeight"] = errorMsg[1];
      errorField =
        "Product Packaging Dimension value should be greater than 0.5 cm";
    }
    if (productData.productWidth && productData.productWidth <= 0.5) {
      newErrors["productWidth"] = errorMsg[1];
      errorField =
        "Product Packaging Dimension value should be greater than 0.5 cm";
    }
    if (productData.productLength && productData.productLength <= 0.5) {
      newErrors["productLength"] = errorMsg[1];
      errorField =
        "Product Packaging Dimension value should be greater than 0.5 cm";
    }
    if (!isError && errorField) {
      dispatch(
        toastMessageActions.showMessage({
          message: errorField,
          type: "error",
          showReduxToast: true,
          duration: 5000,
        })
      );
    }
    if (errorField) {
      return true;
    } else {
      return isError;
    }
  };

  const checkErrorForPriceRange = (newErrors, isError) => {
    let errorField = "",
    errorMsg = "";
    if (toggleIndex == 2) {
      if (priceObj.minPrice!='' && priceObj.minPrice!=null && (Number(priceObj.minPrice < 0.01))) {
        errorMsg = Number(priceObj.minPrice) == 0 ?  "Min. Price Cannot be 0" : "Min. Price must be at least 0.01";  
        newErrors["minPrice"] = errorMsg;
      }
      if (priceObj.maxPrice!='' && priceObj.maxPrice!=null && (Number(priceObj.maxPrice < 0.01))) {
        if (!errorMsg) {
          errorMsg = Number(priceObj.maxPrice) == 0 ?  "Max. Price Cannot be 0" : "Min Price must be at least 0.01"; 
          newErrors["maxPrice"] = errorMsg;  
        } else {
          newErrors["maxPrice"] = false;
        }         
      }
      if (!isError && errorMsg) {
        dispatch(
          toastMessageActions.showMessage({
            message: errorMsg,
            type: "error",
            showReduxToast: true,
            duration: 5000,
          })
        );
        isError = true;
      }
    }
  
    if (
      (priceObj.minPrice == null ||
        priceObj.minPrice === "" ||
        priceObj.minPrice === undefined ||
        priceObj.minPrice === 0) &&
      (priceObj.maxPrice == null ||
        priceObj.maxPrice === "" ||
        priceObj.maxPrice === undefined ||
        priceObj.maxPrice === 0) &&
      priceObj.isSinglePrice
    ) {
      let newPriceObj = { ...priceObj };
      newPriceObj.isSinglePrice = toggleIndex == 1;
      newErrors["minPrice"] = false;
      newErrors["maxPrice"] = false;
      props.updateEditProductDetail({
        key: "priceObj",
        value: newPriceObj,
        uomType: props.productData.uomType,
      });
    } else if (!priceObj.minPrice && !priceObj.maxPrice && (toggleIndex == 2 || showSellOnline && showBulkSell)) {
      errorMsg = " ";
      if (!isError) {
        dispatch(
          toastMessageActions.showMessage({
            message: "Please Enter Minimum Price",
            type: "error",
            showReduxToast: true,
            duration: 5000,
          })
        );
      }
      isError = true;
      newErrors["minPrice"] = errorMsg;
      newErrors["maxPrice"] = errorMsg;
    } else if (
      (!priceObj.minPrice || (!priceObj.maxPrice && priceObj.minPrice != 0)) &&
      (toggleIndex == 2 || showSellOnline && showBulkSell)
    ) {
      // errorMsg = !priceObj.minPrice ? 'Enter Min. Price' : 'Enter Max. Price';
      errorMsg = " ";
      errorField = !priceObj.minPrice ? "minPrice" : "maxPrice";
      let toastError = !priceObj.minPrice ? " Minimum Price" : " Maximum Price";
      if (!isError) {
        dispatch(
          toastMessageActions.showMessage({
            message: "Please Enter " + toastError,
            type: "error",
            showReduxToast: true,
            duration: 5000,
          })
        );
      }
      isError = true;
      if (errorField == "minPrice") {
        newErrors[errorField] = errorMsg;
        newErrors["maxPrice"] = false;
      } else if (errorField == "maxPrice") {
        newErrors[errorField] = errorMsg;
        newErrors["minPrice"] = false;
      }
    } else if (
      ((priceObj.minPrice && priceObj.minPrice == 0) ||
        (priceObj.maxPrice && priceObj.maxPrice == 0)) || (priceObj.minPrice && priceObj.minPrice < 0.01) || (priceObj.maxPrice && priceObj.maxPrice < 0.01)  &&
      (toggleIndex == 2 || showSellOnline && showBulkSell)
    ) {
      if(priceObj.minPrice == 0 || priceObj.maxPrice == 0){
        errorMsg =
          priceObj.minPrice == 0
            ? "Min. Price Cannot be 0"
            : "Max. Price Cannot be 0";
      }else {
        errorMsg = priceObj.minPrice < 0.01 ? "Min. Price must be at least 0.01" : "Max. Price must be at least 0.01"; 
      }
      if (!isError) {
        dispatch(
          toastMessageActions.showMessage({
            message: errorMsg,
            type: "error",
            showReduxToast: true,
            duration: 5000,
          })
        );
      }
      isError = true;
      if (Number(priceObj.minPrice) < 0.01) {
        newErrors["minPrice"] = errorMsg;
        if(Number(priceObj.maxPrice) <= 1){
          newErrors["maxPrice"] = " ";
        }else {
          newErrors["maxPrice"] = false;
        }
      } else if (priceObj.maxPrice < 0.01) {
        newErrors["maxPrice"] = errorMsg;
        if(Number(priceObj.minPrice) < 1){
          newErrors["minPrice"] = " ";
        }else {
          newErrors["minPrice"] = false;
        }
      }
    } else if (
      priceObj.minPrice !== "" &&
      priceObj.maxPrice !== "" &&
      (toggleIndex == 2 || showSellOnline && showBulkSell)
    ) {
      if (Number(priceObj.minPrice) >= Number(priceObj.maxPrice)) {
        errorMsg = " ";
        if (!isError) {
          dispatch(
            toastMessageActions.showMessage({
              message:
                "Maximum Price Cannot be Same or Less Than Minimum Price",
              type: "error",
              showReduxToast: true,
              duration: 5000,
            })
          );
        }
        isError = true;
        newErrors["minPrice"] = errorMsg;
        newErrors["maxPrice"] = errorMsg;
      } else {
        delete newErrors["minPrice"];
        delete newErrors["maxPrice"];
      }
    }
    if (priceObj.minPrice && Number(priceObj.minPrice) < 0.01 && (toggleIndex == 2 || showSellOnline && showBulkSell)) {
      errorMsg =  Number(priceObj.minPrice) == 0 ? newErrors.minPrice : "Min. Price must be at least 0.01";
      if (!isError) {
        dispatch(
          toastMessageActions.showMessage({
            message: errorMsg,
            type: "error",
            showReduxToast: true,
            duration: 5000,
          })
        );
      }
      isError = true;
    }    
    return isError;
  };

  const checkErrorForMinOrder = (value,key,newErrors,isError) => {
    if (priceRangeQtyRef && ((toggleIndex == 3 && !showSellOnline) || (showSellOnline && showBulkSell)) &&
      Number(priceRangeQtyRef?.state?.sellOnlineFormData[0]?.minimumQuantity) > 0 &&
      Number(priceRangeQtyRef?.state?.sellOnlineFormData[0]?.minimumQuantity) <
        Number(productData?.minOrderQuantity)
    ) {
      newErrors["minOrderQuantity"] =
            "Min. Order Quantity Needs to be Same or Less than Minimum Qty. Range";
        if(!isError) {
          dispatch(
            toastMessageActions.showMessage({
              message: "Min. Order Quantity Needs to be Same or Less than Minimum Qty. Range",
              type: "error",
              showReduxToast: true,
              duration: 5000,
              cb: (status) => scrollToError(status, 'minOrderQuantity'),
            })
          );
        }
        updateError({
          ...errors,
          ...newErrors
        })
        return true;
      } else {
        newErrors["minOrderQuantity"] = "";
        updateError({
          ...errors,
          ...newErrors
        });
        return false;
      }
  }
  const saveEditBrandProduct = () => {
    if (!saveButtonStatus.current) {
      saveButtonStatus.current = "disabled";
    } else {
      return;
    }
    console.log("Saveedit");
    let data = { ...props.productData };
    props.updateBrandedProduct({
      productData: data,
      isEditSave: true,
      cb: () => {
        dispatch(
          toastMessageActions.showMessage({
            message: `Product ${
              isAddProduct ? "Added" : "Updated"
            } Successfully`,
            showReduxToast: true,
            duration: 5000,
          })
        );
        if (props.deviceData.isMobile) {
          setRouteChangeMessage({
            message: `Product ${
              isAddProduct ? "Added" : "Updated"
            } Successfully`,
          });
        }
        saveButtonStatus.current = "saved";
        history.goBack();
      },
    });
  };

  const saveData = async (options = {}) => {
    let priceRangeQtyError;
    let rejectionCheck = false;
    const isRejection = (props.auditData.checkedValue == 'productRejected' || props.auditData.checkedValue == 'PRODUCT_REJECTED_FOR_LABEL');
    // if (isAuditor && isRejection) {
    //   if (props.auditData.rejectionMessage) {
    //       rejectionCheck = true
    //   }
    // }
    dispatch(toastMessageActions.hideMessage());
    if (isBrandedProduct) {
      saveEditBrandProduct();
      return;
    }

    const newErrors = { ...errors };
    let isError = false;

    if (
      (
        (productData.showUpload === 1 ? (isTemplate || isTempProd) :
        (!isTempProd && !isTemplate))
   ) &&
   !props.session.viaOmni &&
   !props.variantImagesLength &&
   (!isVariant || productOrService == 'service') &&
   !(isAuditor && isObjectionableQueue)
    ) {
      props.showToastMessage({
        showToastMessage: true,
        message:
          productOrService == "product"
            ? "Please Upload Product Image"
            : "Please Upload Service Image",
        type: "error",
        cb: (status) => {
          // scrollToError(status, 'image')
          status == 'open' && (props.deviceData.isMobile && window || document && document.querySelector('[body-scroll-lock-ignore="true"]')).scrollTo({ top: 0, behavior: "smooth" });
        }
        // setTimeout(() => {
        //
        // }, 100),
      });
      isError = true;
      newErrors["image"] =
        productOrService == "product"
          ? "Please Upload Product Image"
          : "Please Upload Service Image";
    }
    if(props.imagesBeingUploaded.length){
      props.showToastMessage({
          showToastMessage: true,
          message: 'Please wait Image Upload is in Progress',
  type: 'info',
          duration: 5000
      });
      return;
  }
  
  if (
    props.productData.bizSuggestion &&
    props.productData.bizSuggestion.data
    ) {
    let selected = false;
    if (props.productData.bizSuggestion.bizType) {
      selected = true;
    }
    if (!isRejection || props.session.viaOmni) {
      if (
        !selected &&
        !props.session.businessType &&
        selectedType != "service" 
      ) {
        newErrors["businessError"] = "Please Select Business Type";
        if (!isError) {
          dispatch(
            toastMessageActions.showMessage({
              message: "Please Select Business Type",
              type: "error",
              showReduxToast: true,
              animationTime: 5000,
            })
          );
          isError = true;  
        }          
      }
    }
  }
    if (!(isAuditor && isObjectionableQueue)) {
      let variantError = productOrService == 'product' ? props.validateVariants().errorMsg : props.validateVariantsService().errorMsg;
      if (isVariant && variantError) {
        props.showToastMessage({
          message: variantError,
          type: "error",
        });
        return;
      }
    }

    if (showPriceRange) {
      priceObj.isSinglePrice = false;
      //isError = checkErrorForPriceRange(priceObj, isError);
      isError = checkErrorForMinOrder('', '', newErrors, false);
    } else {
      priceObj.isSinglePrice = toggleIndex == 1;
      setFieldValue("priceObj", priceObj, props.productData.uomType);
    }

    let labelErr = '';
    let formError=false;
    [...formElements, ...moreElements].forEach((cur) => {
      if (cur.checkError && !cur.hide) {
        if (cur.priceRange) {
          if (!showSellOnline) {
            formError = cur.checkError("", newErrors, formError);
            isError = formError;
          }
        } else if (cur.packageDimensions) {
          if (showSellOnline || isContractorV1V2) {
            formError = cur.checkError("", newErrors, formError);
          }
        } else if (cur.singleBatchSellOnline) {
          if (showSellOnline) {
            formError = cur.checkError("", newErrors, formError);
          }
        } else if (cur.sellingProductPrice) {
          if (!newErrors.categoryName) {
            formError = cur.checkError("", newErrors, formError);
          }
        }else if (cur.expiryBatch) {
          formError = cur.checkError("",newErrors,formError);
        }else if(cur.key == 'packageWeightGram') {
          newErrors['actualProductWeight'] = cur.checkError(productData.actualProductWeight,newErrors,formError);
          newErrors[cur.key] = newErrors['actualProductWeight'];
        }else if(cur.key === 'specificDuration'){
          formError = cur.checkError("", newErrors , formError);
        } else if(cur.key == 'minOrderQuantity') {
          formError = cur.checkError("","minOrderQuantity",newErrors,isError);
        } else if(cur.key === 'maxSupplyCapacity') {
          newErrors[cur.key] = cur.checkError("","maxSupplyCapacity",newErrors,formError);
          newErrors["supplyTimePeriod"] = cur.checkError("","supplyTimePeriod",newErrors,formError);
        }else if(cur.importer) {
          formError = cur.checkError("",newErrors, formError || isError);
        } else {
          newErrors[cur.key] = cur.checkError(cur.input.value);
        }

        // if(newErrors[cur.key] || newErrors["supplyTimePeriod"]) {
        //   isError=true;
        // }
        // newErrors[cur.key] = cur.checkError(cur.input.value);
        if (newErrors[cur.key] || (cur.singleBatchSellOnline && (newErrors["quantity"] || newErrors["mrp"] || newErrors["sellingOnlinePrice"] )) || (cur.key == 'maxSupplyCapacity' && newErrors['supplyTimePeriod'])) {
          if (!isRejection){
            if ((!formError && !isError && (!newErrors['productName'] && !newErrors['businessError'])) || (cur.key=="productName" && newErrors[cur.key] && !newErrors['image'])) {
              dispatch(
                toastMessageActions.showMessage({
                  message: newErrors[cur.key] || newErrors['supplyTimePeriod'],
                  type: "error",
                  showReduxToast: true,
                  duration: 5000,
                  cb: (status) => scrollToError(status, cur.key),
                })
              );
              isError = true;
            }
          }
        }
      }
    });

    isError=isError || !!formError

    
    if(props.session.viaOmni && showSellOnline && productData['expiryBy'] == 'manufacturing_date') {
      if(productData['best_before'] && !productData['manufacturing_date']) {
        newErrors["manufacturing_date"] = "Please enter valid manufacturing date";
        dispatch(
          toastMessageActions.showMessage({
            message: "Please enter valid manufacturing date",
            type: "error",
            showReduxToast: true,
            animationTime: 5000,
          })
        );
        isError = true;
      }
      
    }

    if (priceRangeQtyRef && toggleIndex == 3 && !showSellOnline || showSellOnline && showBulkSell) {
      priceRangeQtyError = priceRangeQtyRef.verifyRanges();
      isError = !isError ? checkErrorForMinOrder('', '', newErrors, false) : isError;
      if(showSellOnline && showBulkSell && priceRangeQtyError && !isError) {
        isError = checkErrorForPriceRange({}, isError);        
      }
      if (newErrors["sellingPrice"]) {
        if (!isError) {
          dispatch(
            toastMessageActions.showMessage({
              message: newErrors["sellingPrice"],
              type: "error",
              showReduxToast: true,
              animationTime: 5000,
            })
          );
          isError = true;
        }
        if (
          Number(priceRangeQtyRef.state.sellOnlineFormData[0].minimumQuantity) > 0 &&
          Number(priceRangeQtyRef.state.sellOnlineFormData[0].minimumQuantity) <
            Number(productData.minOrderQuantity)
        ) {
          newErrors["minOrderQuantity"] =
            "Min. Order Quantity Needs to be Same or Less than Minimum Qty. Range";
        }
      } else {
        if (priceRangeQtyError && !isError) {
          dispatch(
            toastMessageActions.showMessage({
              message: priceRangeQtyError,
              type: "error",
              showReduxToast: true,
              animationTime: 5000,
            })
          );
          isError = true;
        }
        if (
          Number(priceRangeQtyRef.state.sellOnlineFormData[0].minimumQuantity) > 0 &&
          Number(priceRangeQtyRef.state.sellOnlineFormData[0].minimumQuantity) <
            Number(productData.minOrderQuantity)
        ) {
          // if(!isError || newErrors['minOrderQuantity']) {
          //   dispatch(
          //     toastMessageActions.showMessage({
          //       message:
          //         "Min. Order Quantity Needs to be Same or Less than Minimum Qty. Range",
          //       type: "error",
          //       showReduxToast: true,
          //       animationTime: 5000,
          //     })
          //   );
          //   isError = true;
          // }
        }
      }
    }
    let specError = '';
    let specCheck = false;
    let cntNotFilledSpecs = [];
    let filledSpecs = [];
    let apiSpecsData = props.productSpecification?.savedPuvSpecAttributes?.length ? props.productSpecification?.savedPuvSpecAttributes : props.productSpecification?.editablePuvSpecAttributes;
    for(var index = 0 ; index < apiSpecsData?.length ; index ++){
      var spec = apiSpecsData[index];
      var ignoreSpecAI = ['manufacturer','manufactured_details','importer','importers_detail','price','country_of_origin','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date'];
      if(!ignoreSpecAI.includes(spec.s_nm.toLowerCase())) {
        if(!spec.userInput.value && spec.s_type != 'Fixed') {
          cntNotFilledSpecs.push(spec);
        }else if(spec.s_type != 'Fixed'){
          filledSpecs.push({
            [spec.s_dnm]: spec.userInput.value
          })
        }
      }
    }
    let installCheck = showSellOnline && (props.productSpecification.installationFlag || productData.showInstall) && !props.installData[0].values.length;
    let brandCheck = false;
    if(productData.hasCompliance && showSellOnline) {
      props.editablePuvSpecAttributes.map(cur => {
        if(!['brand','manufacturer','manufactured_details','importer','importers_detail','price','country_of_origin','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date'].includes(cur.s_nm.toLowerCase()) && !cur.userInput.value && cur.s_type != 'Fixed') {
            brandCheck = true;
        }
      })
      brandCheck && props.savedPuvSpecAttributes.map(cur => {
        if(!['brand','manufacturer','manufactured_details','importer','importers_detail','price','country_of_origin','packaging_width','packaging_height','packaging_length','packaging_weight','expiry_date'].includes(cur.s_nm.toLowerCase()) && !cur.userInput.value && cur.s_type != 'Fixed') {
          brandCheck = true;
        }
      })
    }
    // if(productOrService == 'product' && (( brandCheck && (isTempProd || isTemplate)) || ((specCheck || installCheck)))){
    //   specError = "Please Enter Mandatory Specifications";
    // }
    // if (specError && !isError && !isAuditor) {
    //   isError = true;
    //   dispatch(
    //     toastMessageActions.showMessage({
    //       message: "Please Enter Mandatory Specifications",
    //       type: "error",
    //       showReduxToast: true,
    //       animationTime: 5000,
    //     })
    //   );
    // }
    if(!isRejection){

      if (
        !(isAuditor && isObjectionableQueue) &&
        selectedCountry.countryCode &&
        selectedCountry.countryCode != "IN"
      ) {
        props.sendBMDetails.forEach((cur) => {
          let importerArrayString = cur.values.join("");
          if (
            ["importer", "importers_detail"].includes(cur.name) &&
            !importerArrayString
          ) {
            isError = true;
           }
        });

        }

      if(!isError && labelErr) {
        isError = true;
        dispatch(
          toastMessageActions.showMessage({
            message: labelErr,
            type: "error",
            showReduxToast: true,
            animationTime: 5000,
          })
        );
      }
      const proof_required= false; //!props.session.viaOmni && !(productData.isTempProd && productData?.mrp_list?.some(mrp=>Number(mrp)==Number(productData.mrp)))
      if(productData.isUnknownMrpValue && !productData.mrp_images && proof_required){
        isError = 1;
        dispatch(
          toastMessageActions.showMessage({
            message: 'Please Attach Photo Proof of MRP Printed on Product Packaging',
            type: "error",
            showReduxToast: true,
            animationTime: 5000
          })
        );
        setFieldValue('uploadImageError', 'Please Attach Photo Proof');
      }
      if(productData.isUnknownMrpValue && !productData.mrp_front_img && proof_required){
        isError = 1;
        dispatch(
          toastMessageActions.showMessage({
            message: 'Please Attach Photo Proof of MRP Printed on Product Packaging',
            type: "error",
            showReduxToast: true,
            animationTime: 5000
          })
        );
        setFieldValue('uploadProductFrontImageError', 'Please Attach Photo Proof');
      }
      if(newErrors?.businessError || newErrors?.minPrice || newErrors?.maxPrice){
        isError = true
      }
      if(priceRangeQtyError){
        isError = true
      }
      if (isError) {  
        updateError(newErrors);
          return;
      }
    }
    if (!saveButtonStatus.current) {                                                                                  
      saveButtonStatus.current = "disabled";
    }
    // if(props.productData.commissionRate && !options?.fromCommissionModal){
    // 	setCommissionModal(true)
    // 	return;
    // }
    /*if(!isAuditor && productOrService == 'product' && showSellOnline){
      let consignmentResp = '';
      if(productData.total_consignments > 1){
        consignmentResp = await axios
        .get(
          `/marketplace/static/php/web/b2bWebsite.php?action=fetchConsignmentData&token=${props.session.token}&productId=${productData.productId}&currentPage=1&pageSize=15`
        ).then((response) => {
          let batches = response.data.results|| [];

          let filteredBatchesList =[];
          let modalFlag = false;
          for(let i = 0; i <batches.length; i++) {
            const discountPercent = discountCalculator(
              Number(batches[i].selling_price.toString().replaceAll(',','')),
            Number(batches[i].mrp.toString().replaceAll(',',''))
            );
            if(discountPercent>=discountWaringPercent){
            modalFlag = true;
            const obj = {
                mrp: batches[i].mrp.toString().replaceAll(',',''),
                sellingPrice: batches[i].selling_price.toString().replaceAll(',',''),
                batchCreationDate: batches[i].updatedon || ""

            }
            filteredBatchesList.push(obj)

            }

          }
          setSellingPriceModalData( prev=>({...prev, batches: filteredBatchesList}))
          if(modalFlag){
            saveButtonStatus.current = null;
            toggleSellingPriceModal({show:true});
            return modalFlag;
          }
          return modalFlag;
        })
        if(consignmentResp){
          return;
        }
      }else{
        const discountPercent = discountCalculator(
          Number(productData?.sellingOnlinePrice?.toString().replaceAll(',','')),
        Number(productData?.mrp?.toString().replaceAll(',',''))
        );
        if(discountPercent>=discountWaringPercent){
          const batch = [...sellingPriceModalData.batches];
          batch[0].mrp = productData?.mrp?.toString().replaceAll(',','');
          batch[0].sellingPrice = productData?.sellingOnlinePrice?.toString().replaceAll(',','');
          if(productData.addInventoryBatch){
            const InvdiscountPercent = discountCalculator(Number(productData.addInventoryBatch.sellingPrice),Number(productData.addInventoryBatch.mrp)
            );
            if(InvdiscountPercent>=discountWaringPercent){
              batch.push({
                mrp:productData.addInventoryBatch.mrp.toString().replaceAll(',',''),
                sellingPrice:productData.addInventoryBatch.sellingPrice.toString().replaceAll(',',''),
                batchCreationDate:productData.batchCreationDate
              })
            }

          }
          setSellingPriceModalData( prev=>({...prev, batches: batch}));
          saveButtonStatus.current = null;
          toggleSellingPriceModal({show:true});
          return;
        }
      }
    }*/
    if (typeof options !== "undefined" && options.fetchNextUrl) {
      updateProdLoader(true);
    } else {
      toggleBtnLoader(true);
    }
    let prodName = props.productData.productName || "";
    prodName = prodName.trim();
    prodName = prodName.replace(/\s\s+/g, " ");
    let editProductData = [
      {
        key: "productName",
        value: prodName,
      },
      {
        key: "isSellOnline",
        value: showSellOnline,
      },
    ];
    if (
      props.productData &&
      props.productData.priceObj &&
      !props.productData.priceObj.isSinglePrice &&
      props.productData.priceObj.maxPrice &&
      props.productData.priceObj.minPrice &&
      props.productData.priceObj.minPrice == props.productData.priceObj.maxPrice
    ) {
      let priceObj = props.productData.priceObj;
      priceObj = {
        isSinglePrice: true,
        singlePrice: props.productData.priceObj.minPrice,
      };
      if (priceObj.priceOnQty?.length) {
        priceObj.priceOnQty = [];
      }
      if(!showSellOnline && maxSupplyCapacity && supplyTimePeriod) {
        priceObj['maxSupplyCapacity'] = maxSupplyCapacity;
        priceObj['supplyTimePeriod'] = supplyTimePeriod;
      }
      editProductData.push({
        key: "priceObj",
        value: priceObj,
      });
      toggleRange(false); //As per discussion with Shaminder for #411805
    } else if (toggleIndex != 3) {
      let priceObj = props.productData.priceObj;
      if (priceObj?.priceOnQty?.length) {
        priceObj.priceOnQty = [];
      }
      if(!showSellOnline && maxSupplyCapacity && supplyTimePeriod) {
        priceObj['maxSupplyCapacity'] = maxSupplyCapacity;
        priceObj['supplyTimePeriod'] = supplyTimePeriod;
      }
      editProductData.push({
        key: "priceObj",
        value: priceObj,
      });
    }

    let countryOriginName = "";
    let countryOriginCode = "";
    if (selectedCountry.countryName && selectedCountry.countryCode) {
      countryOriginName = selectedCountry.countryName;
      countryOriginCode = selectedCountry.countryCode;
    }
    editProductData.push({
      key: "countryOrigin",
      value: {
        name: "Country Of Origin",
        values: [countryOriginName, countryOriginCode],
        otherFlag: 0,
      },
    });
    if(!showSellOnline && maxSupplyCapacity && supplyTimePeriod) {
      editProductData.push({
        key: 'maxSupplyCapacity',
        value: maxSupplyCapacity
      },
      {
        key: 'supplyTimePeriod',
        value: supplyTimePeriod
      })
    }
    if (!props.productData.isSellOnline && props.productData.bulkPricingDetail) {
      editProductData.push({
        key: "bulkPricingDetail",
        value: ''
      })
    }
    if (!rejectionCheck) {
        props.updateEditProductDetail(editProductData);
    }
    if(descCount > 0 && descCount < 100 ) {
      dispatch(toastMessageActions.showMessage({
        message: 'Description must be at least 100 characters long',
        type: 'error',
        cb: (status) => document.querySelector(".wyswig-div [contenteditable]").scrollIntoView({ behavior: "smooth", block: "center" })
      }));
      updateError({
        description: 'Description must be at least 100 characters long'
      })
      toggleBtnLoader(false);
      saveButtonStatus.current = null;
      return;
    }
    var isPricePresent = true;
    if(!showSellOnline && !(productData.priceObj &&(productData?.priceObj.singlePrice || productData?.priceObj.minPrice))){
      isPricePresent = false;
    }
    
    if (!aiSpecsShown && !isAuditor && !(isTempProd || isTemplate) && (cntNotFilledSpecs.length || !isPricePresent) && !aiSpecBypass) {
      let psvUom = null;
       if(!productData.unitOfMeasurement) {
          let psvData = {
              type : productData.categoryType,
              psv_node_id : props.productData.psv_node_id
                      ? props.productData.psv_node_id
                : props.productData.leafId
            }
          const psvUomList = props.getPsvDetails(psvData);
          psvUom = psvUomList?.UNIT?.length ? psvUomList.UNIT[0].val : null;
          if(productData.categoryType == 'service' && psvUom == 'stds') {
            psvUom = psvUomList[1].val;
          } 
        }
      const showAiModal = await new Promise((resolve) => {
        fetchAiSpecSuggestions({
          productName: props.productData.productName,
          categoryName:
            productData.keywordName ||
            ((props.productData.isTempProd) &&
            props.productData.productId == 'ADD_PRODUCT'
              ? props.productData.psv_node_name
              : props.productData.categoryName
              ? props.productData.categoryName
              : props.productData.psv_node_name) ||
            '',
          specData: cntNotFilledSpecs,
          token: props.session.token,
          keywordId: productData.keywordId,
          unitOfMeasurement: productData.unitOfMeasurement || psvUom,
          filledSpecs,
          description: productData.description,
          isPricePresent,
          cb: (response) => {
            if (response?.logId) {
              props.updateEditProductDetail({
                key: 'aiLogId',
                value: response.logId,
              });
            }
    
            if ((response.data && response.data.length) || response?.priceData.data) {
              saveButtonStatus.current = null;
              toggleBtnLoader(false);
    
              let options = {};
              options.data = response.data || [];
              options.priceData = response.priceData || null;
              options.priceLogId = response?.priceData?.logId || '';
              options.show = true;
    
              setAiSpecsSaved(false);
              setAIspecModal(options);
              updateAiSpecsShown(true);
    
              resolve(true);
              return;
            }
    
            updateAISpecByPass(true);
            resolve(false);
          },
          clickTrack: () => {}
            /*props.clickTrack({
              ll: 'digital_catalog',
              li: 'ai_gen_spec_request',
              userBasedCheck: true,
            }),*/
        });
      });
    
      if (showAiModal) {
        return;
      }
    }
    
    // if(isOwner && !descCount && saveButtonStatus.current != 'redo' && !(isTempProd || isTemplate || isBrandedProduct)) {
    //   saveButtonStatus.current = 'redo';
    //   toggleValidationModal({show: true,noDesc: true});
    //   toggleBtnLoader(false);
    //   return;
    // }else if(saveButtonStatus.current == 'redo'){
    //   saveButtonStatus.current = 'disabled';
    // }

    if (!productData.description){
      const generateDesc = await checkSpecAndGenerateDesc();
    }

    let newOptions = options.newSpecs ? options.newSpecs : props;
    props.saveAddEditProduct(null,  
      (res) => {
      dispatch(filterQuery(''));
      if (typeof options !== "undefined" && options.fetchNextUrl) {
        updateProdLoader(false);
      } else {
        toggleBtnLoader(false);
      }
    if (
        res.data &&
        (res.data.status == 1 || res.data.status == 2) &&
        res.data.msg &&
        res.data.msg != "Product Updated Successfully" &&
        res.data.msg != "Service Updated Successfully" &&
        res.data.msg != 'updated successfully' &&
        res.data.msg != 'Reviewed Successfully'
      ) {
        let newErr = {};
        let msg = res.data.msg;
        let scrollElem = "";
        const { errorType, objectionableContent = [] } = res.data;
        if (errorType == "productName" && res.data.status == 2) {
          newErr = { productName: msg };
          scrollElem = "productName";
          dispatch(
            toastMessageActions.showMessage({
              message: msg,
              type: "error",
              showReduxToast: true,
              duration: 5000,
              cb: (status) => scrollToError(status, scrollElem),
            })
          );
          updateError(newErr);
        } else if (
          res.data.status == 1 &&
          res.data.msg == "objectionable content found"
        ) {
          toggleShowObjectionalModal({
            show: true,
            errors: objectionableContent,
          });
        } else if (errorType === 'productSku') {
          props.showToastMessage({
              showToastMessage: true,
              message: 'Duplicate Seller SKU ID',
              type: 'error',
              duration: 5000
          });
          if(!res.data.position) {
            updateError({
                sku: 'Duplicate Seller SKU ID'
            });
          }else {
            let variantData = [...props.variantProductData];
            variantData[res.data.position].errors = {sku: true};
            props.setVariantProductData(variantData)
          }
        }else if (res.data.status === 2) {
          dispatch(
            toastMessageActions.showMessage({
              message: msg,
              type: "error",
              showReduxToast: true,
              duration: 5000,
              cb: (status) => scrollToError(status, "description"),
            })
          );
          if (errorType === "productDesc") {
            updateError({
              description: msg,
            });
          }
        }
        saveButtonStatus.current = null;
        return;
      }

      if (res?.data?.status === 0 && res?.data?.irrelevantContent) {
        setCorrectnessModel({ show: true, data: res.data?.irrelevantContent })
      }
      if(res?.data?.status === 0 && res?.data?.msg?.toLowerCase() == 'keyword not active'){
        dispatch(
            toastMessageActions.showMessage({
              message: 'Keyword Not Active',
              type: "error",
              showReduxToast: true,
              duration: 5000,
              cb: (status) => scrollToError(status, "categoryName"),
            })
          )
          saveButtonStatus.current = null;
          toggleBtnLoader(false);
          return;
      }

      if (res.isSuccess) {
        if(res.data?.status && !res.data?.docrequiredData?.length > 0){
          handleResetSpecification();
        }
        updateList(productData.productId, true);
        if (isAuditor) {
          // if (res.isAlreadyAudited) {
          //   updateAuditMsg(
          //     (selectedType == "service" ? "Service" :"Product") + " details has got updated while you were auditing. Click on continue to get the updated version of the "+(selectedType == "service" ? "service" :"product")
          //   );
          //   updateSaveProdConflict("alreadyAudited");
          //   updateTimeoutModal(true);
          //   updateProdLoader(false);
          //   return;
          // }
          // if (res.isOwnerEdited) {
          //   updateAuditMsg(
          //     (selectedType == "service" ? "Service" :"Product") + " details has been edited by the Owner while you were auditing. Click on continue to get the updated version of the " + (selectedType == "service" ? "service" :"product")
          //   );
          //   updateSaveProdConflict("ownerEdited");
          //   updateTimeoutModal(true);
          //   updateProdLoader(false);
          //   return;
          // }
          // if (res.duplicateProduct) {
          //   let newErr = { productName: res.msg };
          //   let msgLabel = "Product";
          //   if (selectedType == "service") {
          //     msgLabel = "Service";
          //   }
          //   dispatch(
          //     toastMessageActions.showMessage({
          //       message: `${msgLabel} with this Name Already Exists in Your Catalogue`,
          //       type: "error",
          //       showReduxToast: true,
          //       duration: 5000,
          //       cb: (status) => scrollToError(status, "productName"),
          //     })
          //   );
          //   saveButtonStatus.current = null;
          //   updateError(newErr);
          //   return;
          // }
          // if(res.emptyImage && !(isAuditor && isObjectionableQueue)){
          //   let msg = 'Please Upload '+(selectedType == "service" ? "Service" :"Product")+' Image';
          //   let newErr = { image: msg };
          //   setTimeout(() => {
          //     console.log("This is image Error>>>>>>>");
          //     window.scrollTo({ top: 0, behavior: "smooth" });
          //   }, 100);
          //   dispatch(
          //     toastMessageActions.showMessage({
          //       message: msg,
          //       type: "error",
          //       showReduxToast: true,
          //       duration: 5000
          //     })
          //   );
          //   updateProdLoader(false);
          //   toggleBtnLoader(false);
          //   updateError(newErr);
          //   saveButtonStatus.current = null;
          //   return;
          // }
          // if(res.invalidBrandedId){
          //   props.setAuditObject({
          //     brandedErr: 'Please Enter Valid Product ID',
          //   });
          //   let msg = 'Please Enter Valid Product ID';
          //   dispatch(
          //     toastMessageActions.showMessage({
          //       message: msg,
          //       type: "error",
          //       showReduxToast: true,
          //       duration: 5000
          //     })
          //   );
          //   saveButtonStatus.current = null;
          //   return;
          // }
          // if (auditFromPage) {
          //   let message = "Audit Details Saved Successfully";
          //   if (isAddProduct) {
          //     message = "Product Added Successfully";
          //   }
          //   dispatch(
          //     toastMessageActions.showMessage({
          //       message,
          //       showReduxToast: true,
          //       duration: 1000,
          //     })
          //   );
          //   if(props.docIdSearch){
          //     if (auditFromPage) {
          //           setTimeout(() => {
          //           if (listingDataLength > 0) {
          //             getHistoryObj()
          //           }else {
          //             history.push("/login")
          //           }
          //         }, 2000);
          //       }else {
          //           getHistoryObj()
          //       }
          //   }else{
          //      if (auditFromPage) {
          //       setTimeout(() => {
          //         if (listingDataLength > 0) {
          //             getHistoryObj()
          //         }else {
          //           history.push("/login")
          //         }
          //       }, 2000);
          //     }else {
          //       setTimeout(()=>{
          //       history.go(-2);
          //     },200)
          //     }

          //   }
          //   return;
          // }
          // if (options.fetchNextUrl) {
          //   fetchAuditUrl({
          //     cb: (data) => {
          //       fetchResolve({ data });
          //       if (!data.data.status) {
          //         saveButtonStatus.current = "saved";
          //       }
          //       updateProdLoader(false);
          //     },
          //   });
          // } else {
          //   saveButtonStatus.current = "saved";
          //   // showSuccessPage(true);
          //   history.push(auditHomePath);
          // }
        } else {
          let msgLabel = "Product";
          if (selectedType == "service") {
            msgLabel = "Service";
          }
          if (res.duplicateProduct) {
            let newErr = { productName: res.msg };
            dispatch(
              toastMessageActions.showMessage({
                message: res.msg,
                type: "error",
                showReduxToast: true,
                duration: 5000,
                cb: (status) => scrollToError(status, "productName"),
              })
            );
            saveButtonStatus.current = null;
            updateError(newErr);
            return;
          }
          if(res.data?.smartComplianceData && res.data?.smartComplianceData?.show){
            updateShowComplianceModal(true);
            if(res.data?.docrequiredData?.length > 0){
              toggledocReqModal({show:false,docs:res.data.docrequiredData});
            }else if(res.data?.auditPendingModal){
              // setAuditPendingModal(true);
              setAuditPendingData(true);
            }
            return;
          }else{
            if(res.emptyImage && !props.session.viaOmni){
              let msg = 'Error in Image Upload,Please try again';
              let newErr = { image: msg };
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              });
              dispatch(
                toastMessageActions.showMessage({
                  message: msg,
                  type: "error",
                  showReduxToast: true,
                  duration: 5000
                })
              );
              updateProdLoader(false);
              toggleBtnLoader(false);
              updateError(newErr);
              saveButtonStatus.current = null;
              return;
            }
            // if(res.data?.docrequiredData?.length > 0){
            //   toggledocReqModal({show:true,docs:res.data.docrequiredData});
            //   return;
            // }
            dispatch(
              toastMessageActions.showMessage({
                message: `${msgLabel} ${isAddProduct ? "Added" : "Updated"
                  } Successfully`,
                showReduxToast: true,
                duration: 5000,
              })
            );
            if (props.deviceData.isMobile) {
              setRouteChangeMessage({
                message: `${msgLabel} ${isAddProduct ? "Added" : "Updated"
                  } Successfully`,
              });
            }
            if (props.session.fromWalkthrough) {
              axios({
                  method: 'GET',
                  url: '/marketplace/static/php/web/walkThroughApi.php?action=updateStatus'
              }).then((res) => { })
              let url = '/vendorapis/products/website/getDcAutoLoginUrl';
              let formData = new FormData();
              formData.append("omni", 1);
              formData.append("docid",props.session.docId);
              formData.append("backurl",props.session.backUrl);
              axios.post(url, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }).then(res => {
                if(res.data.autoLoginUrl){
                  parent.window.location.href = res.data.autoLoginUrl;
                }
              })
          }
            if(props.session.closeIframe){
              parent?.callback?.fn(res.data?.inventory || res?.data?.data);
              setTimeout(() => {
                let ele = parent?.document.getElementById('omniIframe');
                parent.document.body.style.overflow = 'unset';
                if(ele?.parentNode && ele?.parentNode?.children && ele?.parentNode?.children?.length){
                  ele.parentNode.removeChild(ele);
                }
              }, 3000);
              return;
            }
            if(props.listingProdData.prodCount <= 1 && props.tabKey != 'auditPending'){
              props.setTabStatus({ tabKey: undefined }); //#329519
            }else{
              props.setTabStatus({ tabKey: props.tabKey }); //#329519
            }
            saveButtonStatus.current = "saved";
            if (productData.isDuplicate) {
              history.replace("/products");
              if (!props.deviceData.isMobile) {
                props?.isSearchSliderOpen ? historyHandler.closeCurrent() : getHistoryObj()
               
              }
            }else if (productOrService == 'product' && isContractorV1V2){
                if (isAddProduct) {
                  getHistoryObj()
                }else {
                  history.go(-1)
                }
            } else if (res.redirectToListing) {
              history.go(-2);
            } else {
              saveButtonStatus.current == "saved" &&  props.resetProductData({});
              if(isAddProduct && isMobile && !isContractorV1V2 && !props.viaSuggested){
                if(props.fromSellerDashboard){
                  historyHandler.closeAll();
                  dispatch(setFromSeller({fromSellerDashboard:false}));
                  setTimeout(()=>{
                    history.replace('/products');
                  },200)
                }else{
                  history.go(fromPhotos || selectedType == 'service' ? -1 : -2);
                }
              } else {
                if((isAddProduct && !props.viaSuggested) && isMobile){
                  if(props.fromSellerDashboard){
                    historyHandler.closeAll();
                    dispatch(setFromSeller({fromSellerDashboard:false}));
                    setTimeout(()=>{
                      history.replace('/products');
                    },200)
                  }else{
                    historyHandler.closeAll();
                    setTimeout(()=>{
                      if(isContractorV1V2){
                        history.go(productOrService == 'service' ? -1 : -2)
                      }else{
                        history.go(-2);
                      }
                    },200)
                  }
                }else{
                  if(isMobile){
                    if(fromSellerRejected){
                      setTimeout(()=>{
                        history.replace('/products');
                      },200);
                    }else{
                      getHistoryObj('save')
                    }
                    if(props.viaSuggested && props.viaSearchSuggested){
                      props.setTabStatus({ tabKey: 'brand' });
                    }
                  }else{
                    props?.showCategoryMissingCard || props?.isActionCardSliderOpen ? getHistoryObj() :  historyHandler.closeAll();
                    if(props.fromSellerDashboard || fromSellerRejected){
                      dispatch(setFromSeller({fromSellerDashboard:false}));
                      setTimeout(()=>{
                        history.replace('/products');
                      },200)
                    }
                  }
                }
              }
            }
          }
        }
      } else if (res.error == "ALL_IMAGE_NOT_UPLOADED") {
        dispatch(
          toastMessageActions.showMessage({
            message: "Please wait Image Upload is in Progress",
            showReduxToast: true,
            duration: 5000,
          })
        );
        saveButtonStatus.current = null;
      }  else if (!res.isSuccess && res.data.isError) {
        showProductSourceVaidation(res);
        saveButtonStatus.current = null;
      }
      // window.location.reload();
    },
      {
        savedCustomSpecAttributes: props.savedCustomSpecAttributes,
        savedPuvSpecAttributes: newOptions.savedPuvSpecAttributes?.length ? newOptions.savedPuvSpecAttributes : newOptions.editablePuvSpecAttributes,
        sendBMDetails: props.sendBMDetails,
        installData: props.installData,
        contentWeightUnitSaved: props.contentWeightUnitSaved,
        rejectionCheck,
        toggleIndex
      }
    );
  };

  const saveAuditorMrpBatch = async ({fetchNextUrl=false}) => {

		// if (isAuditor && isReviewStatusNotRejected) {
		// let errMsg = '';
		// 	let {
		// 		checkedValue,
		// 		minCorrectTextArea,
		// 		rejectionMessage,
		// 		brandedProductId
		// 	} = props.auditData;
		// 	if (!checkedValue) {
		// 		props.setAuditObject({
		// 			unSelectedErr: true
		// 		});
		// 		errMsg = 'Please Select a Value';
		// 	}
		// 	if (checkedValue == 'minCorrect' && !minCorrectTextArea) {
		// 		props.setAuditObject({
		// 			minCorrectErr: true
		// 		});
		// 		errMsg = 'Please Enter Details';
		// 	}
		// 	if (
		// 		(checkedValue == 'productRejected' ||
		// 			checkedValue == 'PRODUCT_REJECTED_FOR_LABEL') &&
		// 		!rejectionMessage
		// 	) {
		// 		props.setAuditObject({
		// 			rejectionErr: 'Please Enter Rejection Details'
		// 		});
		// 		errMsg = 'Please Enter Details';
		// 	}
		// 	if (
		// 		checkedValue == 'mergeWithBrandedProduct' &&
		// 		!brandedProductId
		// 	) {
		// 		props.setAuditObject({
		// 			brandedErr: 'Please Enter Branded Product ID'
		// 		});
		// 		errMsg = 'Please Enter Branded Product ID';
		// 	}
		// 	if (checkedValue == 'errWithDet') {
		// 		let isSelected = false;
		// 		props.auditData.checkBoxData.forEach((item, index) => {
		// 			if (item.value) {
		// 				isSelected = true;
		// 				if (item.showCommentBox && !item.textBoxValue) {
		// 					let checkBoxData = [
		// 						...props.auditData.checkBoxData
		// 					];
		// 					checkBoxData[index].error = true;
		// 					props.setAuditObject({
		// 						checkBoxData
		// 					});
		// 					errMsg = 'Please Enter Details';
		// 				}
		// 			}
		// 		});
		// 		if (!isSelected) {
		// 			props.setAuditObject({
		// 				checkboxErr: true
		// 			});
		// 			errMsg = `Please Select a ${(productOrService == 'service') ? 'Service' : 'Product'} Error`;
		// 		}
		// 	}
		// 	if (checkedValue == 'passedBySample') {
		// 		errMsg = 'Please select another Audit Disposition';
		// 	}
		// 	if (errMsg) {
		// 		window.scrollTo(0, document.body.scrollHeight);
		// 		dispatch(
		// 			toastMessageActions.showMessage({
		// 				message: errMsg,
		// 				type: 'error',
		// 				showReduxToast: true
		// 			})
		// 		);
		// 		return;
		// 	}
		// }

		const newErrors = { ...errors };
		let isError = false;
		let selected = false;
		[...auditorMrpComplianceForm].forEach(cur => {
			if (cur.checkError && !cur.hide) {
				if (cur.auditorMrpBatchSellOnline) {
					if (showSellOnline) {
						isError = cur.checkError('', newErrors, isError);
					}
				}
				if (
					newErrors[cur.key] ||
					(cur.auditorMrpBatchSellOnline &&
						(newErrors['consignment_mrp'] ||
							newErrors['consignment_selling_price']))
				) {
					if (!isError) {
						dispatch(
							toastMessageActions.showMessage({
								message: newErrors[cur.key],
								type: 'error',
								showReduxToast: true,
								duration: 5000,
								cb: status => scrollToError(status, cur.key)
							})
						);
					}
					isError = true;
				}
			}
		});
		if (isError) {
			updateError(newErrors);
			return;
		}

    if (!saveButtonStatus.current) {
      saveButtonStatus.current = "disabled";
    } else {
      return;
    }

    let auditData = props.auditData;

		let obj = {
			token: props.session.token,
			productId: productData.productId,
			mrp: productData.consignment_mrp,
			sellingPrice: productData.consignment_selling_price,
			consignmentNo: productData.consignment_no,
			parentId: productData.product_bankid,
			rejectedReason: auditData.rejectionMessage,
			disposition: auditData.checkedValue === "productRejected" ? "rejected" : "approveProductBank"
		};
    if(fetchNextUrl){
      updateProdLoader(true);
    }else {
      toggleBtnLoader(true);
    }
		saveAuditMrpComplianceBatch(obj, (res) => {
      toggleBtnLoader(false);
      if(res.data.msg == "Updated successfully"){
        if (fetchNextUrl) {
          fetchAuditUrl({
            cb: (data) => {
              fetchResolve({ data });
              if (!data.data.status) {
                saveButtonStatus.current = "saved";
              }
              updateProdLoader(false);
            },
          });
        } else {
          saveButtonStatus.current = "saved";
          history.push(auditHomePath);
        }
      }

    });
  };
  const handleKeyDownText = (e) => {
    if (otherThanEnglish.test(e.key)) {
      e.preventDefault();
    }
  };
  const handleKeyDown = (e, key) => {
    if (key == "description") {
      if (key == "description") {
        updateError({
          ...errors,
          description: "",
        });
        let targetEle = e.target;
        let txtBefore = formatProdDesc(targetEle?.innerHTML);
        if((e.ctrlKey || e.metaKey) && e.key == 'v') {
          getContent((result) => {
            if(result) {
              result = formatProdDesc(result);
              props.updateDescType({descType: 1});
              if((result.length + txtBefore.length) > 8000) {
                e.preventDefault();
                result = result.slice(0,8000 - txtBefore.length);
                setFieldValue('description',txtBefore+''+result)
              }
            }
          })
        }
        if(e.keyCode != 8 && (txtBefore.length >= 8000)) {
          e.preventDefault()
        }
        setTimeout(() => {
          const text = formatProdDesc(targetEle?.innerHTML)?.slice(0,8000);
          const hasText = text && text.trim();
          updateCount(text?.length); 
          if (hasText) {
            togglePaste(false);
          } else {
            targetEle.innerHTML = "";
            togglePaste(true);
          }
        }, 100);
      }
    }
    if (!isIPhone) {
      return;
    }
    const keycode = e.key;
    if (keycode == "Backspace") {
      return;
    }
    switch (key) {
      case "sellingPrice":
        {
          if (
            !keycode.match(/\d|\./g) ||
            !((priceObj.singlePrice || "") + (keycode || "")).match(priceRegex)
          ) {
            e.preventDefault();
          }
        }
        break;
      case "minOrderQuantity":
        {
          if (
            productData.uomType == "PACKED"
              ? !keycode.match(/\d/g) ||
                !((productData.minOrderQuantity || "") + (keycode || "")).match(
                  minQtyRegex
                )
              : !(
                  !keycode.match(/\d/g) ||
                  /^\d{0,10}(\.\d*)?$/.test(
                    productData.minOrderQuantity || ""
                  ) + (keycode || "")
                )
          ) {
            e.preventDefault();
          }
        }
        break;
    }
  };
  const oldAuditData = productData.oldData || {};
  const showPreviousAuditData =
    isAuditUrl && Object.keys(oldAuditData).length > 0;
  const currentAuditDataRef = useRef(
    showPreviousAuditData ? JSON.parse(JSON.stringify(productData)) : null
  );
  const currentAuditData = currentAuditDataRef.current;
  const newAuditPriceObj = currentAuditData
    ? currentAuditData.priceObj || {}
    : {};
  const oldAuditPriceObj = oldAuditData.priceObj || {};
  let isMobile = props.deviceData.isMobile;
  const showOldPriceRange =
    !oldAuditPriceObj.isSinglePrice &&
    (oldAuditPriceObj.minPrice || oldAuditPriceObj.maxPrice);
  //Is Gallery Product check
  const isGalleryProd =
    productData.productName &&
    productData.productName.indexOf("GPB2BMARKETPLACE") > -1;
    
    productData.keywordName = (!productData.keywordName || productData.keywordName === '0' ? '' : productData.keywordName) 
  
  useEffect(() => {
    setShowBusinessType(!productData?.businessType && 
      productData.productId == "ADD_PRODUCT" && 
      isTempProd &&
      !props.session.businessType
    );
  }, []);  
    
  //To show bussiness type
  let hideBusinessType = showBusinessType ? !showBusinessType : (
    (isTemplate || isTempProd
      ? !(isTemplate || isTempProd)
      : !productData.categoryName) ||
    (productData.bizSuggestion?.bizType &&
      ((productData.productId != "ADD_PRODUCT" &&
      !categoryChanged) ||
      (productData.productId == "ADD_PRODUCT" && isTempProd))
    ) ||
    props.session.businessType ||
    props.session.isReadOnly ||
    selectedType == "service"
  );
  
  function getFields(fieldArr, options = {}) {
    let returnFields = options.initialEmpty ? [] : [...fieldArr];
    fieldArr.forEach((cur) => {
      if (cur.previousAuditObj) {
        let previousAuditObj = cur.previousAuditObj;
        let newField = { ...cur };
        newField.key = "previous" + newField.key;
        newField.checkError = null;
        newField.input = { ...newField.input };
        let holderClass = cur.holderClass || "";
        if (previousAuditObj.holderClass) {
          holderClass += previousAuditObj.holderClass;
        } else if (holderClass.indexOf(styles.marginT12) == -1) {
          holderClass += " " + styles.marginT12;
        }
        newField.holderClass =
          holderClass +
          " read-only-mode modified " +
          (previousAuditObj.labelOnTop ? "move-up" : "");
        newField.label = previousAuditObj.label;
        newField.input.value = previousAuditObj.value;
        newField.input.readOnly = true;
        if (cur.formElements) {
          newField.formElements = getFields(cur.formElements, {
            ...options,
            initialEmpty: true,
          });
        }
        if (previousAuditObj.hasOwnProperty("hide")) {
          newField.hide = previousAuditObj.hide;
        }
        if (cur.inputObj) {
          newField.inputObj = getFields(cur.inputObj, {
            ...options,
            initialEmpty: true,
          });
        }
        returnFields.push(newField);
      }
    });
    return returnFields;
  }
  const pasteFromClipboard = () => {
    let text = "";
    getContent((result) => {
      if (result) {
        text = result.trim();
        togglePaste(false);
        let val = formatProdDesc(text)?.slice(0,8000);
        updateCount(val.length);
        setFieldValue("description", val);
      }
    });
  };
  let productOrServiceLabel = "Product Name";
  if (productOrService == "product") {
    productOrServiceLabel = "Product Name";
  } else if (productOrService == "service") {
    productOrServiceLabel = "Service Name";
  }


  const generateDescription = () => {
    let specCount = 0
    if(productData.keywordId) {
      const ignoreField = ['brand', 'country_of_origin', 'price', 'manufacturer', 'manufactured_details', 'importer', 'importers_detail', 'packaging_length', 'packaging_width', 'packaging_height', 'packaging_weight', 'expiry_date'];
      let puvSpecLength =  props.savedPuvSpecAttributes.filter(cur => !ignoreField.includes(cur.s_nm) && !!cur.userInput.value).length;
      specCount = props.savedCustomSpecAttributes.length + puvSpecLength; 
    }
    if(productData.productName?.length < 3 || !productData.keywordId || specCount < 5){
      toggleValidationModal({show: true});
    }else {
      toggleValidationModal({show: true,loadDesc: true});
    }
  }

  const checkSpecAndGenerateDesc = () => {
    return new Promise((resolve) => {
      const ignoreField = ['brand','country_of_origin','price','manufacturer','manufactured_details','importer','importers_detail','packaging_length','packaging_width','packaging_height',
        'packaging_weight','expiry_date'
      ];
  
      let specs = props.savedPuvSpecAttributes?.length ? props.savedPuvSpecAttributes : props.editablePuvSpecAttributes;
  
      let puvSpecLength = specs.filter(cur => !ignoreField.includes(cur.s_nm) && !!cur.userInput.value).length;
  
      const specsForDesc = props.productSpecification.savedPuvSpecAttributes?.length ? props.productSpecification.savedPuvSpecAttributes : props.productSpecification.editablePuvSpecAttributes;
  
      const getSpec = getAllSpecificationData(specsForDesc,props.productSpecification.savedCustomSpecAttributes);
      const filterSpec = getSpec.filter(item => !ignoreField.includes(item.s_name));
  
      const newAry = [];
      filterSpec.slice(0, 7).forEach(item => {const value = typeof item.values === "string" ? item.values : item.values.join(",");
        newAry.push({sid: item?.sid || '', label: item?.name,value, isCustom: item?.sid ? false : true });
      });
  
      const queryString =
        `product_name=${encodeURIComponent(props.productData.productName)}` +
        `&product_category=${encodeURIComponent(props.productData.keywordName)}` +
        `&spec=${encodeURIComponent(JSON.stringify(newAry))}`;
  
      getDescriptionData(queryString ,({ status, value, msg }) => {
        const canGenerate = status && (props?.savedCustomSpecAttributes?.length + puvSpecLength >= 5);
        canGenerate && handleChange('', "description", {value});
        if(productData.description?.length || value?.length) {
          togglePaste(false);
        }
        resolve({canGenerate,value, msg}); 
      });
    });
  };

  let barcodeRef = useRef(null);
  let [barcodeLoader, setBarcodeLoader] = useState(false);
  let isApp = props.deviceData.isAndroidApp /*|| props.deviceData.isIphoneApp*/ || props.deviceData.isIpadApp;//#349571 asked to remove barcode icon from iphone app

  const barcodeScan = () => {
    setTimeout(() => {
      scanBarcode({
        callback: (data) => {
          if(data){
            props.updateEditProductDetail([{
              key: 'barcode',
              value: data
            }])
          }
        }
      })
    }, 100);
  }

  const fillBarcode = () => {
      setBarcodeLoader(true);
      generateBarcode(1).then((res) => {
          setBarcodeLoader(false);
          if(res?.data[0]){
            props.updateEditProductDetail([{
              key: 'barcode',
              value: res.data[0]
            }])
          }
      }).catch((error) => {
        console.error(error)
        setBarcodeLoader(false);
      })
  }




  const updateCountry = (country) => {
    if (errors.countryOfOrigin) {
      let newErr = { ...errors };
      newErr.countryOfOrigin = "";
      updateError(newErr);
    }
    updateSelectedCountry({ ...country });
  };

  const smartFillUpdateProduct = () => {
    setShowComplianceUpdateLoader(true);
		dispatch(
			updateProductsWithSmartFill({
				cb: () => {
          setShowComplianceUpdateLoader(false);
					closeComplianceModal(true);
				},
				complianceSpecsFieldsArr: props.smartFillData?.complianceArr,
				catId:
					productData.leafId == 0 && productData.isTempProd
						? productData.psv_node_id
						: productData.leafId,
            brand: props.smartFillData?.brand
			})
		);
  };

  const openCountrySlider = (country) => {
    !props.countryList.length && props.fetchCountryCode();
    if (errors.countryOfOrigin) {
      let newErr = { ...errors };
      newErr.countryOfOrigin = "";
      updateError(newErr);
    }
    toggleFlagSlider(true);
  };

  const dropdownSelect = function(e, value) {
    // let temp = { ...this.props.errors };
    // temp.maxSupplyCapacity = '';
    // this.props.setItemErrors(temp);
    // this.setState({ supplyTimePeriod: e.key });
    // this.props.updateItemInfo({ supplyTimePeriod: e.key })
    // this.props.setItemErrors({ supplyTimePeriod: '' });
    handleFocus(e,"supplyTimePeriod");
    setSupplyTimePeriod(e.key);
}

  const showPrimaryManuExpDates =
    (showSellOnline || productData.isSellOnline) && props.permissions?.packagePermissionData?.isMaintainExpiry && !(productData.variantCommands?.length>0) && !isVariant
    // ((productData.productId != "ADD_PRODUCT" &&
    //   Number(productData.expiry_date_flag)) ||
    //   Number(props.productSpecification.expiryFlag) ||
    //   (categoryChanged && Number(props.productSpecification.expiryFlag)) ||
    //   props.permissions?.packagePermissionData?.isMaintainExpiry
    // );

  const formElements = [
    ...getFields([
      {
        label: "Product Source URL",
        key: "cv2ProductSource",
        holderClass: `${styles["product-source-field"]}`,
        input: {
          value: productData.cv2ProductSource || "",
          onChange: (e) => handleChange(e, "cv2ProductSource"),
          onFocus: (e) => handleFocus(e, "cv2ProductSource"),
        },
        hide: !isContractor,
        inputRef: scrollEle,
        checkError: isContractor
          ? (value) => checkError(value, "cv2ProductSource")
          : null,
        errorClass: styles["error-text"],
      },
    ]),
    ...getFields([
      {
        label: productOrServiceLabel,
        key: "productName",
        holderClass: `${styles["product-name-field"]} ${
          props.session.isReadOnly ? "read-only-mode" : ""
        }`,
        input: {
          maxLength: 150,
          value: (!isGalleryProd && productData.productName) || "",
          onChange: (e) => handleChange(e, "productName"),
          onFocus: (e) => handleFocus(e, "productName"),
          onKeyDown: (e) => handleKeyDownText(e),
          readOnly: props.session.isReadOnly ? true : false,
        },
        hide: isBrandedProduct || isTempProd || isTemplate,
        inputRef: scrollEle,
        checkError: (value) => checkError(value, "productName"),
        errorClass: styles["error-text"],
        previousAuditObj: showPreviousAuditData
          ? {
              label: `${"Previous"} ${productOrServiceLabel}`,
              value: oldAuditData.productName,
              hide: oldAuditData.productName == currentAuditData.productName,
            }
          : null,
      },
    ]),
    {
      customJSX: (
        <div className={styles["netwt-txt-temp"]}>
          {productData.unitPerPiece ? productData.contentPerPiece : ""}
          {" " + productData.unitPerPiece}
        </div>
      ),
      hide: (!(isTemplate || isTempProd) || !productData.unitPerPiece),
    },
    ...getFields([
      {
        label: `${
          productOrService == "product"
            ? "Product "
            : "Service"
        } Category`,
        key: "categoryName",
        holderClass: `${styles.marginT12} ${styles["product-category"]} ${
          props.session.isReadOnly ? "read-only-mode" : ""
        } ${
          isVariant && productData.productId != "ADD_PRODUCT"
            ? styles["disable-inp-bg"]
            : ""
        }`,
        input: {
          value:
          productData.keywordName || productData.categoryName ||
            productData.suggestedCategoryName ||
            (props.session.isReadOnly ? " " : ""),
          onChange: (e) => handleChange(e, "categoryName"),
          readOnly: true,
          onClick: () => {
            !props.session.isReadOnly &&
            !(isVariant && productData.productId != "ADD_PRODUCT")
              ? openCloseCatSlider(true)
              : null;
          },
        },
        inputRef: scrollEle,
        // showArrow: props.session.isReadOnly ? false : true,
        onRightIconClick: () => {
          !props.session.isReadOnly &&
          !(isVariant && productData.productId != "ADD_PRODUCT")
            ? openCloseCatSlider(true)
            : null;
        },
        rightIconClass: props.session.isReadOnly ? "" : "icon-Next",
        hide: isTemplate || isBrandedProduct || isTempProd,
        checkError: (value) => checkError(value, "categoryName"),
        previousAuditObj: showPreviousAuditData
          ? {
              label: `Previous ${isAuditor ? `${(productOrService == 'service') ? 'Service ' : 'Product '}` : ""}Category`,
              value: oldAuditData.categoryName,
              hide: oldAuditData.categoryName == currentAuditData.categoryName,
            }
          : null,
      },
    ]),
    {
      key: "businessType",
      hide: hideBusinessType,
      customJSX:
        (
          <div className={styles["marginLR15"]}>
            <BusinessType
              natCatId={productData.bizSuggestion?.bizType}
              handleChange={onBusinessChange}
              label="Business Type"
              error={errors.businessError}
            />
          </div>
        ),
    },
    {
      hide: false,
      customJSX:
        (
          <div className={styles["marginLR15"]}>
            <ItemInfoContainer {...props} updateData={setFieldValue} />
          </div>
        ),
    },
    // {
    //   hide: isTemplate || isTempProd || !props.brandSpecIndex,
    //   customJSX: (
    //     <div className={`${styles['marginLR15']} ${styles['out-spec']}`}>
    //       {
    //         props.brandSpecData?.s_type != 'Fixed'?
    //         <InputWithAutosuggestSlider
    //           parentIndex={props.brandSpecIndex}
    //           label={'Brand'}
    //           sliderHeading={'Search Brands'}
    //           handleChange={(data => {

    //           })}
    //         />
    //       :
    //       <FixBoxContainer
    //         parentIndex={props.brandSpecIndex}
    //       />}
    //     </div>
    //   )
    // },
    {
      hide: !props.isBrandSpecIndex || selectedType == "service",
      manufacturer: true,
      customJSX: (
        <div className={`${styles["marginLR15"]} ${styles["out-spec"]}`}>
          <ManufacturerDetails
            errors={errors}
            updateError={updateError}
            isTemplate={productData.isTemplate || productData.isTempProd}
            isReadOnly={props.session.isReadOnly}
            categoryChanged={categoryChanged}
            brandChange={brandChange}
            setCategoryChanged={()=>setCategoryChanged(false)}
            setBrandChange = {() => setBrandChange(!brandChange)}
            psvNodeId={productData.psv_node_id || productData.leafId}
            allowCountryOriginChange={()=>setCountryUpdatedFromSmartFill(false)}
            isAddProduct={isAddProduct}
          />
        </div>
      ),
    },
    ...getFields([
      {
        holderClass: styles["marginLR15"],
        hide: productOrService == 'service' || !props?.variantProps?.variantProductData?.length,
        formElements: [
          {
            label: "Unit of Measurement",
            key: "unitOfMeasurement",
            rightIconClass:
              props.unitOfMeasurement.displayVal
                ? `icon-HDRcross ${isMobile ? "font11" : "font10"}`
                : "icon-Next",
            onRightIconClick: () => {
              if (props.unitOfMeasurement.displayVal) {
                let data = { ...props.unitOfMeasurement };
                data.value = "";
                if (!data.key) {
                  data.key = "unitOfMeasurement";
                }
                props.updateEditProductDetail(data);
              } else {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              }
            },
            holderClass: props.session.isReadOnly ? "read-only-mode" : "",
            input: {
              value:
                (!isGalleryProd && props.unitOfMeasurement.displayVal) || "",
              onChange: (e) => handleChange(e, "unitOfMeasurement"),
              readOnly: true,
              disabled:
                props.unitOfMeasurement.displayVal &&
                (isTemplate || isBrandedProduct || isTempProd),
              onClick: () => {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              },
            },
            ignoreParentClass: true,
            editableForTemplate: true
          }
        ]
      }
    ]),
    {
      hide: selectedType !== 'service',
      customJSX: (
        <>
          {
            props.variantProps.variantProductData.length ?
              <ServiceSwitch
                showSellOnline={showSellOnline}
                productData={productData}
                selectedType={selectedType}
                isVariant={isVariant}
                toggleChangeModal={toggleChangeModal}
                updateType={updateType}
                variantProps={props.variantProps}
                updateRemovedSpec={updateRemovedSpec}
                addRemoveSpecVariant={props.addRemoveSpecVariant}
                toggleVariantWelcome={toggleVariantWelcome}
                hasVariantSpec={props.hasVariantSpec}
                isMobile={isMobile}
                isService = {selectedType == 'service'}
              /> : null
          }
          {
            isVariant ? NudgePrice({ toggleIndex: 4, productData: props.variantProps.variantProductData }) : null
          }
          {!showSellOnline && !isVariant ? (
            <div className={`${styles["marginLR15"]} ${styles["display-price-qty"]}`}>
              <div className={"display-price-qty-title"}>
                {"Select Pricing Type"}
              </div>
              <ToggleBtnGroup
                selectedValue={toggleIndex}
                onToggle={(e, value) => {
                  if (toggleIndex == 1 && isVariant) {
                    toggleChangeModal({ key: "pricing" ,newType: value == 2 ? 'Price Range' : 'Price Based on Qty', value: value});
                    return;
                  }
                  updateValue(e, value);
                  const newErrors = { ...errors };
                  newErrors["sellingPrice"] = "";
                  newErrors["minOrderQuantity"] = "";
                  newErrors["maxPrice"] = "";
                  newErrors["minPrice"] = "";
                  newErrors["actualPrice"] = "";
                  updateError(newErrors);
                }}
              >
                <ToggleBtnGroup.Btn
                  className={styles["input-grp-btn"]}
                  value={1}>
                  SINGLE PRICE
                </ToggleBtnGroup.Btn>
                <ToggleBtnGroup.Btn
                  className={styles["input-grp-btn"]}
                  value={2}>
                  PRICE RANGE
                </ToggleBtnGroup.Btn>
                <ToggleBtnGroup.Btn
                  className={styles["input-grp-btn"]}
                  value={3}>
                  PRICE BASED ON QTY. RANGE
                </ToggleBtnGroup.Btn>
              </ToggleBtnGroup>
            </div>
          ) : null}
        </>
      ),
    },
    {
      hide: selectedType == 'service',
      customJSX: (
        <>
          {!isContractorV1V2 && showTabs? <div
            className={`${styles["marginLR15"]} ${
              styles["display-price-qty"]
            } ${showSellOnline ? styles["marginB20"] : styles["marginB20"]}`}
          >
            <div className={"display-price-qty-title"}>
              {"Select Transaction Type"}
            </div>
            <ToggleBtnGroup
              selectedValue={!showSellOnline ? 0 : 1}
              disabled={
                isVariant && productData.productId != "ADD_PRODUCT"
                  ? true
                  : false
              }
              onToggle={(e, value) => {
                props.updateEditProductDetail([{key:'isSellOnline',value:value}])
                if (!value) {
                  errors["countryOfOrigin"] = "";
                }
                if (!value && isVariant) {
                  toggleChangeModal({ key: "transaction" });
                  return;
                } else {
                }
                updateValue(e, value, "transactionType");
                props.resetSpecErrors(true)
              }}
            >
              <ToggleBtnGroup.Btn
                className={`${styles["input-grp-btn"]}  ${
                  isVariant && productData.productId != "ADD_PRODUCT"
                    ? styles["input-disabled-btn"]
                    : ""
                }`}
                value={0}
                disabled={isVariant && productData.productId != "ADD_PRODUCT"}
              >
                <div className={"title-txt"}>
                  <i className={"icon-message"} /> <span>RECEIVE ENQUIRY</span>
                </div>
              </ToggleBtnGroup.Btn>
              <ToggleBtnGroup.Btn className={styles["input-grp-btn"]} value={1}>
                <div className={"title-txt"}>
                  <i className={"icon-HDRcart"} /> <span>SELL ONLINE</span>
                </div>
              </ToggleBtnGroup.Btn>
            </ToggleBtnGroup>
          </div> : null}
          {!showSellOnline && !isVariant ? (
            <div className={`${styles["marginLR15"]} ${styles["display-price-qty"]}`}>
              <div className={"display-price-qty-title"}>
                {"Select Pricing Type"}
              </div>
              <ToggleBtnGroup
                selectedValue={toggleIndex}
                onToggle={(e, value) => {
                  if (toggleIndex == 1 && isVariant) {
                    toggleChangeModal({ key: "pricing" ,newType: value == 2 ? 'Price Range' : 'Price Based on Qty', value: value});
                    return;
                  }
                  updateValue(e, value);
                  const newErrors = { ...errors };
                  newErrors["sellingPrice"] = "";
                  newErrors["minOrderQuantity"] = "";
                  newErrors["maxPrice"] = "";
                  newErrors["minPrice"] = "";
                  newErrors["actualPrice"] = "";
                  updateError(newErrors);
                }}
              >
                <ToggleBtnGroup.Btn
                  className={styles["input-grp-btn"]}
                  value={1}>
                  SINGLE PRICE
                </ToggleBtnGroup.Btn>
                <ToggleBtnGroup.Btn
                  className={styles["input-grp-btn"]}
                  value={2}>
                  PRICE RANGE
                </ToggleBtnGroup.Btn>
                <ToggleBtnGroup.Btn
                  className={styles["input-grp-btn"]}
                  value={3}>
                  PRICE BASED ON QTY. RANGE
                </ToggleBtnGroup.Btn>
              </ToggleBtnGroup>
            </div>
          ) : null}
          {
            showSellOnline && (!productData.isTempProd || !productData.isTemplate) && props.hasVariantSpec ?
              <ServiceSwitch
                showSellOnline={showSellOnline}
                productData={productData}
                selectedType={selectedType}
                isVariant={isVariant}
                toggleChangeModal={toggleChangeModal}
                updateType={updateType}
                variantProps={props.variantProps}
                updateRemovedSpec={updateRemovedSpec}
                addRemoveSpecVariant={props.addRemoveSpecVariant}
                toggleVariantWelcome={toggleVariantWelcome}
                hasVariantSpec={props.hasVariantSpec}
                isMobile={isMobile} 
              />
            : null
          }
        </>
      ),
    },
    {
      hide: !(showSellOnline || selectedType == 'service') ||
        productData.isTempProd ||
          productData.isTemplate ||
          !props.variantProps.variantProductData?.length,
      customJSX: <VariantSection isEdit={!isAddProduct} />,
    },
    ...getFields([
      {
        hide: selectedType == 'product' || showSellOnline || [2,3].includes(toggleIndex) || isVariant,
        priceRange: true,
        checkError: (value, newErrors, isError) => {
          let sellErr = checkError(priceObj.singlePrice, "sellingProductPrice", newErrors, isError);
          let actErr = checkError(priceObj.actualPrice, "actualPrice",newErrors,isError);
          return actErr || sellErr;
        },
          holderClass:
          styles["marginLR15"] +
          " " +
          // styles["marginTB24"] +
          styles["unit-holder"] +
          " " +
          styles["prod-price"] +
          " " +
          styles['service-price'] +
          " " +
          (props.session.isReadOnly ? " read-only-mode" : ""),
        previousAuditObj: showPreviousAuditData
          ? {
              hide:
                showOldPriceRange ||
                (oldAuditPriceObj.singlePrice == newAuditPriceObj.singlePrice &&
                  oldAuditData.unitOfMeasurement ==
                    currentAuditData.unitOfMeasurement),
            }
          : null,
        inputObj: [
          {
            label : `Actual Price`,
            inputRef: scrollEle,
            prepend: () => <span className="icon-currency" />,
            hidePrependBar: true,
            showPreTextWithoutFocus: true,
            errorClass: "hide-error-text",
            labelAlwaysUp: true,
            key: "actualPrice",
            holderClass: 'price '+(props.session.isReadOnly ? "read-only-mode" : ""),
            input: {
              value:
                priceObj.actualPrice || "",
              type: "tel",
              onChange: (e) => handleChange(e, "actualPrice"),
              onFocus: (e) => handleFocus(e, "actualPrice"),
              onKeyDown: (e) => handleKeyDown(e, "actualPrice"),
              readOnly: props.session.isReadOnly ? true : false,
            },
            ignoreParentClass: true,
            editableForTemplate: true,
            previousAuditObj: showPreviousAuditData
              ? {
                  label: `Previous ${isAuditor ? `${(productOrService == 'service')? 'Service ' : 'Product '}` : ""}Price`,
                  value: oldAuditPriceObj.singlePrice || "",
                  hide: showOldPriceRange,
                  holderClass:
                    " " + (oldAuditPriceObj.singlePrice == 0 ? "move-up" : ""),
                }
              : null,
          },
          {
            label : `Disc. Price`,
            inputRef: scrollEle,
            prepend: () => <span className="icon-currency" />,
            hidePrependBar: true,
            showPreTextWithoutFocus: true,
            errorClass: "hide-error-text",
            labelAlwaysUp: true,
            key: "sellingPrice",
            holderClass: 'price '+(props.session.isReadOnly ? "read-only-mode" : ""),
            input: {
              value:
                priceObj.singlePrice || (props.session.isReadOnly ? " " : ""),
              type: "tel",
              onChange: (e) => handleChange(e, "sellingPrice"),
              onFocus: (e) => handleFocus(e, "sellingPrice"),
              onKeyDown: (e) => handleKeyDown(e, "sellingPrice"),
              readOnly: props.session.isReadOnly ? true : false,
            },
            ignoreParentClass: true,
            editableForTemplate: true,
            previousAuditObj: showPreviousAuditData
              ? {
                  label: `Previous ${isAuditor ? `${(productOrService == 'service')? 'Service ' : 'Product '}` : ""}Price`,
                  value: oldAuditPriceObj.singlePrice || "",
                  hide: showOldPriceRange,
                  holderClass:
                    " " + (oldAuditPriceObj.singlePrice == 0 ? "move-up" : ""),
                }
              : null,
          },
          {
            // hide: showPriceRange,
            label: "Select Unit",
            disableMovingLabel: true,
            key: "unitOfMeasurement",
            inputRef: scrollEle,
            // showArrow:
            //   props.session.isReadOnly ||
            //     isBrandedProduct ||
            //     (!isGalleryProd &&
            //       props.unitOfMeasurement.displayVal &&
            //       (selectedType == "service" || selectedType == "product"))
            //     ? false
            //     : true,
            rightIconClass:
              props.unitOfMeasurement.displayVal &&
              !props.session.isReadOnly &&
              !isBrandedProduct &&
              // !isAuditor &&
              !isTemplate &&
              !isTempProd &&
              (selectedType == "service" || selectedType == "product")
                ? `icon-HDRcross ${isMobile ? "font11" : "font10"}`
                : props.session.isReadOnly ||
                  isBrandedProduct ||
                  (!isGalleryProd &&
                    props.unitOfMeasurement.displayVal &&
                    (selectedType == "service" || selectedType == "product"))
                ? ""
                : "icon-Next uom-unit",
            onRightIconClick: () => {
              if (props.unitOfMeasurement.displayVal) {
                let data = { ...props.unitOfMeasurement };
                data.value = "";
                if (!data.key) {
                  data.key = "unitOfMeasurement";
                }
                props.updateEditProductDetail(data);
              } else {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              }
            },
            holderClass: 'priceUnit '+(props.session.isReadOnly
              ? "read-only-mode"
              : isBrandedProduct
              ? "branded-product-mode"
              : ""),
            input: {
              value:
                (!isGalleryProd && props.unitOfMeasurement.displayVal) || "",
              onChange: (e) => handleChange(e, "unitOfMeasurement"),
              readOnly: true,
              disabled:
                props.unitOfMeasurement.displayVal &&
                (isTemplate || isBrandedProduct || isTempProd),
              onClick: () => {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              },
            },
            previousAuditObj: showPreviousAuditData
              ? {
                  label: "Select Unit",
                  value: props.oldUnitOfMeasurement.displayVal || "",
                  hide: showOldPriceRange,
                  holderClass: " ",
                }
              : null,
            ignoreParentClass: true,
            editableForTemplate: true,
          },
        ],
        error: errors
      }]),
    ...getFields([
      {
        hide: toggleIndex == 2 || showSellOnline || (selectedType == 'service' && toggleIndex != 3),
        sellingProductPrice: true,
        checkError: (value, newErrors, isError) =>
          checkError(value, "sellingProductPrice", newErrors, isError),
        holderClass:
          styles["more-detail-grp"] +
          " " +
          styles["marginLR15"] +
          " " +
          styles.marginT12 +
          " " +
          styles["unit-holder"] +
          " " +
          styles["prod-price"] +
          " " +
          `${errors["sellingPrice"] ? styles["marginB14"] : ""}` +
          (selectedType == "service" ? styles["product-name-field"] : ""),
        previousAuditObj: showPreviousAuditData
          ? {
              hide:
                showOldPriceRange ||
                (oldAuditPriceObj.singlePrice == newAuditPriceObj.singlePrice &&
                  oldAuditData.unitOfMeasurement ==
                    currentAuditData.unitOfMeasurement),
            }
          : null,
        formElements: [
          {
            // hide: showPriceRange,
            label : `${(productOrService == 'service') ? "Service Price" : (isAuditor ? "Product Price" : "Price")}`,
            inputRef: scrollEle,
            prepend: () => <span className="icon-currency" />,
            hidePrependBar: true,
            showPreTextWithoutFocus: true,
            errorClass: "hide-error-text",
            labelAlwaysUp: true,
            key: "sellingPrice",
            holderClass: props.session.isReadOnly ? "read-only-mode" : "",
            input: {
              value:
                priceObj.singlePrice || (props.session.isReadOnly ? " " : ""),
              type: "tel",
              onChange: (e) => handleChange(e, "sellingPrice"),
              onFocus: (e) => handleFocus(e, "sellingPrice"),
              onKeyDown: (e) => handleKeyDown(e, "sellingPrice"),
              readOnly: props.session.isReadOnly ? true : false,
            },
            ignoreParentClass: true,
            editableForTemplate: true,
            inputGroupProps: {
              rightSection: () => {
                return (
                  <span
                    className="per-unit font-14"
                    style={{ color: "#718190" }}
                  >
                    Per
                  </span>
                );
              },
            },
            previousAuditObj: showPreviousAuditData
              ? {
                  label: `Previous ${isAuditor ? `${(productOrService == 'service')? 'Service ' : 'Product '}` : ""}Price`,
                  value: oldAuditPriceObj.singlePrice || "",
                  hide: showOldPriceRange,
                  holderClass:
                    " " + (oldAuditPriceObj.singlePrice == 0 ? "move-up" : ""),
                }
              : null,
          },
          {
            // hide: showPriceRange,
            label: "Select Unit",
            disableMovingLabel: true,
            key: "unitOfMeasurement",
            inputRef: scrollEle,
            // showArrow:
            //   props.session.isReadOnly ||
            //     isBrandedProduct ||
            //     (!isGalleryProd &&
            //       props.unitOfMeasurement.displayVal &&
            //       (selectedType == "service" || selectedType == "product"))
            //     ? false
            //     : true,
            rightIconClass:
             (props.unitOfMeasurement.displayVal &&
              !props.session.isReadOnly &&
              !isBrandedProduct &&
              // !isAuditor &&
              !isTemplate &&
              !isTempProd &&
              (selectedType == "service" || selectedType == "product"))
                ? `icon-HDRcross ${isMobile ? "font11" : "font10"}`
                : props.session.isReadOnly ||
                  isBrandedProduct ||
                  (!isGalleryProd &&
                    props.unitOfMeasurement.displayVal &&
                    (selectedType == "service" || selectedType == "product"))
                ? ""
                : "icon-Next",
            onRightIconClick: () => {
              if (props.unitOfMeasurement.displayVal) {
                let data = { ...props.unitOfMeasurement };
                data.value = "";
                if (!data.key) {
                  data.key = "unitOfMeasurement";
                }
                props.updateEditProductDetail(data);
              } else {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              }
            },
            holderClass: props.session.isReadOnly
              ? "read-only-mode"
              : isBrandedProduct
              ? "branded-product-mode"
              : "",
            input: {
              value:
                (!isGalleryProd && props.unitOfMeasurement.displayVal) || "",
              onChange: (e) => handleChange(e, "unitOfMeasurement"),
              readOnly: true,
              disabled:
                props.unitOfMeasurement.displayVal &&
                (isTemplate || isBrandedProduct || isTempProd),
              onClick: () => {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              },
            },
            previousAuditObj: showPreviousAuditData
              ? {
                  label: "Select Unit",
                  value: props.oldUnitOfMeasurement.displayVal || "",
                  hide: showOldPriceRange,
                  holderClass: " ",
                }
              : null,
            ignoreParentClass: true,
            editableForTemplate: true,
          },
        ],
      },
      {
        hide: toggleIndex == 1 || toggleIndex == 3 || showSellOnline,
        priceRange: true,
        checkError: (value, newErrors, isError) =>
          checkError(value, "priceRange", newErrors, isError),
        previousAuditObj: showPreviousAuditData
          ? {
              hide:
                !showOldPriceRange ||
                (oldAuditPriceObj.minPrice == newAuditPriceObj.minPrice &&
                  oldAuditPriceObj.maxPrice == newAuditPriceObj.maxPrice &&
                  oldAuditData.unitOfMeasurement ==
                    currentAuditData.unitOfMeasurement),
            }
          : null,
        holderClass:
          styles["marginLR15"] +
          " " +
          // styles["marginTB24"] +
          styles["unit-holder"] +
          " " +
          styles["prod-price"] +
          " " +
          (props.session.isReadOnly ? " read-only-mode" : ""),
        inputObj: [
          {
            label: "Min. Price",
            key: "minPrice",
            inputRef: scrollEle,
            holderClass:
              "min-price" + (props.session.isReadOnly ? " read-only-mode" : ""),
            input: {
              value: priceObj.minPrice || (props.session.isReadOnly ? " " : ""),
              //autoFocus: true,
              type: isIPhone ? "text" : "tel",
              onChange: (e) => handleChange(e, "minPrice"),
              onFocus: (e) => handleFocus(e, "minPrice"),
              readOnly: props.session.isReadOnly ? true : false,
            },
            previousAuditObj: showPreviousAuditData
              ? {
                  label: "Min. Price",
                  value: oldAuditPriceObj.minPrice || "",
                  holderClass:
                    " " + (oldAuditPriceObj.minPrice == 0 ? "move-up" : ""),
                }
              : null,
          },
          {
            label: "Max. Price",
            key: "maxPrice",
            inputRef: scrollEle,
            holderClass:
              "max-price" + (props.session.isReadOnly ? " read-only-mode" : ""),
            input: {
              value: priceObj.maxPrice || (props.session.isReadOnly ? " " : ""),
              type: isIPhone ? "text" : "tel",
              onChange: (e) => handleChange(e, "maxPrice"),
              onFocus: (e) => handleFocus(e, "maxPrice"),
              readOnly: props.session.isReadOnly ? true : false,
            },
            previousAuditObj: showPreviousAuditData
              ? {
                  label: "Max. Price",
                  value: oldAuditPriceObj.maxPrice || "",
                  holderClass:
                    " " + (oldAuditPriceObj.maxPrice == 0 ? "move-up" : ""),
                }
              : null,
          },
          {
            label: "Unit",
            key: "unitOfMeasurement",
            holderClass:
              "unit-measurement" +
              (props.session.isReadOnly ? " read-only-mode" : ""),
            showArrow: props.session.isReadOnly ,
            input: {
              value: props.unitOfMeasurement.displayVal || "",
              onChange: (e) => handleChange(e, "unitOfMeasurement"),
              readOnly: true,
              disabled: isTemplate || isBrandedProduct || isTempProd,
              className: styles["range-unit-of-measurement"],
              onClick: () => {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              },
            },
            previousAuditObj: showPreviousAuditData
              ? {
                  label: "Unit",
                  value: props.oldUnitOfMeasurement.displayVal || "",
                  holderClass: " ",
                }
              : null,
            ignoreParentClass: true,
            editableForTemplate: true,
          },
        ],
        error: errors,
      },
      {
        // hide: (selectedType == 'service') || showSellOnline,
        hide: true,
        customJSX: (
          <div
            className={`${styles["more-detail-switch"]} ${
              errors["minPrice"] || errors["maxPrice"]
                ? styles["error-flag"]
                : ""
            } ${props.session.isReadOnly ? "read-only-switch" : ""}`}
          >
            <Switch
              label="Add Price Range"
              labelPosition="before"
              labelTitleClass={styles["price-range-label"]}
              onClick={() => toggleRange(!showPriceRange)}
              checked={showPriceRange}
              showToggleStatus={false}
            />
          </div>
        ),
      },
    ]),
    {
      hide: showSellOnline || !(errors['actualPrice'] || errors["sellingPrice"]),
      customJSX: (
        <div className={`${styles["custom-error-msg"]}`}>
          {typeof errors['actualPrice'] == 'string' && errors['actualPrice'] ? errors['actualPrice'] : errors["sellingPrice"]}
        </div>
      ),
    },
    {
      hide: productOrService == 'product' || !(['Session',"Visit","Session(s)","Visit(s)"].includes(props.unitOfMeasurement.displayVal)) || isVariant,
      customJSX: <UnitCount
                  uomDetails={props.unitOfMeasurement || ''}
                  showUnitCount={['Sess', 'Visit'].includes(props.unitOfMeasurement.val)}
                  customDuration={props.productData.customDuration || ''}
                />
    },
    ...getFields([
      {
        hide: selectedType !== 'service' || props.unitOfMeasurement?.val !== 'stds' || isVariant,
        checkError: (value, newErrors, isError) =>
          checkError(value, "specificDuration", newErrors, isError),
        key: 'specificDuration',
        holderClass:
        styles["more-detail-grp"] +
          " " +
          styles["marginLR15"] +
          " " +
          styles.marginT12 +
          " " +
          styles["unit-holder"] +
          " " +
          styles["prod-price"] +
          " " +
          `${errors["specificDuration"] ? styles["marginB14"] : ""}` +
          (selectedType == "service" ? styles["product-name-field"] : ""),
        formElements: [
          {
            // hide: showPriceRange,
            label: `Specific Duration`,
            inputRef: scrollEle,
            hidePrependBar: true,
            showPreTextWithoutFocus: true,
            errorClass: "hide-error-text",
            labelAlwaysUp: true,
            key: "specificDuration",
            holderClass: props.session.isReadOnly ? "read-only-mode" : "",
            input: {
              value:
                productData.specificDuration || (props.session.isReadOnly ? " " : ""),
              type: "tel",
              onChange: (e) => handleChange(e, "specificDuration"),
              onFocus: (e) => handleFocus(e, "specificDuration"),
              onKeyDown: (e) => handleKeyDown(e, "specificDuration"),
              readOnly: props.session.isReadOnly ? true : false,
            },
            ignoreParentClass: true,
            editableForTemplate: true,
            previousAuditObj: showPreviousAuditData
              ? {
                  label: `Previous ${isAuditor ? "Product " : ""}Price`,
                  value: oldAuditPriceObj.singlePrice || "",
                  hide: showOldPriceRange,
                  holderClass:
                    " " + (oldAuditPriceObj.singlePrice == 0 ? "move-up" : ""),
                }
              : null,
          },
          {
            customJSX: (
                <Dropdown
                  value={productData?.specificDurationUnit || 'months'}
                  className={styles['specific-duration'] +' '+(errors['actualProductWeight']?styles['marginB14']:'')}
                  valueClass={styles["drop-div"]}
                  onChange={e => {
                    props.updateEditProductDetail([{
                      key: 'specificDurationUnit',
                      value: e.key
                    }])
                  }}
                  optionList = {SpecificDurationDropDown}
                />
                )
              }
            ]
          },
      {
        hide: showSellOnline || !errors["specificDuration"],
        customJSX: (
          <div className={`${styles["custom-error-msg"]}`}>
            {errors["specificDuration"]}
          </div>
        ),
      },
      // {
      //   hide: selectedType === 'service' || showPrimaryManuExpDates,
      //   holderClass:
      //     styles["more-detail-grp"] +
      //     " " +
      //     styles["marginLR15"] +
      //     " " +
      //     (isMobile ? "" : "min-qty-web-margin") +
      //     " " +
      //     styles["unit-holder"] +
      //     " " +
      //     styles["min-order-qty"],
      //   previousAuditObj: showPreviousAuditData && selectedType != "service"
      //     ? {
      //         hide:
      //         oldAuditData.minOrderQuantity ==
      //           currentAuditData.minOrderQuantity &&
      //         oldAuditData.unitOfMeasurement ==
      //           currentAuditData.unitOfMeasurement,
      //       }
      //     : null,
      //   formElements: [
      //     {
      //       label: "Min. Order Quantity",
      //       key: "minOrderQuantity",
      //       holderClass: props.session.isReadOnly ? "read-only-mode" : "",
      //       errorClass: "hide-error-text",
      //       input: {
      //         value:
      //           !isGalleryProd && productData.minOrderQuantity
      //             ? productData.uomType == "PACKED"
      //               ? Math.floor(productData.minOrderQuantity)
      //               : productData.minOrderQuantity
      //             : props.session.isReadOnly
      //             ? " "
      //             : "",
      //         type: "tel",
      //         onChange: (e) => handleChange(e, "minOrderQuantity"),
      //         onFocus: (e) => handleFocus(e, "minOrderQuantity"),
      //         onKeyDown: (e) => handleKeyDown(e, "minOrderQuantity"),
      //         readOnly: props.session.isReadOnly ? true : false,
      //       },
      //       ignoreParentClass: true,
      //       editableForTemplate: true,
      //       previousAuditObj: showPreviousAuditData && selectedType != "service"
      //         ? {
      //             label: "Previous Min. Order Quantity",
      //             labelOnTop: true,
      //             value: oldAuditData.minOrderQuantity || "",
      //           }
      //         : null,
      //     },
      //     {
      //       label: "Select Unit",
      //       disableMovingLabel: true,
      //       key: "unitOfMeasurement",
      //       // showArrow:
      //       //   props.session.isReadOnly || isBrandedProduct || (!isGalleryProd && props.unitOfMeasurement.displayVal && selectedType == 'product') ? false : true,
      //       rightIconClass:
      //         props.unitOfMeasurement.displayVal &&
      //         !props.session.isReadOnly &&
      //         !isBrandedProduct &&
      //         selectedType == "product" &&
      //         !isTemplate &&
      //         !isTempProd
      //           ? `icon-HDRcross ${isMobile ? "font11" : "font10"}`
      //           : props.session.isReadOnly ||
      //             isBrandedProduct ||
      //             (!isGalleryProd &&
      //               props.unitOfMeasurement.displayVal &&
      //               selectedType == "product")
      //           ? ""
      //           : "icon-Next",
      //       onRightIconClick: () => {
      //         if (props.unitOfMeasurement.displayVal) {
      //           let data = { ...props.unitOfMeasurement };
      //           data.value = "";
      //           if (!data.key) {
      //             data.key = "unitOfMeasurement";
      //           }
      //           props.updateEditProductDetail(data);
      //         } else {
      //           !props.session.isReadOnly &&
      //             sliderRef.current.openCloseUOMSlider(true);
      //         }
      //       },
      //       holderClass: props.session.isReadOnly
      //         ? "read-only-mode"
      //         : isBrandedProduct
      //         ? "branded-product-mode"
      //         : "",
      //       input: {
      //         value:
      //           (!isGalleryProd && props.unitOfMeasurement.displayVal) || "",
      //         onChange: (e) => handleChange(e, "unitOfMeasurement"),
      //         readOnly: true,
      //         disabled:
      //           props.unitOfMeasurement.displayVal &&
      //           (isTemplate || isBrandedProduct || isTempProd),
      //         onClick: () => {
      //           !props.session.isReadOnly &&
      //             sliderRef.current.openCloseUOMSlider(true);
      //         },
      //       },
      //       ignoreParentClass: true,
      //       editableForTemplate: true,
      //       previousAuditObj: showPreviousAuditData
      //         ? {
      //             label: "",
      //             value: props.oldUnitOfMeasurement.displayVal || "",
      //           }
      //         : null,
      //     },
      //   ],
      // },
    ]),
    // {
    //   hide: isAuditor || showSellOnline || isVariant,
    //   customJSX: NudgePrice({ toggleIndex , productData: props.productData })
    // },
    ...getFields([
      {
        holderClass:
          styles["more-detail-grp"] +
          " " +
          styles["marginLR15"] +
          " " +
          styles["unit-holder"] +
          " " +
          styles["min-order-qty"] +
          " " +
          styles["sellOnline-minQuantity"],
        hide: showSellOnline || selectedType == "service" || isVariant,
        key: 'minOrderQuantity',
        formElements: [
          {
            label: "Min. Order Quantity",
            key: "minOrderQuantity",
            holderClass: props.session.isReadOnly ? "read-only-mode" : "",
            errorClass: "hide-error-text",
            input: {
              value:
                !isGalleryProd && productData.minOrderQuantity
                  ? productData.uomType == "PACKED"
                    ? Math.floor(productData.minOrderQuantity)
                    : productData.minOrderQuantity
                  : props.session.isReadOnly
                  ? " "
                  : "",
              type: "tel",
              onChange: (e) => handleChange(e, "minOrderQuantity"),
              onFocus: (e) => handleFocus(e, "minOrderQuantity"),
              onKeyDown: (e) => handleKeyDown(e, "minOrderQuantity"),
              readOnly: props.session.isReadOnly ? true : false,
            },
            ignoreParentClass: true,
            editableForTemplate: true,
          },
          {
            label: "Select Unit",
            disableMovingLabel: true,
            key: "unitOfMeasurement",
            // showArrow:
            //   props.session.isReadOnly || isBrandedProduct || (!isGalleryProd && props.unitOfMeasurement.displayVal && selectedType == 'product') ? false : true,
            rightIconClass:
              props.unitOfMeasurement.displayVal &&
              !props.session.isReadOnly &&
              !isBrandedProduct &&
              selectedType == "product" &&
              !isTemplate &&
              !isTempProd
                ? `icon-HDRcross ${isMobile ? "font11" : "font10"}`
                : props.session.isReadOnly ||
                  isBrandedProduct ||
                  (!isGalleryProd &&
                    props.unitOfMeasurement.displayVal &&
                    selectedType == "product")
                ? ""
                : "icon-Next",
            onRightIconClick: () => {
              if (props.unitOfMeasurement.displayVal) {
                let data = { ...props.unitOfMeasurement };
                data.value = "";
                if (!data.key) {
                  data.key = "unitOfMeasurement";
                }
                props.updateEditProductDetail(data);
              } else {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              }
            },
            holderClass: props.session.isReadOnly
              ? "read-only-mode"
              : isBrandedProduct
              ? "branded-product-mode"
              : "",
            input: {
              value:
                (!isGalleryProd && props.unitOfMeasurement.displayVal) || "",
              onChange: (e) => handleChange(e, "unitOfMeasurement"),
              readOnly: true,
              disabled:
                props.unitOfMeasurement.displayVal &&
                (isTemplate || isBrandedProduct || isTempProd),
              onClick: () => {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              },
            },
            ignoreParentClass: true,
            editableForTemplate: true,
            previousAuditObj: showPreviousAuditData
              ? {
                  label: "",
                  value: props.oldUnitOfMeasurement.displayVal || "",
                }
              : null,
          },
        ],
      },
    ]),
    {
      hide:
        showSellOnline || 
        selectedType == "service" || 
        isVariant ||
        !errors["minOrderQuantity"],
      customJSX: (
        <div className={`${styles["custom-error-msg"]}`}>
          {errors["minOrderQuantity"]}
        </div>
      ),
    },
    {
      hide: showSellOnline || isVariant || productOrService == 'service',
      key: 'maxSupplyCapacity',
      checkError: (value, key, newErrors, isError) =>
            checkError(value, key, newErrors, isError),
      customJSX: (
        <div className={styles['max-supply-cap'] + ' ' + styles["marginLR15"]}>
          <div>
            <InputWithMovingLabel
              label='Max. Sup. Capacity'
              holderClass={styles['maxsup-holder']}
              inputGroupProps={{
                  rightSection: () => showInputPlaceHolder ? 'Per' : '',
                  onFocus: () => {
                    setShowInputPlaceHolder(true)
                  },
                  onBlur: () => {
                    if(maxSupplyCapacity) {
                      setShowInputPlaceHolder(true);
                    } else {
                      setShowInputPlaceHolder(false);
                    }
                  }
              }}
              errorMessage={errors['maxSupplyCapacity']}
              errClass={"error-div"}
              input={{
                  type: 'tel',
                  value: maxSupplyCapacity,
                  onFocus: e => handleFocus(e,'maxSupplyCapacity'),
                  onChange: e => {
                     if(!isNaN(e.target.value)) {
                      setMaxSupplyCapacity(e.target.value);     
                     }                      
                  }
              }}
            />
          </div>
          <div>
              <Dropdown
                  className={`${styles['dropdown-div']}`}
                  optionList={dateOptions}
                  valueClass={`${styles['selectPeroid']}`}
                  onChange={(e, value) => { dropdownSelect(e, value) }}
                  placeholder='Select Period'
                  value={supplyTimePeriod}
              ></Dropdown>
              {errors['supplyTimePeriod'] ? <div className={styles['custom-error-msg2']}>{errors['supplyTimePeriod']}</div> : null}
          </div>
        </div>
      )
    },
    {
      hide: showSellOnline || toggleIndex == 1 || toggleIndex == 2,
      customJSX: (
        <div className={styles["marginLR15"]}>
          <PriceRangeQty
            isActive={false}
            defaultPrice={priceObj.singlePrice}
            unitOfMeasurement={productData.unitOfMeasurement}
            onRef={(ref) => setPriceRangeQtyRef(ref)}
            updateSellOnlineFormData={updateSellOnlineFormData}
            handleMaxQty={(maxQty) =>
              updateSellOnlineFormData(maxQty, "maxQty")
            }
            handleRangeOnMinQty={() => {
              return checkErrorForMinOrder('', '', {}, false);
            }}
          />
        </div>
      ),
    },
    ...getFields([
      {
        holderClass: `${styles["single-batch-holder"]} ${styles["mrp-row"]} ${
          errors[`quantity`] == "allSellFieldEmpty" ||
          errors[`mrp`] == "allSellFieldEmpty" ||
          errors[`sellingOnlinePrice`] == "allSellFieldEmpty"
            ? "all-quanity-error"
            : ""
        }`,
        hide:
          !showSellOnline ||
          selectedType == "service" ||
          isBrandedProduct ||
          props.variantProps.variantProductData?.length||
          isVariant,
        singleBatchSellOnline: true,
        checkError: (value, newErrors, isError) =>
          checkError(value, "singleBatchSellOnline", newErrors, isError),
        formElements: [
          {
            label: "In Stock Qty.",
            key: "quantity",
            holderClass: props.session.isReadOnly || disableSellOnlineCustom ? "read-only-mode number-field" : "number-field",
            ignoreParentClass: true,
            input: {
              value: productData.quantity || "",
              type: "tel",
              onChange: (e) => handleChange(e, "quantity"),
              onFocus: (e) => handleFocus(e, "quantity"),
              readOnly: props.session.isReadOnly ? true : false,
              className:
                errors[`quantity`] == "allSellFieldEmpty"
                  ? styles["dim-red-border"]
                  : "",
              disabled: disableSellOnlineCustom
            },
            checkError: (value) => checkError(value, "quantity"),
            errorClass: `${styles["batch-input-error"]} ${
              errors[`quantity`] == "allSellFieldEmpty" ? "hide-error-text" : "err-qty"
            }`,
            hide: (isAuditor && (isTemplate || isTempProd))
          },
          // {
          //   label: "MRP",
          //   key: "mrp",
          //   holderClass: props.session.isReadOnly ? "read-only-mode" : "",
          //   ignoreParentClass: true,
          //   input: {
          //     value: productData.mrp?.toString()?.replaceAll(',','') || "",
          //     type: isIPhone ? "text" : "number",
          //     onChange: (e) => handleChange(e, "mrp"),
          //     readOnly: props.session.isReadOnly ? true : false,
          //     className:
          //       errors[`mrp`] == "allSellFieldEmpty"
          //         ? styles["dim-red-border"]
          //         : "",
          //     onFocus: (e) => handleFocus(e, "mrp"),
          //   },
          //   checkError: (value) => checkError(value, "mrp"),
          //   errorClass: `${styles["batch-input-error"]} ${
          //     errors[`mrp`] == "allSellFieldEmpty" ? "hide-error-text" : ""
          //   }`,
          // },
          {
            label: "MRP",
            key: "mrp",
            holderClass: `${styles["mrp-input-wrap"]} ${props.session.isReadOnly ? "read-only-mode" : ""}`,
            ignoreParentClass: true,
            input: {
              value: productData.mrp?.toString()?.replaceAll(',','') || "",
              type: "tel",
              onChange: (e) => handleChange(e, "mrp"),
              readOnly: props.session.isReadOnly ? true : false,
              className:`${errors[`mrp`] == "allSellFieldEmpty"
              ? styles["dim-red-border"]
              : ""}`
               ,
              onFocus: (e) => handleFocus(e, "mrp"),
            },
            hide: getHideMrp(),
            checkError: (value) => checkError(value, "mrp"),
            errorClass: `${styles["batch-input-error"]} ${
              errors[`mrp`] == "allSellFieldEmpty" ? "hide-error-text" : ""
            }`,
          },
          {
            ...getMRPInput((isAuditor&& isTemplate) || !getHideMrp())
          },

          {
            label: "Selling Price",
            key: "sellingOnlinePrice",
            holderClass: props.session.isReadOnly || disableSellOnlineCustom ? "read-only-mode" : "",
            ignoreParentClass: true,
            input: {
              value: productData.sellingOnlinePrice?.toString()?.replaceAll(',','') || "",
              type: "tel",
              onChange: (e) => handleChange(e, "sellingOnlinePrice"),
              onFocus: (e) => handleFocus(e, "sellingOnlinePrice"),
              readOnly: props.session.isReadOnly ? true : false,
              className:
                errors[`sellingOnlinePrice`] == "allSellFieldEmpty"
                  ? styles["dim-red-border"]
                  : "",
              disabled: disableSellOnlineCustom
            },
            checkError: (value) => checkError(value, "sellingOnlinePrice"),
            errorClass: `${styles["batch-input-error"]} ${
              errors[`sellingOnlinePrice`] == "allSellFieldEmpty"
                ? "hide-error-text"
                : ""
            }`,
            hide: (isAuditor && (isTemplate || isTempProd))
          },
        ],
      },
      {
        hide: (isAuditor && isTemplate) || props.session.viaOmni,
        customJSX:getBothCommentAndUpload(getHideMrp() && !productData.mrp_status ? {...productData , mrp_status: ''} : productData)
      },
    ]),
    {
      hide:
        !showSellOnline ||
        !productData.lowestPrice ||
        parseFloat(productData.lowestPrice.toString()?.replaceAll(',','')) >= parseFloat(productData.sellingOnlinePrice.toString()?.replaceAll(',','')) || (isAuditor && (isTemplate || isTempProd)) || 0,//productData.lowestPrice && productData.lowestPrice > Number(productData.sellingOnlinePrice || 0)
      customJSX: (
        <div
          className="lowest-price-holder lowest-price-holder-add-edit"
          onClick={() => matchLowestPrice(productData.lowestPrice)}
        >
          <span className="lowest-price-title">
            <span className="icon-refresh"></span>Match Lowest Competitor Price:{" "}
          </span>
          <span className="lowest-price-title">
            <span className={`${styles["currency"]} icon-currency`}></span>
            {productData.lowestPrice}
          </span>
        </div>
      ),
    },
    {
      hide:
        !showSellOnline ||
        selectedType == "service" ||
        isBrandedProduct ||
        (!(errors[`quantity`] == "allSellFieldEmpty") &&
          !(errors[`mrp`] == "allSellFieldEmpty") &&
          !(errors[`sellingOnlinePrice`] == "allSellFieldEmpty")),
      customJSX: (
        <div className={`${styles["batch-dimension-error"]}`}>
          {"Please Enter Quantity and Price"}
        </div>
      ),
    },
    // {
    //     key: 'cp',
    //     label: `Cost Price`,
    //     holderClass: `single-width ${styles["cost-price"]}`,
    //     ignoreParentClass: true,
    //     type: 'tel',
    //     input: {
    //       value: productData.cp?.toString()?.replaceAll(',','') || "",
    //       type: isIPhone ? "text" : "number",
    //       onChange: (e) => handleChange(e, "cp"),
    //       onFocus: (e) => handleFocus(e, "cp"),
    //     },        
    // },
    {
      holderClass: `${styles["marginLR15"]}  ${styles["cp-barcode"]}`,
      hide: !showSellOnline || !showSOFields || productData.variantCommands?.length>0 || props.variantProductData?.length > 0,
      formElements: [
        {
          key: 'cost_price',
          label: `Cost Price`,
          holderClass: `single-width ${styles["cost-price"]}`,
          ignoreParentClass: true,
          type: 'tel',
          input: {
            value: Number(productData.cost_price?.toString()?.replaceAll(',','')) || "",
            type: isIPhone || isApp ? "tel": "text",
            onChange: (e) => handleChange(e, "cost_price"),
            onFocus: (e) => handleFocus(e, "cost_price"),
            onBlur: (e) => handleChange(e, "cost_price")
          },    
          checkError: (value) => checkError(value, "cost_price"),
          errorClass: styles["prod-input-error"],  
        },
        // {
        //   label: "EAN Barcode",
        //   key: "barcode",
        //   holderClass: styles["barcode-field-holder"],
        //   ignoreParentClass: true,
        //   input: {
        //     value: productData.barcode || "",
        //     onChange: (e) => handleChange(e, "barcode"),
        //   },
        //   rightSection: () =>(props.isSourceJustdial && !productData.barcode?<i className={'icon-barcode '+styles['barcode-btn']} onClick={barcodeScan} />:null),
        //   parentClass: styles["barcode-field"],
        //   errorClass: styles["error-text"],
        // }
        {
          label: "Barcode",
          holderClass: "barcode-field",
          key: "barcode",
          ref: barcodeRef,
          ignoreParentClass: true,
          inputGroupProps: {
              rightSection: () => {
                  return (
                      <div className="barcode-icons">
                          {barcodeLoader && <Loader />}
                          {(!barcodeLoader && !isApp && (Array.isArray(productData?.barcode) && productData?.barcode?.length == 0 || !productData.barcode)) && <i onClick={fillBarcode} className="icon-Generate"></i>}
                          {isApp && <i onClick={barcodeScan} className="icon-ScanBarcode"></i>}
                      </div>
                  );
              }
          },
          input: {
              value: productData.barcode || "",
              onFocus: (e) => {
                  e.currentTarget && scrollIntoView(e.currentTarget);
              },
              onChange: e => {
                  handleChange(e, "barcode");
              }
          }
      }
      ],
    },
    ...getFields([
      {
        label: "Batch / Lot Number",
        key: "newconsignmentNo",
        holderClass: styles["batch-lot-num"],
        input: {
            value: productData.newconsignmentNo || "",
            onChange: e => {
                handleChange(e, "newconsignmentNo", true);
            },
            onFocus: e => {
              handleFocus(e,"newconsignmentNo")
            }
        },
        parentClass: styles["barcode-field"],
        hide: !showSellOnline || !props.permissions.isMaintainBatch || !showSOFields,
        errorClass: styles["error-text"],
      },
    ]),
    {
      hide: !showSellOnline || showSOFields || isVariant || selectedType == 'service',
      customJSX: (
        <div
          className={`${styles["add-barcode-section"]} ${
            errors[`quantity`] || errors[`mrp`] || errors[`sellingOnlinePrice`]
              ? "barcode-quanity-error"
              : ""
          }`}
          onClick={() => {
            toggleShowSOFields(true);
          }}
        >
          <span className={`icon-plus ${styles["add-barcode-icon"]}`}></span>
          {"Add More Details"}
        </div>
      ),
    },
    ...getFields([
      {
        label: "EAN Barcode",
        key: "barcode",
        holderClass: styles["barcode-field-holder"],
        input: {
          value: productData.barcode || "",
          onChange: (e) => handleChange(e, "barcode"),
          readOnly: props.session.isReadOnly ? true : false,
        },
        rightSection: () =>(props.isSourceJustdial && !productData.barcode?<i className={'icon-barcode '+styles['barcode-btn']} onClick={barcodeScan} />:null),
        parentClass: styles["barcode-field"],
        hide: !showSellOnline || !showBarcodeField || isBrandedProduct || (isTempProd || isTemplate),
        errorClass: styles["error-text"],
      },
    ]),
    // {
    //   hide: !(showPrimaryManuExpDates && !productData.expiry_date && !productData.manufacturing_date),
    //   customJSX: (
    //     <div className={`${styles["rejected-product-container"]} ${styles["audit-pending"]} ${styles["marginLR15"]}`}>
    //       <div className={`${styles["pending-text"]} ${styles["warning-status"]}`}>
    //         <i className="icon-Info"></i>
    //         <div>
    //           <div className={styles["pending-status"]}>
    //             Product Expiry Details Required
    //           </div>
    //           <div className={`${styles["rejection-message"]}`}>
    //             Mandated government regulation requires Expiry Details to be showcased on the marketplace.
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   ),
    // },
    {
      hide: !showSOFields || !showPrimaryManuExpDates,
      expiryBatch: true,
      checkError: (value, newErrors, isError) => {
        return checkErrorForExpiryBatch(newErrors, isError);
      },
      customJSX: <div className={`${styles['marginLR15']} ${styles['product-expiry-by']}`}>
                  <ProductExpiry
                    errors={errors}
                    setItemErrors={updateError}
                    holderClass={"paddingLR0"}
                  />
                </div>
    },
    ...getFields([
      {
        hide:
          productData.variantCommands?.length>0 ||
          productData?.productId === "ADD_PRODUCT" ||
          !productData.isSellOnline ||
          productData?.total_consignments <= 1 || (isAuditor && (isTemplate || isTempProd)),
        customJSX: (
          <div
            className={`general-details section-container ptb15 marginT16  view-inventory-cta ${!(isAuditor || productData.reviewStatus == 'REJECTED')?"followed-by-add-inventory":""}`}
            onClick={() => !props.session.isReadOnly && setInventory(true)}
          >
            <div
              className={`more-sec-label view-all-batches single-line-label no-margin`}
            >
              <i className="icon-InventoryInvoice more-sec-icon"></i> View All
              Inventory Batches
            </div>
          </div>
        ),
      },
    ]),
    ...getFields([
      {
        hide: props.session.viaOmni || productData.variantCommands?.length>0 || selectedType == "service" || !productData.isSellOnline,
        customJSX: (
          <div
            className="general-details section-container ptb15 marginT16 add-inventory-cta"
            onClick={() => !props.session.isReadOnly && setAddInventory(true)}
          >
            <div
              className={`more-sec-label view-all-batches single-line-label no-margin`}
            >
              <i className="icon-plus more-sec-icon"></i> Add New
                Inventory Batch
            </div>
          </div>
        ),
      },
    ]),
    ...getFields([
      {
        holderClass:
          styles["more-detail-grp"] +
          " " +
          styles["marginLR15"] +
          " " +
          styles["unit-holder"] +
          " " +
          styles["min-order-qty"] +
          " " +
          styles["sellOnline-minQuantity"],
        hide: !showSellOnline || selectedType == "service" || isVariant,
        formElements: [
          {
            errorClass: "hide-error-text",
            label: "Min. Order Quantity",
            key: "minOrderQuantity",
            holderClass: props.session.isReadOnly ? "read-only-mode" : "",
            input: {
              value:
                !isGalleryProd && productData.minOrderQuantity
                  ? productData.uomType == "PACKED"
                    ? Math.floor(productData.minOrderQuantity)
                    : productData.minOrderQuantity
                  : props.session.isReadOnly
                  ? " "
                  : "",
              type: "tel",
              onChange: (e) => handleChange(e, "minOrderQuantity"),
              onFocus: (e) => handleFocus(e, "minOrderQuantity"),
              onKeyDown: (e) => handleKeyDown(e, "minOrderQuantity"),
              readOnly: props.session.isReadOnly ? true : false,
            },
            ignoreParentClass: true,
            editableForTemplate: true,
          },
          {
            label: "Select Unit",
            disableMovingLabel: true,
            key: "unitOfMeasurement",
            // showArrow:
            //   props.session.isReadOnly || isBrandedProduct || (!isGalleryProd && props.unitOfMeasurement.displayVal && selectedType == 'product') ? false : true,
            rightIconClass:
              props.unitOfMeasurement.displayVal &&
              !props.session.isReadOnly &&
              !isBrandedProduct &&
              selectedType == "product" &&
              !isTemplate &&
              !isTempProd
                ? `icon-HDRcross ${isMobile ? "font11" : "font10"}`
                : props.session.isReadOnly ||
                  isBrandedProduct ||
                  (!isGalleryProd &&
                    props.unitOfMeasurement.displayVal &&
                    selectedType == "product")
                ? ""
                : "icon-Next",
            onRightIconClick: () => {
              if (props.unitOfMeasurement.displayVal) {
                let data = { ...props.unitOfMeasurement };
                data.value = "";
                if (!data.key) {
                  data.key = "unitOfMeasurement";
                }
                props.updateEditProductDetail(data);
              } else {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              }
            },
            holderClass: props.session.isReadOnly
              ? "read-only-mode"
              : isBrandedProduct
              ? "branded-product-mode"
              : "",
            input: {
              value:
                (!isGalleryProd && props.unitOfMeasurement.displayVal) || "",
              onChange: (e) => handleChange(e, "unitOfMeasurement"),
              readOnly: true,
              disabled:
                props.unitOfMeasurement.displayVal &&
                (isTemplate || isBrandedProduct || isTempProd),
              onClick: () => {
                !props.session.isReadOnly &&
                  sliderRef.current.openCloseUOMSlider(true);
              },
            },
            ignoreParentClass: true,
            editableForTemplate: true,
            previousAuditObj: showPreviousAuditData
              ? {
                  label: "",
                  value: props.oldUnitOfMeasurement.displayVal || "",
                }
              : null,
          },
        ],
      },
    ]),
    {
      hide:
        !showSellOnline || 
        selectedType == "service" || isVariant ||
        !errors["minOrderQuantity"],
      customJSX: (
        <div className={`${styles["custom-error-msg"]}`}>
          {errors["minOrderQuantity"]}
        </div>
      ),
    },
    // ...getFields([
    //   {
    //     label: (
    //       <>
    //         Commission Rate
    //         <Popover
    //           content="This is the commission % that you will pay to JdMart for each successful sales transaction involving this product"
    //           containerEle={commissionRef}
    //         >
    //           <div className={styles["icon-holder"]}>
    //             <i
    //               className="icon-Info info-icon"
    //               style={{
    //                 fontSize: props.deviceData.isMobile ? "14px" : "12px",
    //                 cursor: "pointer",
    //               }}
    //             ></i>
    //           </div>
    //         </Popover>
    //       </>
    //     ),
    //     key: "commissionRate",
    //     holderClass: styles["commission-field-holder"],
    //     input: {
    //       maxLength: 10,
    //       type: isIPhone ? "number" : "tel",
    //       value: productData.commissionRate || "",
    //       onChange: (e) => handleChange(e, "commissionRate"),
    //       onFocus: (e) => handleFocus(e, "commissionRate"),
    //       readOnly: props.session.isReadOnly ? true : false,
    //     },
    //     inputGroupProps: {
    //       rightSection: () => {
    //         return (
    //           <span className="font-14" style={{ color: "#718190" }}>
    //             %
    //           </span>
    //         );
    //       },
    //     },
    //     parentRef: commissionRef,
    //     parentClass: styles["commission-field"],
    //     labelAlwaysUp: true,
    //     hide: !showSellOnline || selectedType == "service" || isBrandedProduct,
    //     checkError: (value) => checkError(value, "commissionRate"),
    //     errorClass: styles["error-text"],
    //   },
    // ]),

    {
      hide: !showSellOnline || !props.permissions?.sellOnlineInBulk,
      customJSX: (
        <div className={styles["marginLR15"]}>
          <div onClick={e=>toggleBulkSell(v=>!v)} className={styles['sell-online-label']}>
            <div>Sell Online in Bulk / Wholesale</div>
            <FormSwitch
              label={''}
              checked={showBulkSell}
              className={`${styles['input-row']} ${styles['label-row']}`}
              onClick={(e) => { e.stopPropagation() }}
              showToggleStatus={false}
            // variant='secondary'
            />
          </div>
        </div>
      ),
    },
    {
      hide: !showSellOnline || !showBulkSell,
      customJSX: (
        <div className={styles["marginLR15"]}>
          <PriceRangeQty
            isActive={false}
            defaultPrice={productData.mrp?.toString()?.replaceAll(',','')}
            unitOfMeasurement={productData.unitOfMeasurement}
            onRef={(ref) => setPriceRangeQtyRef(ref)}
            updateSellOnlineFormData={updateBulkSellFormData}
            handleMaxQty={(maxQty) =>
              updateBulkSellFormData(maxQty, "maxQty")
            }
            handleRangeOnMinQty={() => {
              return checkErrorForMinOrder('', '', {}, false);
            }}
          />
        </div>
      ),
    },


    {
      hide: (!showSellOnline && !isContractorV1V2) || selectedType == "service" || (props.hideLBH && props.hideWeight && (isTempProd || isTemplate)),
      customJSX: (
        <div className={`${styles["prod-dimension-Text"]}`}>
          {`Product Packaging Dimensions`}
        </div>
      ),
    },

    ...getFields([
      {
        label: "Actual Product Weight in Kilograms (kg)",
        key: "actualProductWeight",
        holderClass: styles["actual-wt-input"],
        input: {
            value: productData.actualProductWeight || "",
            onChange: e => {
                handleChange(e, "actualProductWeight", true);
            },
            onFocus: e => {
              handleFocus(e,"actualProductWeight")
            }
        },
        hide: (!showSellOnline && !isContractorV1V2) || selectedType == "service" || (props.hideLBH && props.hideWeight && (isTempProd || isTemplate)),
        // hide: this.props.permissions.isVolumetricWeightEnabled && this.props.itemInfo.packagingType != 'LOOSE',
        errorClass: styles["error-text"],
      },
    ]),

    ...getFields([
      {
        holderClass: `${styles["prod-dimension-holder"]} ${
          errors[`productLength`] ||
          errors[`productWidth`] ||
          errors[`productHeight`]
            ? "prod-error-present"
            : ""
        }`,
        hide:
          (!showSellOnline && !isContractorV1V2) ||
          selectedType == "service" ||
          isBrandedProduct || (props.hideLBH && (isTempProd || isTemplate)),
        packageDimensions: true,
        // checkError: (name, newErrors, isError) => {
        //   return !(isAuditor && isObjectionableQueue) ? checkErrorForProductDimensions(newErrors, isError):'';
        // },
        formElements: [
          {
            label: "Length (cm)",
            key: "productLength",
            maxLength: 10,
            holderClass: `product-dimension-length ${
              props.session.isReadOnly ? "read-only-mode" : ""
            }`,
            ignoreParentClass: true,
            input: {
              type: isIPhone ? "text" : "tel",
              value: typeof productData.productLength === "string" && productData.productLength.toLowerCase()?.includes("cm") ? parseFloat(productData.productLength) : productData.productLength || "",
              onChange: (e) => handleChange(e, "productLength"),
              onFocus: (e) => handleFocus(e, "productLength"),
              readOnly: props.session.isReadOnly ? true : false,
              disabled: productData?.compliance?.packaging_length && (isTemplate || isTempProd),
              className: errors[`productLength`]
                ? styles["dim-red-border"]
                : "",
            },
            checkError: (value) => checkError(value, "productLength"),
            errorClass: styles["prod-input-error"],
          },
          {
            label: "Width (cm)",
            key: "productWidth",
            maxLength: 10,
            holderClass: props.session.isReadOnly ? "read-only-mode" : "",
            ignoreParentClass: true,
            input: {
              type: isIPhone ? "text" : "tel",
              value: typeof productData.productWidth === "string" && productData.productWidth.toLowerCase()?.includes("cm")  ? parseFloat(productData.productWidth) : productData.productWidth || "",
              onChange: (e) => handleChange(e, "productWidth"),
              onFocus: (e) => handleFocus(e, "productWidth"),
              readOnly: props.session.isReadOnly ? true : false,
              className: errors[`productWidth`] ? styles["dim-red-border"] : "",
              disabled: productData?.compliance?.packaging_width && (isTemplate || isTempProd),
            },
            checkError: (value) => checkError(value, "productWidth"),
            errorClass: styles["prod-input-error"],
          },
          {
            label: "Height (cm)",
            key: "productHeight",
            maxLength: 10,
            holderClass: props.session.isReadOnly ? "read-only-mode" : "",
            ignoreParentClass: true,
            input: {
              type: isIPhone ? "text" : "tel",
              value: typeof productData.productHeight === "string" && productData.productHeight.toLowerCase()?.includes("cm")  ? parseFloat(productData.productHeight) : productData.productHeight || "",
              onChange: (e) => handleChange(e, "productHeight"),
              onFocus: (e) => handleFocus(e, "productHeight"),
              readOnly: props.session.isReadOnly ? true : false,
              className: errors[`productHeight`]
                ? styles["dim-red-border"]
                : "",
                disabled: productData?.compliance?.packaging_height && (isTemplate || isTempProd),
            },
            checkError: (value) => checkError(value, "productHeight"),
            errorClass: styles["prod-input-error"],
          },
        ],
      },
    ]),

    {
      hide: (!showSellOnline && !isContractorV1V2) || selectedType == "service" || (props.hideLBH && props.hideWeight && (isTempProd || isTemplate)),
      customJSX: (
        <div className={`${styles["prod-dimension-info"]}`}>
          {subText}
        </div>
      ),
    },



    // ...getFields([
    //   {
    //     holderClass: `${styles["prod-dimension-holder"]} ${
    //       errors[`productLength`] ||
    //       errors[`productWidth`] ||
    //       errors[`productHeight`]
    //         ? "prod-error-present"
    //         : ""
    //     }`,
    //     hide:
    //       (!showSellOnline && !isContractorV1V2) ||
    //       selectedType == "service" ||
    //       isBrandedProduct || (props.hideLBH && (isTempProd || isTemplate)),
    //     packageDimensions: true,
    //     checkError: (name, newErrors, isError) => {
    //       return !(isAuditor && isObjectionableQueue) ? checkErrorForProductDimensions(newErrors, isError):'';
    //     },
    //     formElements: [
    //       {
    //         label: "Length (cm)",
    //         key: "productLength",
    //         maxLength: 10,
    //         holderClass: `product-dimension-length ${
    //           props.session.isReadOnly ? "read-only-mode" : ""
    //         }`,
    //         ignoreParentClass: true,
    //         input: {
    //           type: isIPhone ? "text" : "tel",
    //           value: typeof productData.productLength === "string" && productData.productLength.toLowerCase()?.includes("cm") ? parseFloat(productData.productLength) : productData.productLength || "",
    //           onChange: (e) => handleChange(e, "productLength"),
    //           onFocus: (e) => handleFocus(e, "productLength"),
    //           readOnly: props.session.isReadOnly ? true : false,
    //           disabled: productData?.compliance?.packaging_length && (isTemplate || isTempProd),
    //           className: errors[`productLength`]
    //             ? styles["dim-red-border"]
    //             : "",
    //         },
    //         checkError: (value) => checkError(value, "productLength"),
    //         errorClass: styles["prod-input-error"],
    //       },
    //       {
    //         label: "Width (cm)",
    //         key: "productWidth",
    //         maxLength: 10,
    //         holderClass: props.session.isReadOnly ? "read-only-mode" : "",
    //         ignoreParentClass: true,
    //         input: {
    //           type: isIPhone ? "text" : "tel",
    //           value: typeof productData.productWidth === "string" && productData.productWidth.toLowerCase()?.includes("cm")  ? parseFloat(productData.productWidth) : productData.productWidth || "",
    //           onChange: (e) => handleChange(e, "productWidth"),
    //           onFocus: (e) => handleFocus(e, "productWidth"),
    //           readOnly: props.session.isReadOnly ? true : false,
    //           className: errors[`productWidth`] ? styles["dim-red-border"] : "",
    //           disabled: productData?.compliance?.packaging_width && (isTemplate || isTempProd),
    //         },
    //         checkError: (value) => checkError(value, "productWidth"),
    //         errorClass: styles["prod-input-error"],
    //       },
    //       {
    //         label: "Height (cm)",
    //         key: "productHeight",
    //         maxLength: 10,
    //         holderClass: props.session.isReadOnly ? "read-only-mode" : "",
    //         ignoreParentClass: true,
    //         input: {
    //           type: isIPhone ? "text" : "tel",
    //           value: typeof productData.productHeight === "string" && productData.productHeight.toLowerCase()?.includes("cm")  ? parseFloat(productData.productHeight) : productData.productHeight || "",
    //           onChange: (e) => handleChange(e, "productHeight"),
    //           onFocus: (e) => handleFocus(e, "productHeight"),
    //           readOnly: props.session.isReadOnly ? true : false,
    //           className: errors[`productHeight`]
    //             ? styles["dim-red-border"]
    //             : "",
    //             disabled: productData?.compliance?.packaging_height && (isTemplate || isTempProd),
    //         },
    //         checkError: (value) => checkError(value, "productHeight"),
    //         errorClass: styles["prod-input-error"],
    //       },
    //     ],
    //   },
    // ]),
    // {
    //   hide:
    //     (!showSellOnline && !isContractorV1V2) ||
    //     selectedType == "service" ||
    //     isBrandedProduct ||
    //     (!errors[`productLength`] &&
    //       !errors[`productWidth`] &&
    //       !errors[`productHeight`]),
    //   customJSX: (
    //     <div className={`${styles["prod-dimension-error"]}`}>
    //       {errors[`productLength`] ||
    //         errors[`productWidth`] ||
    //         errors[`productHeight`]}
    //     </div>
    //   ),
    // },
    // ...getFields([
    //   {
    //     label: "Packaged Weight",
    //     key: "actualProductWeight",
    //     holderClass: styles["package-weight-field-holder"]+' number-field '+styles["package-weight-text-input"],
    //     input: {
    //       maxLength: 10,
    //       type: isIPhone ? "text" : "tel",
    //       value: productData.actualProductWeight || "",
    //       onChange: (e) => handleChange(e, "actualProductWeight"),
    //       onFocus: (e) => handleFocus(e, "actualProductWeight"),
    //       readOnly: props.session.isReadOnly ? true : false,
    //       disabled: productData?.compliance?.packaging_weight
    //     },
    //     checkError: (value) => checkError(value, "packageWeight"),
    //     inputGroupProps: {
    //       rightSection: () => {
    //         return <span className={styles["package-weight-field-holder-unit"]}>Kg</span>;
    //       },
    //     },
    //     parentClass: styles["package-weight-field"],
    //     hide:
    //       ((!showSellOnline && !isContractorV1V2) ||
    //       selectedType == "service" ||
    //       isBrandedProduct || (props.hideWeight && (isTemplate || isTempProd))) || (productData.productId == 'ADD_PRODUCT'?productData.logistic_flag == '1': productData.logistic_flag == '1' && !productData.oldProductWeight),
    //     errorClass: styles["error-text"],
    //   },
    // ]),
    //   ...getFields([{
    //     key: 'packageWeightGram',
    //     hide: ((!showSellOnline && !isContractorV1V2) ||
    //     selectedType == "service" ||
    //     isBrandedProduct || (props.hideWeight && (isTemplate || isTempProd))) || (productData.productId == 'ADD_PRODUCT' ? productData.logistic_flag != '1'  : !(productData.logistic_flag == '1' && !productData.oldProductWeight)),
    //     holderClass:
    //     styles["more-detail-grp"] +
    //     " " +
    //     styles["marginLR15"] +
    //     " " +
    //     (isMobile ? "" : "min-qty-web-margin") +
    //     " " +
    //     " " +
    //     styles["package-weight-field-with-dropdown"],
    //     checkError: (value, newErrors, isError) =>
    //       checkError(value, "packageWeight",newErrors,isError),
    //     formElements: [
    //       {
    //         label: "Packaged Weight",
    //         key: "actualProductWeight",
    //         holderClass: styles["package-weight-field-holder"]+' number-field '+(errors['actualProductWeight']?'err':''),
    //         input: {
    //           maxLength: 10,
    //           type: isIPhone ? "text" : "tel",
    //           value: productData.actualProductWeight || "",
    //           onChange: (e) => handleChange(e, "actualProductWeight"),
    //           onFocus: (e) => handleFocus(e, "actualProductWeight"),
    //           readOnly: props.session.isReadOnly ? true : false,
    //         },
    //         checkError: (value) => checkError(value, "packageWeight"),
    //         parentClass: styles["package-weight-field"],
    //         hide:false &&(
    //           (!showSellOnline && !isContractorV1V2) ||
    //           selectedType == "service" ||
    //           isBrandedProduct || (props.hideWeight && (isTemplate || isTempProd))),
    //         errorClass: styles["error-text"],
    //       },
    //       {
    //         customJSX: (
    //             <Dropdown
    //               value={productData?.packUnit || 'Kg'}
    //               className={styles['weight-dropdown'] +' '+(errors['actualProductWeight']?styles['marginB14']:'')}
    //               valueClass={styles["drop-div"]}
    //               onChange={e => {
    //                 props.updateEditProductDetail([{
    //                   key: 'packUnit',
    //                   value: e.key
    //                 }])
    //               }}
    //               optionList = {[
    //                 {
    //                   label: 'Kilogram(s)',
    //                   key: 'Kg'
    //                 },
    //                 {
    //                   label: 'Gram(s)',
    //                   key: 'Gm'
    //                 }
    //               ]}
    //             />
    //         )
    //       }
    //     ]
    //   }]),
    {
      hide:
        selectedType == "service" ||
        (productData.compliance && productData.compliance["country_of_origin"] && !(productData?.compliance["country_of_origin"]?.toLowerCase() != 'india' && !productData?.compliance["importers_detail"])),
      checkError: (value) => checkError(value, "countryOfOrigin"),
      key: "countryOfOrigin",
      input: {
        value: selectedCountry,
      },
      customJSX: (
        <>
          <div className={`${styles[`country-selector`]}`}>
            <div
              className={styles[`country-holder`]}
              onClick={() => {
                !props.session.isReadOnly && !(productData.compliance && productData?.compliance["country_of_origin"] && productData?.compliance["country_of_origin"]?.toLowerCase() != 'india' && !productData?.compliance["importers_detail"]) ? openCountrySlider() : null;
              }}
            >
              <div
                className={`${styles[`country-container`]} ${
                  !selectedCountry.countryCode
                    ? styles[`empty-country-container`]
                    : null
                }`}
              >
                {selectedCountry.countryCode ? (
                  <>
                    <label className={styles[`country-label`]}>
                      Country Of Origin
                    </label>
                    <div className={styles["country-flag"]}>
                      {(countrySuggestions.some(cur => cur.countryCode == selectedCountry.countryCode) || (!!props.countryList.find(x =>  x.countryName == selectedCountry.countryName))) &&
                        <span
                          className={`flag sprite ${
                            flagStyles["sprite-" + selectedCountry.countryCode]
                          }`}
                        ></span>
                      }
                    </div>
                  </>
                ) : null}
                <div
                  className={`${styles[`country-input`]} ${(productData.compliance && productData?.compliance["country_of_origin"] && productData?.compliance["country_of_origin"]?.toLowerCase() != 'india' && !productData?.compliance["importers_detail"]) ? "disabled" : ''} ${
                    errors[`countryOfOrigin`] ? "red-border" : ""
                  } ${props.deviceData.isMobile ? "mobile-country-input" : ""}`}
                >
                  {selectedCountry.countryName
                    ? selectedCountry.countryName
                    : "Country Of Origin"}
                </div>
                <div className={styles[`country-right-icon`]}>
                  <span className={"country-arrow-icon icon-Next"}></span>
                </div>
              </div>
            </div>
            {!selectedCountry.countryCode ? (
              <div
                className={`${"suggestion-options"} ${
                  props.deviceData.isMobile ? "mobile-suggestion-options" : ""
                }`}
              >
                {countrySuggestions.map((cur) => {
                  return (
                    <div
                      class="suggestion-option"
                      onClick={() => {
                        props.session.isReadOnly ? null : updateCountry(cur);
                      }}
                    >
                      <span
                        className={`suggestion-flag sprite ${
                          flagStyles["sprite-" + cur.countryCode]
                        }`}
                      ></span>
                      <span class="suggestion-options-name">
                        {cur.countryName}
                      </span>
                    </div>
                  );
                })}
                <div
                  class="suggestion-option more-option"
                  onClick={() => {
                    props.session.isReadOnly ? null : openCountrySlider();
                  }}
                >
                  <span className={`icon-plus`}></span>
                  <span class="suggestion-more">More</span>
                </div>
              </div>
            ) : null}
            {errors["countryOfOrigin"] ? (
              <div className={styles["country-err"]}>
                {errors["countryOfOrigin"]}
              </div>
            ) : null}
          </div>
        </>
      ),
    },
    {
      hide: !props.isImporterPresent || !selectedCountry.countryCode || selectedCountry.countryCode == "IN",
      checkError: (value, newErrors, isError) => {
        return checkErrorForImporter(newErrors, isError);
      },
      importer: true,
      customJSX: (
        <div className={`${styles["marginLR15"]} ${styles["out-spec"]}`}>
          <ImporterDetails errors={errors} updateError={updateError} />
        </div>
      ),
    },
    ...getFields([
      {
        label: `${isAuditor? ((productOrService == 'service') ? 'Service Description' : 'Product Description') : 'Description' }`,
        key: "description",
        holderClass:
          ((errors[`productLength`] ||
            errors[`productWidth`] ||
            errors[`productHeight`]) &&
          showSellOnline
            ? styles.marginT8
            : styles.marginT20) +
          " " +
          styles["wyswig-div"] +
          " " + styles["description-text-input"] +
          (props.session.isReadOnly ? " read-only-mode description" : ""),
        input: {
          value:
            productData.description || (props.session.isReadOnly ? " " : ""),
          onChange: (e, options) => handleChange(e, "description", options),
          onKeyDown: (e) => handleKeyDown(e, "description"),
          readOnly: props.session.isReadOnly ? true : false,
          onPaste: (e) => {
            e.persist();
            setTimeout(() => {
              const value = formatProdDesc(
                (document.querySelector(".wyswig-div [contenteditable]") && document.querySelector(".wyswig-div [contenteditable]").innerHTML) || ''
              )?.slice(0,8000);
              if (value.length) {
                updateCount(value.length);
                togglePaste(false);
              }
              handleChange(e, "description", {
                value,
              });
            }, 0);
          },
        },
        errorClass: (errors['description'] ? '' : styles['char-count']),
        inputRef: scrollEle,
        hide: isBrandedProduct || isTempProd || isTemplate,
        as: "editableContent",
        showRightSectionAlways: true,
        rightSection: () =>
          showPaste ? (
            <div
              className={styles["paste-option"]}
              onClick={() => pasteFromClipboard()}
            >
              Paste
            </div>
          ) : null,
          showBottomSection: true,
          bottomSection: () =>(
            <div className={`${styles['marginLR15']} ${styles['ai-desc']}`}>
              <Button className={reTryAI ? styles['ai-try-again-btn'] : styles['ai-btn']} onClick={generateDescription}>
                <MagicWind/>
                <span>{reTryAI ? `Let AI Rewrite` : `Let AI Write`}</span>
              </Button>
              <div className={`${styles['bottom-sesction-char-count']}`}>
                {`${descCount}/8000 Characters`}
              </div>
            </div>
          ),
        previousAuditObj: showPreviousAuditData
          ? {
              label: `Previous ${isAuditor ? `${(productOrService == 'service')? 'Service ' : 'Product '}` : ""}Description`,
              value: oldAuditData.description,
              hide: oldAuditData.description == currentAuditData.description,
            }
          : null,
      },
    ]),
    {
      hide: selectedType == "service" || isAuditor || props.variantProps.variantProductData?.length || props.permissions?.isMaintainProductSku,
      customJSX: (
        <div className={`${styles["marginLR15"]} ${styles["out-spec"]}`}>
          <SkuField itemInfo={productData} setFieldValue={setFieldValue} errors={errors} updateError={updateError} token={props.session.token} />
        </div>
      ),
    },
  ];
  const productType =
    isAddProduct || savedUOM.current.uomType != "LOOSE"
      ? productData.uomType
      : savedUOM.current.uomType;
  const moreElements = [];

  let formComponent = (
    <FormElement
      formElements={formElements}
      // isTemplate={isTemplate}
      errors={errors}
    />
  );

  const hideMoreFields = productType == "LOOSE";

  //Approve pending and deletion pending
  const updateList = (productId, isRemove) => {
    let tempList =
      props.tabKey == "approvalPending"
        ? [...props.approvalPendingList]
        : [...props.deletionPendingList];
    if (tempList.indexOf(productId) != -1) {
      tempList.splice(tempList.indexOf(productId), 1);
      if (props.tabKey == "approvalPending") {
        props.updateApprovalPending({ approvalPendingList: tempList });
      } else if (props.tabKey == "deletionPending") {
        props.updateDeletionPending({ deletionPendingList: tempList });
      }
    }
  };
  let location = useLocation();
  const deleteProduct = () => {
    if (isAuditor) {
      // let specialContract = "";
      // if (location.search.indexOf("isSpecialContract=true")) {
      //   specialContract = "&isSpecialContract=true";
      // }
      // axios
      //   .get(
      //     `/marketplace/static/php/web/b2bWebsite.php?action=deleteProduct&token=${props.session.token}&productId=${productData.productId}${specialContract}`
      //   )
      //   .then((data) => {
      //     data = data.data;
      //     if (data.status) {
      //       if (auditFromPage) {
      //         props.showToastMessage({
      //           showToastMessage: true,
      //           message: "Product Deleted",
      //           duration: 5000,
      //         });
      //         window.history.go(-2);
      //       } else {
      //         fetchAuditUrl({
      //           cb: (data) => {
      //             fetchResolve({ data });
      //             updateTAPLoader(false);
      //           },
      //         });
      //       }
      //     }
      //   });
    } else {
      updateList(productData.productId, true);
      props.updateProductStatus({
        action: "delete",
        isDelete: true,
        token: props.session.token,
        productId: productData.productId,
        cb: () => {
          props.getListingData({ tabKey: props.tabKey });
          props.showToastMessage({
            showToastMessage: true,
            message: "Product Deleted - " + productData.productName,
            duration: 5000,
          });
          history.goBack();
        },
      });
    }
  };
  const dontApprove = () => {
    toggleBtnLoader(true)
    if (!isAuditor) {
      let productId = productData.productId;
      if(productData?.variantCommands?.length){
        let pidList = "";
        productData.variantCommands.map((cur,index) => {
          pidList = pidList+''+cur.id + (index != (productData.variantCommands.length - 1)?",":'')
        })
        productId = pidList;
      }
      axios
        .get(
          `/marketplace/static/php/web/b2bWebsite.php?action=rejectProduct&token=${props.session.token}&productId=${productId}&approveStatus=REJECTED`
        )
        .then((data) => {
          toggleBtnLoader(false);
          props.getListingData({ tabKey: props.tabKey });
          updateList(productData.productId, true);
          props.showToastMessage({
            showToastMessage: true,
            message: `${selectedType == 'service' ? 'Service' : 'Product'} Rejected`,
            duration: 5000,
          });
          if(isMobile){
            setTimeout(()=>{
              history.replace('/products');
            },200)
          }
          else{
            historyHandler.closeAll();
          }
        });
    }
  };

  let headerText = "Edit Product";
  if (!isAuditor) {
    if (isAddProduct) {
      if (props.productData.generic_p_id) {
        headerText = "Edit Product";
      } else if (productOrService == "service") {
        headerText = "Add a Service";
      } else {
        headerText = "Add a Product";
      }
    } else {
      if (productOrService == "both") {
        headerText = "Edit Product / Service";
      } else if (productOrService == "service") {
        headerText = "Edit Service";
      }
    }
  }

  const copyCodeToClipboard = (copiedIdIdentity) => {
    if(copiedIdIdentity == "productId") {
      copytext.current.select();
      document.execCommand("copy");
      props.showToastMessage({
        showToastMessage: true,
        message: `${(productOrService == 'service') ? 'Service' : 'Product'} ID Copied`,
        type: "info",
        duration: 5000,
      });

    } else if(copiedIdIdentity == "productBankId") {
      copyProductBankIdText.current.select();
      document.execCommand("copy");
      props.showToastMessage({
        showToastMessage: true,
        message: `${(productOrService == 'service') ? 'Service' : 'Product'} Bank ID Copied`,
        type: "info",
        duration: 5000,
      });

    } else if(copiedIdIdentity == "productName") {
      copyProductNameText.current.select();
      document.execCommand("copy");
      props.showToastMessage({
        showToastMessage: true,
        message: `${(productOrService == 'service') ? 'Service' : 'Product'} Name Copied`,
        type: "info",
        duration: 5000,
      });

    }
  };
  let productTag = "";
  let tagColor = "";
  if (type) {
    let tmpType = mrpCompliance ? 'brandedMrp' : type;
    const tagValues = getAuditTagValues({
      type: tmpType,
    });
    productTag = tagValues.productTag;
    tagColor = tagValues.tagColor;
  }


  const ProductIdCopy = ({ copyLabel = "", isMobile, identity = "" }) => {
    return (
      <div className={styles["user-details-productid"]}>
        {copyLabel && <span className="copy-label">{copyLabel} : </span>}
        {
          mrpCompliance ?
            <>
              <div
                readonly="readonly"
                className={styles["copy-text"]}
              >
                &nbsp;{productData && productData.productId}
              </div>
              <textarea
                ref={copytext}
                readonly="readonly"
              >
                {productData && productData.productId}
              </textarea>
            </>
          :
            <textarea
              ref={copytext}
              readonly="readonly"
              className={styles["copy-text"]}
            >
              {productData && productData.productId}
            </textarea>
        }
        {isMobile ? (
          <div
            className={styles["product-id-copy-holder"]}
            onClick={() => copyCodeToClipboard(identity)}
          >
            <span
              className={styles["product-id-copy-icon"] + " icon-Copy"}
            ></span>
            COPY
          </div>
        ) : (
          <AnimateOnHover
            className={styles["product-id-copy-holder"]}
            onClick={() => copyCodeToClipboard(identity)}
          >
            <span
              className={styles["product-id-copy-icon"] + " icon-Copy"}
            ></span>
            COPY
          </AnimateOnHover>
        )}
      </div>
    );
  };
  const ProductBankIdCopy = ({ copyLabel = "", isMobile, identity = "" }) => {
    return (
      <div className={styles["user-details-productbankid"]}>
        {copyLabel && <span className={styles["copy-label"]}>
          <span className={styles["copy-label-text"]}>{copyLabel}: </span>

          {
            mrpCompliance?
            <>
              <div
                className={styles["copy-text"]}
              >
                &nbsp;{productData && productData.product_bankid}
              </div>
              <textarea
                ref={copyProductBankIdText}
                readonly="readonly"
              >
                {productData && productData.product_bankid}
              </textarea>
            </>
          :
            <textarea
              ref={copyProductBankIdText}
              readonly="readonly"
              className={styles["copy-text"]}
            >
              {productData && productData.product_bankid}
            </textarea>
          }


        </span>}
        {isMobile ? (
          <div
            className={styles["product-id-copy-holder"]}
            onClick={() => copyCodeToClipboard(identity)}
          >
            <span
              className={styles["product-id-copy-icon"] + " icon-Copy"}
            ></span>
            COPY
          </div>
        ) : (
          <AnimateOnHover
            className={styles["product-id-copy-holder"]}
            onClick={() => copyCodeToClipboard(identity)}
          >
            <span
              className={styles["product-id-copy-icon"] + " icon-Copy"}
            ></span>
            COPY
          </AnimateOnHover>
        )}
      </div>
    );
  };
  const ProductNameCopy = ({ copyLabel = "", isMobile, identity = "" }) => {
    return (
      <div className={styles["user-details-productname"]}>
        {copyLabel && <span className={styles["copy-label"]}>{copyLabel}: </span>}
        <textarea
          ref={copyProductNameText}
          readonly="readonly"
          className={styles["copy-text"]}
          style={{height: `${productNameTextAreaScrollHeight}px`}}
        >
          {productData && productData.productName}
        </textarea>
        {isMobile ? (
          <div
            className={styles["product-id-copy-holder"]}
            onClick={() => copyCodeToClipboard(identity)}
          >
            <span
              className={styles["product-id-copy-icon"] + " icon-Copy"}
            ></span>
            COPY
          </div>
        ) : (
          <AnimateOnHover
            className={styles["product-id-copy-holder"]}
            onClick={() => copyCodeToClipboard(identity)}
          >
            <span
              className={styles["product-id-copy-icon"] + " icon-Copy"}
            ></span>
            COPY
          </AnimateOnHover>
        )}
      </div>
    );
  };

  const onUrlClick = (url) => {
    let redirectUrl = url;
    if (
      !(
        redirectUrl.indexOf("http://") == 0 ||
        redirectUrl.indexOf("https://") == 0
      )
    ) {
      redirectUrl = `https://` + redirectUrl;
    }
    window.open(redirectUrl, "_blank");
  };

  let noImgLabel = "Add a Product Photo";
  if (productOrService == "product") {
    noImgLabel = "Add a Product  Photo";
  } else if (productOrService == "service") {
    noImgLabel = "Add a Service Photo";
  }

  const editViewImageProps = {
    updateProductImage: props.updateProductMedia,
    deleteProductImage: props.deleteProductImage,
    deleteProductVideo: props.deleteProductVideo,
    showToastMessage: props.showToastMessage,
    showUndoToast: true,
    restoreProductData: props.restoreProductData,
    toggleLibrarySlider: props.toggleLibrarySlider,
    ignoreSave: true,
    isTemplate: (isTemplate || isTempProd) && props.productData?.showUpload !== 1,
    showUpload: props.productData?.showUpload || -1,
    hideAddVideo: Boolean(props.productData?.showUpload),
    canUploadImage: !props.session.isReadOnly && !isBrandedProduct,
    isReadOnly: props.productData.showUpload === 0 && (isTemplate || isTempProd),
    uploadSingleImage:
      isBrandedProduct || (isTempProd && productData?.productImages?.length <= 1)
        ? true
        : false,
    productId: productData.productId,
    showDots: isBrandedProduct ? true : false,
    isAddEditPage: isAddProduct || isEditProduct,
    imageUrlArr: props.productData.imageUrlArr,
    videoUrlIds:props.productData.videoUrlIds,
    noImgLabel: noImgLabel,
    onViewImageClick:toggleViewImageSlider,
    hideSaveButton: true,
    errorMessage: errors["image"] && !props.session.viaOmni
      ? productOrService == "product"
        ? "Please Upload Product Image"
        : "Please Upload Service Image"
      : "",
    isMobile: props.deviceData.isMobile,
    categoryType: !isAddProduct ? productData.categoryType : null,
    isTempProd: isTempProd && props.productData?.showUpload !== 1,
    dontShowPrimaryTag: isTemplate || isTempProd
  };

  const readOnlyViewImageProps = {
    imageUrlArr: mediaUrlArr,
    hideSaveButton: true,
    isReadOnly: true,
    isReadOnlyImageSlider: true,
    canUploadImage: true,
  };
  let saveButtonText = "Save";
  if (productData.reviewStatus == "APPROVAL_PENDING" && isOwner) {
    saveButtonText = `Save and Approve ${(productOrService == 'service') ? 'Service' : 'Product'} `;
  } else if (isOwner && !productData.ownerEdit && productData.isObjectionable) {
    saveButtonText = "Save";
  }
  const scrollHandler = (e) => {
    setScroll(e.target.scrollTop);
  };

  const taxObjProps = {
    heading: "Manage Taxes",
    headerVariant: "secondary",
    onHidden: () => toggleTaxSlider(false),
    initialData: {...taxObj},
    onSubmit: (result, upFrontData) => {
      props.updateEditProductDetail({ ...result });
      setTaxObj(upFrontData);
    },
    isMobile: isMobile,
  };

  const handleComplianceHistory = () => {
    // history.go(complianceModalShown ? -3 : -2);
    if(complianceModalShown){
        history.go(-3);
    }else{
        history.go(fromPhotos ? -1 : -2);
    }
  }

  const AISpecDataSavedHandler = (newSpecs) => {
    updateAISpecByPass(true);
    saveData({newSpecs});
  }

  const showProductUpdatedStatus = (status) => {
    handleResetSpecification();
    dispatch(
      toastMessageActions.showMessage({
        message: `Product ${isAddProduct ? "Added" : "Updated"} Successfully`,
        showReduxToast: true,
        duration: 5000,
      })
    );
    if (props.deviceData.isMobile) {
      setRouteChangeMessage({
        message: `Product ${isAddProduct ? "Added" : "Updated"} Successfully`,
      });
    }
    if(props.listingProdData.prodCount <= 1 && props.tabKey != 'auditPending'){
      props.setTabStatus({ tabKey: undefined }); //#329519
    }else{
      props.setTabStatus({ tabKey: props.tabKey }); //#329519
    }
    saveButtonStatus.current = "saved";
    if (productData.isDuplicate) {
      history.replace("/products");
      if (!props.deviceData.isMobile) {
        history.goBack();
        if (props.isSearchSliderOpen) {
          history.goBack();
        }
      }
    } else {
      saveButtonStatus.current == "saved" && props.resetProductData({});
      if (
        isAddProduct &&
        isMobile &&
        !isContractorV1V2 &&
        !props.viaSuggested
      ) {
        if(props.fromSellerDashboard){
          historyHandler.closeAll();
          dispatch(setFromSeller({fromSellerDashboard:false}));
          setTimeout(()=>{
            history.replace('/products');
          },200)
        }else{
         // history.go(complianceModalShown ? -3 : -2);
         handleComplianceHistory();
        }
      } else {
        if((isAddProduct && !props.viaSuggested) && isMobile){
          if(props.fromSellerDashboard){
            historyHandler.closeAll();
            dispatch(setFromSeller({fromSellerDashboard:false}));
            setTimeout(()=>{
              history.replace('/products');
            },200)
          }else{
            historyHandler.closeAll();
            setTimeout(()=>{
              if(!isContractorV1V2){
                history.go(-2)
              }
            },200)
          }
        } else {
          if (isMobile) {
            if(fromSellerRejected){
              setTimeout(()=>{
                history.replace('/products');
              },200)
              return;
            }
            if(complianceModalShown){
              history.go(-2);
            }else{
              history.goBack();
            }
            if(props.viaSuggested && props.viaSearchSuggested){
              props.setTabStatus({ tabKey: 'brand' });
            }
          } else {
            historyHandler.closeAll();
            if(props.fromSellerDashboard || fromSellerRejected){
              dispatch(setFromSeller({fromSellerDashboard:false}));
              setTimeout(()=>{
                history.replace('/products');
              },200)
            }
          }
        }
      }
    }
  };

  const closeComplianceModal = (status) =>{
    updateShowComplianceModal(false);
    setComplianceModalShown(true);
    if(docReqModal.docs?.length && !props?.session?.viaOmni){
      let reqModalData = {...docReqModal};
      reqModalData.show = true;
      toggledocReqModal(reqModalData);
    }else if(auditPendingData){
      setAuditPendingModal(true);
    }else{
      showProductUpdatedStatus(status);
    }
  }
  const showProductSourceVaidation = (res) => {
    let newErr = {};
    let scrollElem = "";
    newErr = { cv2ProductSource: res.data.msg };
    scrollElem = "cv2ProductSource";
    dispatch(
      toastMessageActions.showMessage({
        message: res.data.msg,
        type: "error",
        showReduxToast: true,
        duration: 5000,
        cb: (status) => scrollToError(status, scrollElem),
      })
    );
    updateError(newErr);
  }

  let scrollToError = (status, key) => {
    const errorElement = scrollEle.current[key];
    if (status == "open" && errorElement) {
      errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const confirmSellingPrice = () => {

    let prodName = props.productData.productName;
    prodName = prodName.trim();
    prodName = prodName.replace(/\s\s+/g, " ");
    toggleConfirmBtnLoader(true)
    let editProductData = [
      {
        key: "productName",
        value: prodName,
      },
      {
        key: "isSellOnline",
        value: showSellOnline,
      },
    ];
    if (
      props.productData &&
      props.productData.priceObj &&
      !props.productData.priceObj.isSinglePrice &&
      props.productData.priceObj.maxPrice &&
      props.productData.priceObj.minPrice &&
      props.productData.priceObj.minPrice == props.productData.priceObj.maxPrice
    ) {
      let priceObj = props.productData.priceObj;
      priceObj = {
        isSinglePrice: true,
        singlePrice: props.productData.priceObj.minPrice,
      };
      if (priceObj.priceOnQty?.length) {
        priceObj.priceOnQty = [];
      }
      editProductData.push({
        key: "priceObj",
        value: priceObj,
      });
      toggleRange(false); //As per discussion with Shaminder for #411805
    } else if (toggleIndex != 3) {
      let priceObj = props.productData.priceObj;
      if (priceObj?.priceOnQty?.length) {
        priceObj.priceOnQty = [];
      }
      editProductData.push({
        key: "priceObj",
        value: priceObj,
      });
    }

    let countryOriginName = "";
    let countryOriginCode = "";
    if (selectedCountry.countryName && selectedCountry.countryCode) {
      countryOriginName = selectedCountry.countryName;
      countryOriginCode = selectedCountry.countryCode;
    }
    editProductData.push({
      key: "countryOrigin",
      value: {
        name: "Country Of Origin",
        values: [countryOriginName, countryOriginCode],
        otherFlag: 0,
      },
    });
    if(!showSellOnline && maxSupplyCapacity && supplyTimePeriod) {
        editProductData.push({
          key: 'maxSupplyCapacity',
          value: maxSupplyCapacity
        },
        {
          key: 'supplyTimePeriod',
          value: supplyTimePeriod
        });
    }
    props.updateEditProductDetail(editProductData);
    props.saveAddEditProduct(null,  (res) => {
      toggleBtnLoader(false);
      toggleConfirmBtnLoader(false);
    toggleSellingPriceModal({show:false});

    if (
        res.data &&
        (res.data.status == 1 || res.data.status == 2) &&
        res.data.msg &&
        res.data.msg != "Product Updated Successfully" &&
        res.data.msg != "Service Updated Successfully" &&
        res.data.msg != 'updated successfully' &&
        res.data.msg != 'Reviewed Successfully'
      ) {
        let newErr = {};
        let msg = res.data.msg;
        let scrollElem = "";
        const { errorType, objectionableContent = [] } = res.data;
        if (errorType == "productName" && res.data.status == 2) {
          newErr = { productName: msg };
          scrollElem = "productName";
          dispatch(
            toastMessageActions.showMessage({
              message: msg,
              type: "error",
              showReduxToast: true,
              duration: 5000,
              cb: (status) => scrollToError(status, scrollElem),
            })
          );
          updateError(newErr);
        } else if (
          res.data.status == 1 &&
          res.data.msg == "objectionable content found"
        ) {
          toggleShowObjectionalModal({
            show: true,
            errors: objectionableContent,
          });
        } else if (res.data.status === 2) {
          dispatch(
            toastMessageActions.showMessage({
              message: msg,
              type: "error",
              showReduxToast: true,
              duration: 5000,
              cb: (status) => scrollToError(status, "description"),
            })
          );
          if (errorType === "productDesc") {
            updateError({
              description: msg,
            });
          }
        }
        saveButtonStatus.current = null;
        return;
      }
      if(res?.data?.status === 0 && res?.data?.msg?.toLowerCase() == 'keyword not active'){
        dispatch(
            toastMessageActions.showMessage({
              message: 'Keyword Not Active',
              type: "error",
              showReduxToast: true,
              duration: 5000,
              cb: (status) => scrollToError(status, "categoryName"),
            })
          )
          saveButtonStatus.current = null;
          toggleBtnLoader(false);
          return;
      }

      if (res.isSuccess) {
        if(res.data?.status && !res.data?.docrequiredData?.length > 0){
          handleResetSpecification();
        }
        updateList(productData.productId, true);
        if (isAuditor) {
          // if (res.isAlreadyAudited) {
          //   updateAuditMsg(
          //     `${(productOrService == 'service') ? 'Service' : 'Product'} details has got updated while you were auditing. Click on continue to get the updated version of the ${(productOrService == 'service') ? 'service' : 'product'}`
          //   );
          //   updateSaveProdConflict("alreadyAudited");
          //   updateTimeoutModal(true);
          //   updateProdLoader(false);
          //   return;
          // }
          // if (res.isOwnerEdited) {
          //   updateAuditMsg(
          //     `${(productOrService == 'service') ? 'Service' : 'Product'} details has been edited by the Owner while you were auditing. Click on continue to get the updated version of the ${(productOrService == 'service') ? 'service' : 'product'}`
          //   );
          //   updateSaveProdConflict("ownerEdited");
          //   updateTimeoutModal(true);
          //   updateProdLoader(false);
          //   return;
          // }
          // if (res.duplicateProduct) {
          //   let newErr = { productName: res.msg };
          //   let msgLabel = "Product";
          //   if (selectedType == "service") {
          //     msgLabel = "Service";
          //   }
          //   dispatch(
          //     toastMessageActions.showMessage({
          //       message: `${msgLabel} with this Name Already Exists in Your Catalogue`,
          //       type: "error",
          //       showReduxToast: true,
          //       duration: 5000,
          //       cb: (status) => scrollToError(status, "productName"),
          //     })
          //   );
          //   saveButtonStatus.current = null;
          //   updateError(newErr);
          //   return;
          // }
          // if(res.emptyImage && !(isAuditor && isObjectionableQueue)){
          //   let msg = `Please Upload ${(productOrService == 'service') ? 'Service' : 'Product'}  Image`;
          //   let newErr = { image: msg };
          //   setTimeout(() => {
          //     console.log("This is image Error>>>>>>>");
          //     window.scrollTo({ top: 0, behavior: "smooth" });
          //   }, 100);
          //   dispatch(
          //     toastMessageActions.showMessage({
          //       message: msg,
          //       type: "error",
          //       showReduxToast: true,
          //       duration: 5000
          //     })
          //   );
          //   updateProdLoader(false);
          //   toggleBtnLoader(false);
          //   updateError(newErr);
          //   saveButtonStatus.current = null;
          //   return;
          // }
          // if(res.invalidBrandedId){
          //   props.setAuditObject({
          //     brandedErr: 'Please Enter Valid Product ID',
          //   });
          //   let msg = 'Please Enter Valid Product ID';
          //   dispatch(
          //     toastMessageActions.showMessage({
          //       message: msg,
          //       type: "error",
          //       showReduxToast: true,
          //       duration: 5000
          //     })
          //   );
          //   saveButtonStatus.current = null;
          //   return;
          // }
          // if (auditFromPage) {
          //   let message = "Audit Details Saved Successfully";
          //   if (isAddProduct) {
          //     message = "Product Added Successfully";
          //   }
          //   dispatch(
          //     toastMessageActions.showMessage({
          //       message,
          //       showReduxToast: true,
          //       duration: 5000,
          //     })
          //   );
          //   if(props.docIdSearch){
          //     history.goBack();
          //   }else{
          //     setTimeout(()=>{
          //       history.go(-2);
          //     },200)
          //   }
          //   return;
          // }
          // if (options.fetchNextUrl) {
          //   fetchAuditUrl({
          //     cb: (data) => {
          //       fetchResolve({ data });
          //       if (!data.data.status) {
          //         saveButtonStatus.current = "saved";
          //       }
          //       updateProdLoader(false);
          //     },
          //   });
          // } else {
          //   saveButtonStatus.current = "saved";
          //   // showSuccessPage(true);
          //   history.push(auditHomePath);
          // }
        } else {
          let msgLabel = "Product";
          if (selectedType == "service") {
            msgLabel = "Service";
          }
          if (res.duplicateProduct) {
            let newErr = { productName: res.msg };
            dispatch(
              toastMessageActions.showMessage({
                message: res.msg,
                type: "error",
                showReduxToast: true,
                duration: 5000,
                cb: (status) => scrollToError(status, "productName"),
              })
            );
            saveButtonStatus.current = null;
            updateError(newErr);
            return;
          }
          if(res.data?.smartComplianceData && res.data?.smartComplianceData?.show){
            updateShowComplianceModal(true);
            if(res.data?.docrequiredData?.length > 0){
              toggledocReqModal({show:false,docs:res.data.docrequiredData});
            }else if(res.data?.auditPendingModal){
              // setAuditPendingModal(true);
              setAuditPendingData(true);
            }
            return;
          }else{
            if(res.emptyImage){
              let msg = 'Error in Image Upload,Please try again';
              let newErr = { image: msg };
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              });
              dispatch(
                toastMessageActions.showMessage({
                  message: msg,
                  type: "error",
                  showReduxToast: true,
                  duration: 5000
                })
              );
              updateProdLoader(false);
              toggleBtnLoader(false);
              updateError(newErr);
              saveButtonStatus.current = null;
              return;
            }
            dispatch(
              toastMessageActions.showMessage({
                message: `${msgLabel} ${isAddProduct ? "Added" : "Updated"
                  } Successfully`,
                showReduxToast: true,
                duration: 5000,
              })
            );
            if (props.deviceData.isMobile) {
              setRouteChangeMessage({
                message: `${msgLabel} ${isAddProduct ? "Added" : "Updated"
                  } Successfully`,
              });
            }
            if(props.listingProdData.prodCount <= 1 && props.tabKey != 'auditPending'){
              props.setTabStatus({ tabKey: undefined }); //#329519
            }else{
              props.setTabStatus({ tabKey: props.tabKey }); //#329519
            }
            saveButtonStatus.current = "saved";
            if (productData.isDuplicate) {
              history.replace("/products");
              if (!props.deviceData.isMobile) {
                history.goBack();
                if (props.isSearchSliderOpen) {
                  history.goBack();
                }
              }
            } else if (res.redirectToListing) {
              history.go(-2);
            } else {
              saveButtonStatus.current == "saved" &&  props.resetProductData({});
              if(isAddProduct && isMobile && !isContractorV1V2 && !props.viaSuggested){
                if(props.fromSellerDashboard){
                  historyHandler.closeAll();
                  dispatch(setFromSeller({fromSellerDashboard:false}));
                  setTimeout(()=>{
                    history.replace('/products');
                  },200)
                }else{
                  history.go(-2);
                }
              } else {
                if((isAddProduct && !props.viaSuggested) && isMobile){
                  if(props.fromSellerDashboard){
                    historyHandler.closeAll();
                    dispatch(setFromSeller({fromSellerDashboard:false}));
                    setTimeout(()=>{
                      history.replace('/products');
                    },200)
                  }else{
                    historyHandler.closeAll();
                    setTimeout(()=>{
                      if(isContractorV1V2){
                        history.goBack();
                      }else{
                        history.go(-2);
                      }
                    },200)
                  }
                }else{
                  if(isMobile){
                    if(fromSellerRejected){
                      setTimeout(()=>{
                        history.replace('/products');
                      },200);
                    }else{
                      history.goBack();
                    }
                    if(props.viaSuggested && props.viaSearchSuggested){
                      props.setTabStatus({ tabKey: 'brand' });
                    }
                  }else{
                    historyHandler.closeAll();
                    if(props.fromSellerDashboard || fromSellerRejected){
                      dispatch(setFromSeller({fromSellerDashboard:false}));
                      setTimeout(()=>{
                        history.replace('/products');
                      },200)
                    }
                  }
                }
              }
            }
          }
        }
      } else if (res.error == "ALL_IMAGE_NOT_UPLOADED") {
        dispatch(
          toastMessageActions.showMessage({
            message: "Please wait Image Upload is in Progress",
            showReduxToast: true,
            duration: 5000,
          })
        );
        saveButtonStatus.current = null;
      } else if (!res.isSuccess && res.data.isError) {
        showProductSourceVaidation(res);
        saveButtonStatus.current = null;
      }
      // window.location.reload();
    },
      {
        savedCustomSpecAttributes: props.savedCustomSpecAttributes,
        savedPuvSpecAttributes: props.savedPuvSpecAttributes?.length ? props.savedPuvSpecAttributes : props.editablePuvSpecAttributes,
        sendBMDetails: props.sendBMDetails,
        installData: props.installData,
        contentWeightUnitSaved: props.contentWeightUnitSaved,
        toggleIndex
      }
    );

  }
  const auditorMrpComplianceForm = [
    ...getFields([
      {
        holderClass: `${styles["single-batch-holder"]} ${
          errors[`quantity`] == "allSellFieldEmpty" ||
          errors[`mrp`] == "allSellFieldEmpty" ||
          errors[`sellingOnlinePrice`] == "allSellFieldEmpty"
            ? "all-quanity-error"
            : ""
        }`,
        auditorMrpBatchSellOnline: true,
        checkError: (value, newErrors, isError) =>
          checkError(value, "auditorMrpBatchSellOnline", newErrors, isError),
        formElements: [
          {
            label: "MRP",
            key: "consignment_mrp",
            holderClass: props.session.isReadOnly ? "read-only-mode" : "",
            ignoreParentClass: true,
            input: {
              value: productData.consignment_mrp?.toString()?.replaceAll(',','') || "",
              type: isIPhone ? "text" : "tel",
              onChange: (e) => handleChange(e, "consignment_mrp"),
              readOnly: props.session.isReadOnly ? true : false,
              className:
                errors[`consignment_mrp`] == "allSellFieldEmpty"
                  ? styles["dim-red-border"]
                  : "",
              onFocus: (e) => handleFocus(e, "consignment_mrp"),
            },
            checkError: (value) => checkError(value, "consignment_mrp"),
            errorClass: `${styles["batch-input-error"]} ${
              errors[`consignment_mrp`] == "allSellFieldEmpty" ? "hide-error-text" : ""
            }`,
          },
          {
            label: "Selling Price",
            key: "consignment_selling_price",
            holderClass: props.session.isReadOnly ? "read-only-mode" : "",
            ignoreParentClass: true,
            input: {
              value: productData.consignment_selling_price?.toString()?.replaceAll(',','') || "",
              type: isIPhone ? "text" : "tel",
              onChange: (e) => handleChange(e, "consignment_selling_price"),
              disabled: true,
              onFocus: (e) => handleFocus(e, "consignment_selling_price"),
              readOnly: props.session.isReadOnly ? true : false,
              className:
                errors[`consignment_selling_price`] == "allSellFieldEmpty"
                  ? styles["dim-red-border"]
                  : "",
            },
            checkError: (value) => checkError(value, "consignment_selling_price"),
            errorClass: `${styles["batch-input-error"]} ${
              errors[`consignment_selling_price`] == "allSellFieldEmpty"
                ? "hide-error-text"
                : ""
            }`,
          },
        ],
      },
    ]),
    {
      hide:
        !showSellOnline ||
        selectedType == "service" ||
        isBrandedProduct ||
        (
          !(errors[`consignment_mrp`] == "allSellFieldEmpty") &&
          !(errors[`consignment_selling_price`] == "allSellFieldEmpty")),
      customJSX: (
        <div className={`${styles["batch-dimension-error"]}`}>
          {"Please Enter Price"}
        </div>
      ),
    }
  ];

const auditorMrpCompliance = () => {
		return (
			<>
				<div className={`${styles['auditor-mrp-container']}`}>
					<div className={`${styles['product-details-container']}`}>
            <div>
              <div className={styles["user-details-holder"]}>
                <ProductBankIdCopy copyLabel="Product Bank ID" identity="productBankId" isMobile={isMobile} />
                <ProductIdCopy copyLabel="Product ID" identity="productId" isMobile={isMobile} />
                <div className={styles["product-last-time"]}>Last Modified: {props.timestampAudit}</div>
                {
                  type && productTag ? (
                    <div className={styles["tag-holder"]}>
                      <div className={styles["tag-text"] + " MR5 " + tagColor}>
                        {productTag}
						          </div>
                    </div>
                  ) : null
                }
              </div>
              {
                !props.variantProps?.variantProductData?.length ? (
                  <ViewImage
                    key="image-slider"
                    {...readOnlyViewImageProps}
                    isMobile={props.deviceData.isMobile}
                  />
                ) : (
                  <div style={{ marginTop: "20px" }} />
                )
              }
              <ProductNameCopy copyLabel="" identity="productName" isMobile={isMobile} />
						</div>
					</div>
					<FormElement
						formElements={auditorMrpComplianceForm}
						errors={errors}
					/>
				</div>
        <ImageZoom imageHolderClass={"proof-images-add-edit"} title={"Proof of MRP"} images={[...mrpFrontImages,...mrpImages]} isAuditor={isAuditor}/>
			</>
		);
  };
  const EditProduct = (
    <>
      {
        <>
          {(showBtnLoader || audiProdLoader) &&
            <div className="blur-loader"></div>
          }
          <div
            ref={scrollRef}
            onScroll={(e) => {
              scrollHandler(e);
            }}
            className={
              styles["add-edit-product"] +
              (isIPhone ? " " + styles["jd-iphone"] : "") +
              " " +
              (type ? "product-type" : "") +
              (isMobile ? ` ${styles["isMob"]}` : " " + styles["isWeb"])
              + " " + (props.session.closeIframe ? 'omni-iframe' : '')
            }
          >
            { props.deviceData.isMobile ? (
              <div
              className={
                styles["edit-product-header"] +
                (isScrolled ? " scrolled" : "") +
                (props.session.isReadOnly
                  ? " " + styles["readonly-header"]
                  : "")
              }
            >
              <SliderHeader
                className={styles["add-edit-header"]}
                heading={headerText}
                leftIcons={isMobile ? leftIconArr : leftIconWeb}
                rightIcons={rightIconArray}
                variant="secondary"
                headingClass={styles["header-title"]}
              />
            </div>
            ) : null }
            {/* <CSSTransition> */}
              <div
                className={
                  styles["edit-product-form"] +
                  " " +
                  (isAuditor ? styles["auditor-edit-form"] : "") +
                  " " +
                  (props.session.isReadOnly ? styles["readonly-edit-form"] : "")
                }
              >
                
                {productData.isObjectionable && !isAuditor ? (
                  <ObjectionalNotify
                    showLink={true}
                    showModal={() => {
                      toggleShowObjectionalModal({
                        show: true,
                        errors: productData.objectionableContent || [],
                        infoModal: true,
                      });
                    }}
                    selectedType={selectedType}
                  />
                ) : null}
                {mrpCompliance ?
                <>
                 {auditorMrpCompliance()}
                </> :
                  <>
                <div className={styles["marginLR15"]}>
                  {/*isAuditor && !isAddProduct ? (
                    <div className={styles["user-details-holder"]}>
                      {productData.isObjectionable ? null : (
                        <ProductIdCopy identity="productId" isMobile={isMobile} />
                      )}

                      {isTempProd || isTemplate ? (
                        <ProductBankIdCopy copyLabel="Product Bank ID" identity="productBankId" isMobile={isMobile} />
                      ) : null}

                      {productData.bucketId && (
                        <div className={styles["product-last-time"]}>
                          Bucket ID: {productData.bucketId}
                        </div>
                      )}
                      {productData.createdOnAudit && (
                        <div className={styles["product-last-time"]}>
                          Created On: {productData.createdOnAudit}
                        </div>
                      )}
                      {props.timestampAudit && (
                        <div className={styles["product-last-time"]}>
                          Last Modified: {props.timestampAudit}
                        </div>
                      )}
                      {((type && productTag) ||
                        (productData.maskedTag &&
                          productData.maskedTag == "MASKED")) && (
                        <div className={styles["tag-holder"]}>
                          {type && productTag ? (
                            <div
                              className={
                                styles["tag-text"] + " MR5 " + tagColor
                              }
                            >
                              {productTag}
                            </div>
                          ) : null}
                          {productData.maskedTag &&
                          productData.maskedTag == "MASKED" ? (
                            <div className={styles["tag-text"] + " grey"}>
                              {"MASKED"}
                            </div>
                          ) : null}
                        </div>
                      )}
                      {productData.objectionableContent ? (
                        <ObjectionalNotify
                          showLink={true}
                          isAuditor={productData.objectionableContent}
                          selectedType={selectedType}
                        />
                      ) : null}
                    </div>
                  ) : null} */}
                  {/* {isAuditor &&  isReviewStatusNotRejected &&
                  !isAddProduct &&
                  (isTemplate || isTempProd) &&
                  props.auditorBrandedLog?.length > 0 ? (
                    <StatusMessages status='BRANDED_LOG' reasons={props.auditorBrandedLog} />
                  ) : null}
                  {!isAuditor &&
                  !isAddProduct &&
                  productData.reviewStatus?.split(',').includes("DOCUMENT_PENDING") ? (
                    <StatusMessages status='DOCUMENT_PENDING' reasons={productData.documentRejectedReason} />
                  ) : null}
                  {
                    !isAddProduct &&
                    productData.reviewStatus?.split(",").includes("REJECTED") &&
                    productData.rejectedReason?.length > 0 ? (
                      <StatusMessages
                        status={`${
                          productData.categoryType === "service" ? "REJECTED_SERVICE" : "REJECTED"
                        }`}
                        reasons={productData.rejectedReason}
                      />
                    ) : null
                  }
                  {
                    (()=>{
                      if(!isAuditor && !isAddProduct){
                        if(productData.batchStatus && ["INVENTORY_AUDIT_PENDING","AWAITING_INVENTORY_COMPLIANCE"].includes(productData?.batchStatus)){
                          return <StatusMessages status={productData.batchStatus} reasons={[]} />
                        } else if(productData.reviewStatus == "AUDIT_PENDING"){
                          return  <StatusMessages status={productData.reviewStatus} />
                        }
                      }
                    })()
                  } */}
                  {(!props.variantProps?.variantProductData?.length || productOrService === "service") ? (
                    <>
                    <ViewImage key="image-slider" {...editViewImageProps} />
                    {/* {!isAuditor && props.variantImagesLength >= 1 && props.variantImagesLength < 40 && !isTempProd && !isTemplate ?
                    <ProgressSvgComponent styleParent={styles['marginB16']}
                        text={'Engage Your Customers and Get More Business by Uploading More Photos'}
                    />
                     : null} */}
                    </>
                  ) : (
                    <div style={{ marginTop: "20px" }} />
                  )}
                  {/* {(showSellOnline || productData.isSellOnline) && ((!(isTempProd || isTemplate || productData.productId != 'ADD_PRODUCT') || categoryChanged ? Number(props.productSpecification.lbl_img_mandatory): Number(productData.lbl_img_mandatory)) && !isAuditor)?
                    <PackagingLabel
                      proofImages={proofImages}
                      labelFront={labelFront}
                      setFrontImage={setFrontImage}
                      errors={errors}
                      updateError={updateError}
                      setProofImagesList={setProofImagesList}
                    />
                    :null
                    } */}
                </div>
                {!isAddProduct &&
                !isMobile &&
                isJdRepresentative &&
                !productData.isObjectionable &&
                !isBrandedProduct ? (
                  <div className={styles["copy-div-jd-rep"]}>
                    <ProductIdCopy copyLabel="Product Id" identity="productId" isMobile={isMobile} />
                  </div>
                ) : null}
                {/* {isAuditor && proofImages.length ? <><ImageZoom imageHolderClass={`proof-images-add-edit ${labelFront[0]?.url?'front':''} ${proofImages[0]?.url?'back':''}`} updateList={list => {
                  setProofImagesList(list)
                  }} title={"Proof of Product Packaging Label"} images={[...labelFront,...proofImages].map((cur,index) => {
                    return {
                      ...cur,
                      fileId: index
                    }
                  })} isAuditor={isAuditor}/></>: null} */}

                {isAuditor && (isTempProd || isTemplate) ? (
                  <ProductNameCopy copyLabel="" identity="productName" isMobile={isMobile} />
                ) :
                (isTemplate || isTempProd)?<div
                  className={`${styles["marginLR15"]} ${(!isTempProd || props.session.isJdMart || isJdRepresentative || !productData.jd_shop_url) && !productData.unitPerPiece ? 'marginB15' : ''} ${styles["branded-prop-name"]}`}>
                  {productData.productName}
                </div>:null}

                {/* {isAuditor && productData.cv2ProductSource ? (
                  <div
                    className={`${styles["marginLR15"]} ${styles["contractAudit-url-holder"]}`}
                  >
                    <div className={`${styles["contractAudit-url-label"]}`}>
                      {`${productOrService == 'service'? 'Service': 'Product'} Source URL`}
                    </div>
                    <div
                      className={`${styles["contractAudit-url"]}`}
                      onClick={() => {
                        onUrlClick(productData.cv2ProductSource);
                      }}
                    >
                      {productData.cv2ProductSource}
                    </div>
                  </div>
                ) : null} */}
                {formComponent}
                  <>
                    {false ? (
                      <div className={styles["more-detail-switch"]}>
                        <Switch
                          label="Add More Details"
                          labelPosition="before"
                          onClick={toggleMoreFields}
                          checked={moreFieldsShown}
                          showToggleStatus={false}
                        />
                      </div>
                    ) : null}
                  
                    <div ref={moreFieldsRef} className={`${((isTemplate || isTempProd) && !(productData.showInstall || productData.hasCompliance || props.productSpecification?.installationFlag))?"":styles["prod-spec"]}`}>
                      {!isBrandedProduct ? (
                        <>
                          {/* {hideMoreFields||isTemplate?null:<div className={styles['more-detail-grp']}>
												{moreElements.map((cur, index) => {
													return cur.hide ? null : (
														<InputWithMovingLabel
															label={cur.label}
															holderClass={cur.holderClass}
															input={cur.input}
															key={index}
															as={cur.as}
															errorMessage={errors[cur.key]}
															showArrow={cur.showArrow}
															disableMovingLabel={
																cur.disableMovingLabel
															}
														/>
													);
												})}
											</div>
											} */}
                          {
                            !(isTemplate || isTempProd) && isSizeChartEnabled && (productOrService != 'service') &&
                            <SizeChartSlider
                              sizeChartId={productData.sizeChartId}
                              onSelect={(sizeChartId, sizeChartName) => {
                                setFieldValue("sizeChartId", sizeChartId, productData.uomType)
                                setFieldValue("sizeChartName", sizeChartName, productData.uomType)
                              }}
                            />
                          }
                          {(isTemplate || isTempProd) && !(productData.showInstall || productData.hasCompliance || props.productSpecification?.installationFlag) ? null : (
                            <>
                              <ProductSpecification
                                showSellOnline={showSellOnline}
                                isAddProduct={isAddProduct}
                                showInstall={productData.showInstall}
                                toggleValidationModal={toggleValidationModal}
                                productOrService={productOrService}
                              /> 
                              
                            </>
                          )}
                          {(isTemplate || isTempProd || !props.permissions?.addAttachment) ? null : (
                            <>
                              <ProductFileAttachment
                                productId={productData?.productId}
                                isReadOnly={props.session.isReadOnly}
                              />
                            </>
                          )}
                          {
                            !(isTemplate || isTempProd) && 
                            props?.session?.viaOmni && props.permissions?.addSynonym &&
                            <ProductSynonyms 
                                synonyms = {productData.productSynonym ? productData.productSynonym : ''}
                            />
                          }
                        </>
                      ) : null}
                    </div>
                  </>
                {toggleInventory && (
                  <InventoryBatches
                    itemInfo={productData}
                    tabKey={props.tabKey}
                    componentlabel="Edit Inventory Batch"
                    onHidden={() => setInventory(false)}
                    isAddEdit={true}
                    disableSellOnlineCustom={disableSellOnlineCustom}
                  />
                )}
                {toggleAddInventoy && (
                  <AddInventoryBatch
                    itemInfo={{
                      imageUrl : productData?.imageUrlArr?.length? productData.imageUrlArr[0]?.imgURL:'',
                      productName: productData.productName,
                      productId: productData.productId
                    }}
                    onHidden= {()=>setAddInventory(false)}
                    addInventoryBatch={props.productData.addInventoryBatch || Boolean(productData?.mrp_list?.length && parseInt(productData.mrp_list[0],10) !== 0)  || productData.mrp_status === 'EMPTY_MRP_LIST'  ? {
                      'quantity':  "",
                      'mrp': productData.mrp?.toString()?.replaceAll(',','') || "",
                      'sellingPrice': productData.sellingOnlinePrice?.toString()?.replaceAll(',','') || "",
                      'expiry_date': '',
                      'manufacturing_date': '',
                      'newConsignmentNo': '',
                    }: {} }
                    productData={props.productData}
                    hideMrp={getHideMrp()}
                    handleInventorySave={(consignmentObj)=>{
                      historyHandler.closeCurrent();
                      // setShowAddInv(true);
                      props.updateEditProductDetail([{
                        key: "addInventoryBatch",
                        value: consignmentObj
                      }]);
                    }
                    }
                  />
                )}

                  
                {props.selectedCategoryType != "service" && showSellOnline ? (
                  <ManageTaxesHOC
                    {...props}
                    toggleTaxSlider={toggleTaxSlider}
                    taxObj={taxObj}
                    hideGeneralDetails={true}
                    taxSequence={taxSequence}
                    isTempProd={isTempProd || isTemplate}
                  />
                ) : null}
                </>
                }
                {/* {
                  isAuditor &&
                  ( isTemplate ||
                  selectTypeQuery.queueType === 'branded') ?
                  <ProductBankFields
                    productId = {productData.product_bankid}
                    token = {props.session.token}
                    newProfile = {props.session.newProfile}
                  /> :
                  null
                } */}
                {showCopyModal ? (
                  <Modal
                    settings={{
                      modalId: "productIdCopy",
                      variant: "action",
                      class: styles["product-id-copy-modal"],
                    }}
                    onHidden={() => toggleCopyModal(false)}
                  >
                    <Modal.CloseIcon
                      iconClass={styles["jd-cat-icon"] + " icon-HDRcross"}
                    />
                    <div className={styles["product-id-copy-header"]}>
                      {showCopyModal != "delete"
                        ? `${(productOrService == 'service') ? 'Service' : 'Product'} ID`
                        : `Delete ${(productOrService == 'service') ? 'Service' : 'Product'}`}
                    </div>
                    <div className={styles["product-id-copy-body"]}>
                      {showCopyModal == "delete" ? (
                        <div className={styles["delete-text"]}>
                          Are you sure you want to delete
                          <span className={styles["delete-bold-text"]}>
                            {(productOrService == 'service') ? 'Service' : (productData.productName
                              ? productData.productName
                              : "")}
                          </span>
                          ?
                        </div>
                      ) : (
                        <div className={styles["user-details-productid"]}>
                          <textarea
                            ref={copytext}
                            className={styles["copy-text"]}
                            readonly="readonly"
                          >
                            {productData && productData.productId}
                          </textarea>
                          <div
                            className={styles["product-id-copy-holder"]}
                            onClick={() => {
                              copyCodeToClipboard('productId');
                              window.history.back();
                            }}
                          >
                            <span
                              className={
                                styles["product-id-copy-icon"] + " icon-Copy"
                              }
                            ></span>
                            COPY
                          </div>
                        </div>
                      )}
                    </div>
                    <div className={styles["copy-close-btn-holder"]}>
                      <Button
                        size="lg"
                        block
                        variant={
                          showCopyModal == "delete" ? "danger" : undefined
                        }
                        showLoader={TAPLoader}
                        clickHandler={() => {
                          if (showCopyModal == "delete") {
                            updateTAPLoader(true);
                            deleteProduct();
                          } else {
                            window.history.back();
                          }
                        }}
                      >
                        {showCopyModal == "delete" ? `Delete ${(productOrService == 'service') ? 'Service' : 'Product'}` : "Close"}
                      </Button>
                    </div>
                  </Modal>
                ) : null}
                {onlineUrlModal && (
                  <BuyOnlineUrlModal
                    url={props.productData.buyOnlineUrl}
                    onHidden={() => setOnlineUrlModal(false)}
                    onSave={(url) => {
                      console.log(url);
                      axios
                        .get(
                          `/marketplace/static/php/web/b2bWebsite.php?action=updateBuyOnlineUrlForProduct&token=${props.session.token}&productId=${props.productData.productId}&buyOnlineUrl=${url}`
                        )
                        .then((res) => {
                          props.updateEditProductDetail({
                            key: "buyOnlineUrl",
                            value: url,
                          });
                          historyHandler.closeCurrent();
                        });
                    }}
                    showToastMessage={props.showToastMessage}
                  />
                )}
                {commissionModal && (
                  <CommissionModal
                    webStyle={!props.deviceData.isMobile}
                    commissionRate={props.productData.commissionRate}
                    onHidden={() => {
                      setCommissionModal(false);
                      saveButtonStatus.current = "";
                    }}
                    onSave={() => {
                      saveButtonStatus.current = "";
                      saveData({ fromCommissionModal: true });
                      historyHandler.closeCurrent();
                    }}
                  />
                )}
                {/* {isAuditor && (isReviewStatusNotRejected || mrpCompliance) ? (
                  <>
                   
                    {justdialCatModal ? (
                      <JustdialCatModal
                        showJDCatModal={showJDCatModal}
                        jdCatList={jdCatList}
                      />
                    ) : null}
                    {timeoutModal ? (
                      <Modal
                        settings={{
                          modalId: "timeoutModal",
                          variant: "action",
                          class: styles["timeout-modal"],
                        }}
                        backdropStatic={true}
                        onHidden={() => updateTimeoutModal(false)}
                      >
                        {auditFromPage ||
                        saveProdConflict == "ownerEdited" ? null : (
                          <Modal.Header>
                            {`This ${(productOrService == 'service') ? 'Service' :  'Product'} is Already Audited`}
                          </Modal.Header>
                        )}
                        <div className={styles["timeout-body"]}>
                          <div className={styles["timeout-text"]}>
                            {auditFromPage || saveProdConflict == "ownerEdited"
                              ? saveAuditMsg
                              : productData.productName}
                          </div>
                          <Button
                            showLoader={TAPLoader}
                            size="lg"
                            block
                            className={styles["timeout-btn"]}
                            clickHandler={() => {
                              if (
                                auditFromPage ||
                                saveProdConflict == "ownerEdited"
                              ) {
                                // window.history.go(-2);
                                historyHandler.closeCurrent();
                                setTimeout(() => {
                                  window.location.reload();
                                }, 500);
                              } else {
                                updateTAPLoader(true);
                                fetchAuditUrl({
                                  cb: (data) => {
                                    fetchResolve({ data });
                                    // if(data.data.status == 1) {
                                    // 	if(window.top != window.self) {
                                    // 		data.data.url += '&loadedInIframe=true';
                                    // 	}
                                    // 	window.location.href = data.data.url;
                                    // } else {
                                    // 	alert("No Products Found.");
                                    // }
                                    updateTAPLoader(false);
                                  },
                                });
                              }
                            }}
                          >
                            {auditFromPage || saveProdConflict == "ownerEdited"
                              ? "Continue"
                              : `Fetch Another ${(productOrService == 'service')? 'Service' : 'Product'}`}
                          </Button>
                          {auditFromPage ||
                          saveProdConflict == "ownerEdited" ? null : (
                            <Button
                              size="lg"
                              block
                              variant="default"
                              clickHandler={() => {
                                // showSuccessPage(true);
                                history.push(auditHomePath);
                              }}
                            >
                              {"Stop Auditing"}
                            </Button>
                          )}
                        </div>
                      </Modal>
                    ) : null}
                  </>
                ) : null} */}
                {/* {isAuditor && isObjectionableQueue ? (
                  <div
                    className={
                      styles["marginLR15"] +
                      " " +
                      styles["objectional-save-btn-holder"]
                    }
                  >
                    <div
                      className={
                        styles["partial-btns"] + " " + styles["firstRow"]
                      }
                    >
                      <Button
                        size="lg"
                        className={styles["first-btn"]}
                        clickHandler={() => {
                          saveData({
                            fetchNextUrl: true,
                          });
                        }}
                      >
                        {"Approve"}
                      </Button>
                      <Button
                        size="lg"
                        className={styles["second-btn"]}
                        clickHandler={() => {
                          toggleShowObjectionalDelModal({
                            id: "reject",
                            headerText: `Reject / Delete ${(productOrService == 'service') ? 'Service' : 'Product'}`,
                            buttonText: `Reject / Delete ${(productOrService == 'service') ? 'Service' : 'Product'}`,
                            cb: () => {
                              const { queueType = "" } = identifyAuditFlow({
                                query: true,
                              });
                              delObjectionableProd({
                                queueType,
                                token: props.session.token,
                                id: productData.id,
                              });
                            },
                          });
                        }}
                      >
                        {"Reject / Delete"}
                      </Button>
                    </div>
                    {!auditFromPage ? (
                      <div className={styles["partial-btns"]}>
                        <Button
                          size="lg"
                          variant="default"
                          className={styles["first-btn"]}
                          clickHandler={() => {
                            updateSkipDrawer("skipProduct");
                          }}
                        >
                          {`Skip ${(productOrService == 'service') ? 'Service' : 'Product'}`}
                          <span
                            className={
                              "icon-pagination-down" +
                              " " +
                              styles["btns-icons"]
                            }
                          ></span>
                        </Button>
                        <Button
                          size="lg"
                          variant="default"
                          className={styles["second-btn"]}
                          clickHandler={() => {
                            updateSkipDrawer("stopAuditing");
                          }}
                        >
                          {"Stop Auditing"}
                          <span
                            className={
                              "icon-pagination-down" +
                              " " +
                              styles["btns-icons"]
                            }
                          ></span>
                        </Button>
                      </div>
                    ) : null}
                  </div>
                ) : null} */}
                {/* {isAuditor && !auditFromPage && !isObjectionableQueue ? (
                  <>
                    <div
                      className={
                        styles["marginLR15"] +
                        " " +
                        styles["audi-save-btn-holder"]
                      }
                    >
                      <Button
                        size="lg"
                        block
                        clickHandler={() => {
                         !mrpCompliance ? saveData({
                            fetchNextUrl: true,
                          }) : saveAuditorMrpBatch({
                            fetchNextUrl: true,
                          })
                        }}
                        showLoader={audiProdLoader}
                        className={"auditor-btn"}
                      >
                        {`Save and Fetch Another ${mrpCompliance ? 'Inventory Batch' :  (productOrService == 'service' ? 'Service' : 'Product')}`}
                      </Button>

                      <div className={styles["partial-btns"]}>
                        <Button
                          size="lg"
                          variant="default"
                          className={styles["first-btn"]}
                          clickHandler={() => {
                            mrpCompliance ? updateSkipBatch() :
                            updateSkipDrawer("skipProduct");
                          }}
                        >
                          {`Skip  ${mrpCompliance ? 'Batch' : (productOrService == 'service' ? 'Service' :  'Product')}`}
                        </Button>
                        <Button
                          size="lg"
                          variant="default"
                          className={styles["second-btn"]}
                          clickHandler={mrpCompliance ? saveAuditorMrpBatch : saveData}
                          showLoader={showBtnLoader}
                        >
                          {"Save & Stop Auditing"}
                        </Button>
                      </div>
                    </div>
                  </>
                ) : null} */}
                {skipDrawer && (
                  <SwipeableDrawer
                    onHidden={(e) => {
                      updateSkipDrawer(false);
                    }}
                    title={drawerTitle}
                    drawerOptions={drawerOptions}
                    onClick={drawerOnClick}
                    className={"fetch-swipe-drawer"}
                  />
                )}
                {auditFromPage && isAuditUrl && !isObjectionableQueue ? (
                  <div
                    className={
                      styles["marginLR15"] +
                      " " +
                      styles["audi-save-btn-holder"]
                    }
                  >
                    <Button
                      size="lg"
                      showLoader={showBtnLoader}
                      block
                      clickHandler={saveData}
                      className={"auditor-save-btn"}
                    >
                      {isAddProduct || (productData.reviewStatus?.toString().split(',').includes("REJECTED") || productData.reviewStatus?.toString().split(',').includes("DOCUMENT_PENDING")) ? `Save ${(productOrService == 'service') ? 'Service' : 'Product'}` : "Save & Continue"}
                    </Button>{" "}
                  </div>
                ) : null}
                <EnquiryDeliveryStockContainer {...props} selectedType={selectedType} />
                {saveBtnShown && !props.session.isReadOnly ? (
                  <div className={styles["save-product-btn"]}>
                    {isOwner &&
                    productData.reviewStatus == "DELETION_PENDING" &&
                    props.tabKey != "brand" ? (
                      <ButtonGroup
                        raised
                        className={styles["delete-btn-holder"]}
                      >
                        <Button
                          raised
                          variant="default"
                          className={styles["delete-btn"]}
                          clickHandler={saveData}
                        >
                          Don't Delete &amp; Save Changes
                        </Button>
                        <Button
                          raised
                          variant="default"
                          className={styles["delete-btn-reverse"]}
                          clickHandler={deleteProduct}
                        >
                          Delete Product
                        </Button>
                      </ButtonGroup>
                    ) : isOwner &&
                    productData.reviewStatus == "APPROVAL_PENDING" &&
                    props.tabKey != "brand" ?
                    (
                      !showBtnLoader?
                      (<ButtonGroup
                        raised
                        className={styles["delete-btn-holder"]}
                      >
                        <Button
                          raised
                          variant="default"
                          className={styles["delete-btn"]}
                          clickHandler={dontApprove}
                        >
                          Don't Approve
                        </Button>
                        <Button
                          raised
                          variant="default"
                          className={styles["delete-btn-reverse"]}
                          clickHandler={saveData}
                        >
                          Approve &amp; Save
                        </Button>
                      </ButtonGroup>):
                      <Button
                        variant="default"
                        size="lg"
                        block
                        showLoader={showBtnLoader}>
                      </Button>
                    ):isAuditor ? null : (
                      <Button
                        size="lg"
                        block
                        clickHandler={saveData}
                        showLoader={showBtnLoader}
                      >
                        {saveButtonText}
                      </Button>
                    )}
                  </div>
                ) : null}
              </div>
            {/* </CSSTransition> */}
            <ShowUploadLibraryImage 
                    type={'itemCategory'} 
                    uploadLibrary={true} 
                    onHidden={() => { updateShowUploadFromLibrary(false); props.onHidden(); }} 
                    updateProductImage={props.updateProductImage} 
            />
            {isMobile || props.session.closeIframe ? (
              <>
                {props.session.closeIframe ? 
                <PortalUploadOptions
                  onUploadOptionClick={(value) => {
                    if (value === "jdGallery") {
                      dontResetEditProduct.current = true;
                    }
                  }}
                  categoryType={!isAddProduct ? productData.categoryType : null}
                />:
                <UploadOptions
                    onUploadOptionClick={(value) => {
                      if (value === "jdGallery") {
                        dontResetEditProduct.current = true;
                      }
                    }}
                    categoryType={!isAddProduct ? productData.categoryType : null}
                />
              }
                <LinkUploadSlider />
                <CopyImagesSlider listClass={"list-aligned-top"} />
              </>
            ) : null}
            {!isAuditor && showValidationModal.show ? 
              <ValidationModal
                elementRef={scrollEle}
                productData={productData} 
                openCloseCatSlider={openCloseCatSlider} 
                onHidden={() => {
                  toggleValidationModal({show:false})
                }}
                showLoading={showValidationModal.loadDesc} 
                noDesc={showValidationModal?.noDesc}
                onSave={saveData}
                togglePaste={togglePaste}
                updateCount={updateCount}
                setReTryAI={setReTryAI}
                generateDescription={generateDescription}
              /> : null}
            <UOMSliderWrapper
              ref={sliderRef}
              uomType={
                selectedType == "product"
                  ? "productUOM"
                  : selectedType == "service"
                  ? "serviceUOM"
                  : "both"
              }
              isAddProduct={isAddProduct}
              isHideStds={(selectedType === 'service' && toggleIndex !== 1)}
              isProduct={selectedType == 'product'}
              onSelectUOM={onSelectUOM}
              showUOMType={savedUOMTYPE == "PACKED" ? "Packed" : ""}
            />
            {catSliderShown ? (
              <CategorySearchSlider
                ref={catSliderRef}
                onSelectCategory={onSelectCategory}
                productName={productData.productName}
                catSliderShown={catSliderShown}
                closeSlider={() => openCloseCatSlider(false)}
                categoryName={productData.categoryName}
                keywordName={productData.keywordName}
                showToastMessage={props.showToastMessage}
                oType={
                  productData.categoryType && !isAddProduct
                    ? productData.categoryType.toUpperCase()
                    : selectedType
                    ? selectedType.toUpperCase()
                    : ""
                }
                hintText= {'Enter Category Name'}
                isAddProduct={isAddProduct}
              />
            ) : null}
            {taxSlider ? (
              <TaxSlider {...taxObjProps} manageTaxes={true} />
            ) : null}
            {objectionalModal.show ? (
              <Modal
                settings={{
                  modalId: "ObjectionalProduct",
                  variant: "action",
                  class: styles["objectional-product-modal"],
                }}
                backdropStatic={true}
                onHidden={() => toggleShowObjectionalModal({ show: false })}
              >
                <div className={styles["objectional-product-body"]}>
                  <div className={styles["heading"]}>
                    <span className={styles["highlight"]}>
                      Objectionable Content Found:
                    </span>
                  </div>
                  <div className={styles["objectional-product-text"]}>
                    {objectionalModal.errors.map((error) => {
                      return (
                        <div className={styles["objectional-error"]}>
                          <span className={styles["highlight"]}>
                            {error.name}:
                          </span>{" "}
                          {error.details}
                        </div>
                      );
                    })}
                  </div>

                  <div className={styles["objectional-product-subtext"]}>
                    <span className={styles["highlight"]}>Note:</span> {`This
                    ${selectedType == "service" ? "service" : "product"} will be visible under the`}{" "}
                    <span className={styles["highlight"]}>
                        {`Audit Pending`}
                    </span>{" "}
                    tab till it gets moderated.
                  </div>
                </div>
                <div className={styles["objectional-product-btn-holder"]}>
                  <Button
                    size="lg"
                    block
                    variant={objectionalModal.infoModal ? "primary" : "default"}
                    clickHandler={() => {
                      if (objectionalModal.infoModal) {
                        window.history.back();
                      } else {
                        if(savingObjectionable){
                          return;
                        }
                        setSavingObjectionable(true);
                        props.saveAddEditProduct(
                          null,
                          (res) => {
                            setSavingObjectionable(false);
                            // props.setTabStatus({ tabKey: undefined });
                            saveButtonStatus.current = "saved";
                            dispatch(
                              toastMessageActions.showMessage({
                                message: `${(productOrService == 'service') ? 'Service' : 'Product'} ${
                                  isAddProduct ? "Added" : "Updated"
                                } Successfully`,
                                showReduxToast: true,
                                duration: 5000,
                              })
                            );
                            if(props.deviceData.isMobile){
                              setRouteChangeMessage({
                                message: `${(productOrService == 'service') ? 'Service' : 'Product'} ${
                                  isAddProduct ? "Added" : "Updated"
                                } Successfully`,
                              });
                            }
                            history.replace("/products");
                            props.resetProductData({});
                            if (!props.deviceData.isMobile) {
                              window.history.back();
                              setTimeout(() => {
                                // if (props.isSearchSliderOpen) {
                                //   historyHandler.closeAll();
                                // } else {
                                //   window.history.back();
                                // }
                                historyHandler.closeAll();
                              }, 300);
                            }
                          },
                          {
                            isSaveForceFully: true,
                            savedCustomSpecAttributes:
                              props.savedCustomSpecAttributes,
                            savedPuvSpecAttributes:
                              props.savedPuvSpecAttributes?.length ? props.savedPuvSpecAttributes : props.editablePuvSpecAttributes,
                            sendBMDetails: props.sendBMDetails,
                            installData: props.installData,
                            toggleIndex
                          }
                        );
                      }
                    }}
                  >
                    {objectionalModal.infoModal
                      ? "Okay, Got it"
                      : "Save and Continue"}
                  </Button>
                </div>
                {!objectionalModal.infoModal ? (
                  <div className={styles["objectional-goBack-btn-holder"]}>
                    <Button
                      size="lg"
                      block
                      clickHandler={() => {
                        window.history.back();
                      }}
                    >
                      {"Go Back and Edit"}
                    </Button>
                  </div>
                ) : null}
              </Modal>
            ) : null}
            {docReqModal.show ? (
              <DocReqModel
                onHidden={() => toggledocReqModal({ show: false })}
                gotClicked={showProductUpdatedStatus}
                requireddocs={docReqModal.docs}
                isMobile={props.deviceData.isMobile}
                isChrome={props.deviceData.isChrome}
                isIphone={isIPhone}
              />
            ) : null}
            {sellingPriceModal.show ? (
              <SellingPriceModal
              confirmClick ={()=>confirmSellingPrice()}
              onHidden={() => toggleSellingPriceModal({ show: false })}
              data ={sellingPriceModalData}
              showBtnLoader={confirmBtnLoader}
              isMobile={props.deviceData.isMobile}
              isChrome={props.deviceData.isChrome}
              isIphone={isIPhone}
              />
            ) : null}
            
            {["transaction","pricing"].includes(showChangeModal.key) ? (
              <TransactionModal
                onHidden={() => toggleChangeModal({ key: "" })}
                type={showChangeModal.key}
                newType={showChangeModal.newType}
                changeType={(e) => {
                  if(showChangeModal.key == 'transaction') {
                    updateValue(e, 0, "transactionType");
                    updateType(0);
                  }else {
                    updateValue(e, showChangeModal.value);
                    const newErrors = { ...errors };
                    newErrors["sellingPrice"] = "";
                    newErrors["minOrderQuantity"] = "";
                    newErrors["maxPrice"] = "";
                    newErrors["minPrice"] = "";
                    newErrors["actualPrice"] = "";
                    updateError(newErrors);
                  }
                }}
              />
            ) : null}
            {showPriceLabelModal.show ?
              <ActionModal
                onHidden={()=>toggleShowPriceLabelModal({show:false,isVisited: true})}
                title={'Product Packaging Label Required'}
                content={<>This category requires the product packaging label image to be uploaded. this is usually on the backside of the product and needs to show details such as ingredients, net weight / volume, marketed by, manufacturing license, customer care contact details, etc.</>}
                btnName= {'Okay, Got It'}
                variant={'primary'}
                onclick={()=>toggleShowPriceLabelModal({show: false,isVisited: true})}
              />
              : null
            }
            {showChangeModal.key == "product" ? (
              <ProductChangeModal
                onHidden={() => toggleChangeModal({ key: "" })}
                changeType={(e) => {
                  updateRemovedSpec(
                    props.addRemoveSpecVariant({
                      remove: false,
                      data: removedSpec,
                    })
                  );
                  props.setVariantData([]);
                  props.setVariantProductData([]);
                  updateType(0);
                  historyHandler.closeCurrent();
                }}
                isService={showChangeModal.isService}
              />
            ) : null}
            {showObjectionalDelModal ? (
              <Modal
                settings={{
                  modalId: "ObjectionalDeleteProduct",
                  variant: "action",
                  class: styles["objectional-delete-product-modal"],
                }}
                onHidden={() => toggleShowObjectionalDelModal(false)}
              >
                <Modal.Header>
                  {showObjectionalDelModal.headerText}
                </Modal.Header>
                <Modal.CloseIcon
                  iconClass={styles["jd-cat-icon"] + " icon-HDRcross"}
                />
                <div className={styles["objectional-delete-body"]}>
                  <div className={styles["objectional-delete-text"]}>
                    By rejecting/deleting, this product will be permanently
                    removed from the system.Are you sure you want to
                    reject/delete{" "}
                    <span className={styles["objectional-highlight-text"]}>
                      {productData.productName}
                    </span>
                    {showObjectionalDelModal.id == "deleteStopAudit"
                      ? " & Stop Auditing?"
                      : "?"}
                  </div>
                </div>
                <div className={styles["objectional-delete-btn-holder"]}>
                  <Button
                    size="lg"
                    block
                    variant={"danger"}
                    clickHandler={() => {
                      getHistoryObj('reject')
                      showObjectionalDelModal.cb &&
                        showObjectionalDelModal.cb();
                    }}
                  >
                    {showObjectionalDelModal.buttonText}
                  </Button>
                </div>
              </Modal>
            ) : null}
          </div>
          {props.showLibrarySlider && (props.deviceData.isMobile || props.session.closeIframe) ?
            <VideoListing />
          : null}
          {
            imageSliderVisible && (
              <ViewImageSlider
                className={"read-only-image-slider"}
                key="read-only-image-slider"
                session={props.session}
                isBrandedProduct={isBrandedProduct}
                onHidden={() => updateViewImageSlider(null)}
                {...imageSliderVisible}
                {...(props.session.isReadOnly || isBrandedProduct
                  ? readOnlyViewImageProps
                  : editViewImageProps)}
              />
            )}
          {openFlagSlider ? (
            <CountrySliderList
              onHidden={() => {
                toggleFlagSlider(false);
              }}
              countryList={props.countryList}
              selectedCountry={selectedCountry}
              updateCountry={updateCountry}
            ></CountrySliderList>
          ) : null}
          {variantInfo ? (
            <AddVariantWelcome
              onHidden={() => {
                if(!props.variantProps.variantProductData.length){
                  updateType(0);
                }
                toggleVariantWelcome(false);
              }}
            />
          ) : null}
          {props.variantProps.showEditVariantSlider && <AddVariantOptions />}
          {props.variantProps.variantTypeSlider.show && <AddVariantOptions />}
          {props.variantProps.variantOptionsSlider.show && <VariantOptions />}
          {props.variantProps.variantDetailsSlider && <VariantDetails />}
          {props.variantProps.moreDetailsSlider.show && <VariantMoreDetails />}
          {props.variantProps.showSyncImagesModal && <SyncImagesModal />}
          {correctnessModel.show ?
            <CorrectnessModel
              data={correctnessModel}
              setCorrectnessModel={setCorrectnessModel}
              productOrService={productOrService}
              categoryName={productData.keywordName || productData.categoryName}
            /> : null}
          {aiSpecModal?.show ? 
            <AISuggestedSpex
                omni={true}
                setAIspecModal={setAIspecModal}
                data={aiSpecModal}
                onHidden={()=> {
                    setAIspecModal({show: false});
                    if (!aiSpecsSaved) {
                      // props.clickTrack({ll: 'digital_catalog', li:'ai_gen_spec_modal_close', userBasedCheck: true});  
                    }
                  }
                }
                onAISpecDataSaved={(newData)=> 
                  AISpecDataSavedHandler(newData)                  
                }
                modalShowClickTrack={() => {}}//props.clickTrack({ll: 'digital_catalog', li:'ai_gen_spec_modal_show', userBasedCheck: true})}
                saveClickTrack={(main, selected) => {
                  setAiSpecsSaved(true);
                  const li = (selected==0 ?  'ai_gen_spec_modal_save_none' : main != selected ? 'ai_gen_spec_modal_save_some' : 'ai_gen_spec_modal_save_all');
                  // props.clickTrack({ll: 'digital_catalog', li:li, userBasedCheck: true})
                }}
            /> : null
          } 
        </>
      }
    </>
  );
  if (props.deviceData.isMobile) {
    return (
		<>
      {getUpdateMRPModal()}
			{EditProduct}
			{showComplianceModal ? (
				<ComplianceFieldModal
					toggleModal={() => closeComplianceModal(true)}
          deviceData={props.deviceData}
          smartFillUpdateProduct={smartFillUpdateProduct}
          showLoader={showComplianceUpdateLoader}
				/>
			) : null}
		</>
	);
  } else {
    return (
      <>
      {getUpdateMRPModal()}
        <SliderWrapper
          slider={{
            slideDirection: "right",
            // showOverlay: true
          }}
          enableHeader
          animateChildren='true'
          header={{
            className: `${styles["add-edit-header"]} ${styles["add-edit-header-no-border"]} ${isScrolled>10?styles["add-edit-header-scrolled"]:""}`,
            heading: headerText,
            leftIcons: isMobile ? leftIconArr : leftIconWeb,
            rightIcons: rightIconArray,
            variant:"secondary",
            headingClass: styles["header-title"],
          }}
          onHidden={() => {

            //
            props.hideProductEditSlider();
            props.discardAddProductMedia();
            handleResetSpecification();
            props.resetVariantData();
            if(props.session.closeIframe && saveButtonStatus.current == 'saved') {
              let ele = parent?.document.getElementById('omniIframe');
              parent.document.body.style.overflow = 'unset';
              if(ele?.parentNode && ele?.parentNode?.children && ele?.parentNode?.children?.length){
                ele.parentNode.removeChild(ele);
              }
            }
          }}
          onScroll={(e)=>scrollHandler(e)}
        >
          {EditProduct}
        </SliderWrapper>
        {showComplianceModal ? (
            <ComplianceFieldModal
              toggleModal={() => closeComplianceModal(true)}
              deviceData={props.deviceData}
              smartFillUpdateProduct={smartFillUpdateProduct}
              showLoader={showComplianceUpdateLoader}
            />
          ) : null}
      </>
    );
  }
};

const mapStateToProps = (state,props) => {
  let hideLBH = false;
  let hideWeight = false;
  const editProduct = state.products.editProduct || {};
  let isBrandSpecIndex = "", isImporterPresent = true;
  let productId = "";
  const uom = state.uom;
  if(editProduct.compliance){
    let length = editProduct.compliance.packaging_length;
    let height = editProduct.compliance.packaging_height;
    let width = editProduct.compliance.packaging_width;
    let weight = editProduct.compliance.packaging_weight;
    hideLBH = length && width && height;
    hideWeight = weight ? true: false;
  }
  let unitOfMeasurement = {},
    unitPerPiece = {},
    oldUnitOfMeasurement = {};
  if (editProduct) {
    productId = editProduct.productId;
    if (editProduct.unitOfMeasurement) {
      unitOfMeasurement = getMatchedUOM(
        uom.productUOM,
        editProduct.unitOfMeasurement
      );
    }
    if (!Object.keys(unitOfMeasurement).length) {
      unitOfMeasurement.displayVal = editProduct.unitOfMeasurement;
    }
    editProduct.uomType =
      state.products.uomType || unitOfMeasurement.uomType || "";
    if (editProduct.unitPerPiece) {
      unitPerPiece = getMatchedUOM(uom.netweightUOM, editProduct.unitPerPiece);
      unitPerPiece = unitPerPiece.displayVal
        ? unitPerPiece
        : { displayVal: editProduct.unitPerPiece };
    }
    const oldAuditData = editProduct.oldData;
    if (oldAuditData) {
      if (oldAuditData.unitOfMeasurement) {
        oldUnitOfMeasurement = getMatchedUOM(
          uom.productUOM,
          oldAuditData.unitOfMeasurement
        );
      }
      if (!Object.keys(oldUnitOfMeasurement).length) {
        oldUnitOfMeasurement.displayVal = oldAuditData.unitOfMeasurement;
      }
    }
  }

  const imageUrlArr = productId
    ? state.products.editProduct.imageUrlArr
    : [];
  if(editProduct && productId != 'ADD_PRODUCT'){
    editProduct.imageUrlArr = imageUrlArr;
  }
  const variantImagesLength = imageUrlArr?.length || 0 ;
  let productData = state.products.allProducts[productId] || {};
  if (Boolean(editProduct && productId != 'ADD_PRODUCT' && editProduct.videoUrlIds)) {
    editProduct.videoUrlIds = editProduct.videoUrlIds;
    editProduct.videoUrlArr = editProduct?.videoUrlIds.map((curId) => {
      let libraryUploaded = null;
      libraryUploaded = Object.keys(state.videoLibrary.videos).filter(cur => (state.videoLibrary.videos[cur].oldId == curId && curId != cur));
      editProduct.videoUrlIds = libraryUploaded?.length ? libraryUploaded : editProduct.videoUrlIds;
      return state.videoLibrary.videos[curId] || state.videoLibrary.videos[libraryUploaded[0]];
    });
  } else {
    editProduct.videoUrlArr = [];
  }
  let editablePuvSpecAttributes =
    state.productSpecification.editablePuvSpecAttributes;
  if (
    editProduct.categoryName ||
    editProduct.isTempProd || editProduct.isTemplate
  ) {
    if (editablePuvSpecAttributes.length) {
      isBrandSpecIndex = editablePuvSpecAttributes.findIndex(cur => cur?.s_nm == 'brand') != -1 ? true : false;
    } else if (editProduct?.specification?.length) {
      isBrandSpecIndex = true;
    }
  }
  if (editProduct.compliance) {
    if (
      editProduct.compliance["manufacturer"] &&
      editProduct.compliance["manufactured_details"]
    ) {
      isBrandSpecIndex = false;
    } else {
      isBrandSpecIndex = true;
    }
    if (
      editProduct.compliance["importer"] &&
      editProduct.compliance["importers_detail"]
    ) {
      isImporterPresent = false;
    } else {
      isImporterPresent = true;
    }
  }
  const bizSuggestion = {
    data: [
      { bizType: "Retailer", natCatId: "Retailer" },
      { bizType: "Wholesaler", natCatId: "Wholesaler" },
      { bizType: "Exporter", natCatId: "Exporter" },
      { bizType: "Manufacturer", natCatId: "Manufacturer" }
    ]
  }

  return {
	  uom:state.uom,
    productData: editProduct,
    deviceData: state.deviceData,
    unitOfMeasurement,
    oldUnitOfMeasurement,
    unitPerPiece,
    variantImagesLength,
    showLibrarySlider: state.videoLibrary.showLibrarySlider,
    session: state.session,
    auditData: state.products.auditData,
    showAuditData: editProduct.showAuditData,
    deletionPendingList: state.products.deletionPendingList,
    approvalPendingList: state.products.approvalPendingList,
    tabKey: state.products.tabKey,
    listingProdData: state.products.listing,
    userData: state.session.user.loginData,
    timestampAudit: editProduct.timestampAudit,
    countPerDocId: editProduct.countPerDocId,
    isJdPhotoSlider: state.photosGallery.isJdPhotoSlider,
    directAddToProduct: !!state.photosGallery?.jdPhotosData?.variantId,
    isSearchSliderOpen: state.products.isSearchSliderOpen,
    countryList: state.products.countryList,
    isJdSourceIOS: state.session.isJdSourceIOS,
    selectedCategoryType: state.products.selectedCategoryType,
    savedCustomSpecAttributes:
      state.productSpecification.savedCustomSpecAttributes,
    savedPuvSpecAttributes: state.productSpecification.savedPuvSpecAttributes,
    permissions: state.permissions,
    user: state.session.user,
    productSpecification: state.productSpecification,
    isBrandSpecIndex,
    isImporterPresent,
    brandManufacturer: state.brandManufacturer,
    sendBMDetails: state.brandManufacturer.sendDetails,
    installData: state.brandManufacturer.installData,
    specification: editProduct.specification,
    viaSuggested: state.products.viaSuggested,
    viaSearchSuggested: state.products.viaSearch,
    editablePuvSpecAttributes,
    hybrid: state.hybrid.hybridToSend,
    variantProps: state.variants,
    variantSpec: state.variants.variantSpec,
    variantProductData: state.variants.variantProductData,
    hasVariantSpec: state.variants.variantSpec.length && (state.session.supplierId != 231 && state.permissions?.packagePermissionData?.isAllowVariantProducts),
    smartFillData: state.products.smartFillData,
    auditorBrandedLog: state.products.auditorBrandedLog,
    contentWeightUnitSaved: state.brandManufacturer.contentWeightUnitSaved,
    productSmartFillSpec: state.productSpecification.productSmartFillSpec,
    docIdSearch: state.products.docIdSearch,
    fromSellerDashboard: state.products.fromSellerDashboard,
    bizSuggestion: bizSuggestion,
    isSourceJustdial: state.session.isJdSourceAndroid || state.session.isJdSourceIOS,
    isJdBusinessIOS: state.session.isJdBusinessIOS,
    isJdSourceAndroid: state.session.isJdSourceAndroid,
    imagesBeingUploaded: state.products.imagesBeingUploaded,
    hideLBH,
    hideWeight,
    docId : state.session.docId,
    isAddProductSlider : state.products.isAddProductSlider,
  };
};

export default connect(mapStateToProps, {
  updateEditProductDetail,
  resetSpecErrors,
  showToastMessage: toastMessageActions.showMessage,
  saveAddEditProduct,
  auditorRejection,
  resetProductData,
  hideProductEditSlider,
  getBizList,
  updateBizList,
  updateProductMedia,
  deleteProductImage,
  deleteProductVideo,
  toggleBiz,
  toggleLibrarySlider,
  discardAddProductMedia,
  updateProductStatus,
  getListingData,
  setAuditObject,
  restoreProductData,
  updateDeletionPending,
  updateApprovalPending,
  setTabStatus,
  updateBrandedProduct,
  fetchCountryCode,
  showItemSearchSlider,
  fetchSpecificationAttributes,
  resetSpecificationFormData,
  updateBrandManufactureDetails,
  setBrandSuggestion,
  updateSpecificationData,
  resetBrandManufactureData,
  setHybridData,
  resetVariantData,
  validateVariants,
  validateVariantsService,
  setVariantProductData,
  getAuditProductUpdateLog,
  addRemoveSpecVariant,
  setShouldRetainScroll,
  addUpdateFixedSpecs,
  setVariantData,
  checkAndReset,
  convertRetainSpecs,
  getAllJdCatCoverData,
  updateDescType,
  getPsvDetails,
})(AddEditProductOmni);
